<template>
  <div class="home">
    <b-container fluid>
      <b-row no-gutters class="minus-gutters">
        <b-col>
          <div class="loading" v-show="isLoading">
            <b-spinner variant="success" label="Spinning"></b-spinner>
          </div>
          <div class="gis-basic">
            <div id="map"></div>
            <div id="legend" class="legend" v-show="legendShow">
              <div style="text-align: right; width: 100%">
                <b-avatar
                  button
                  @click="legendShow = !legendShow"
                  size="1rem"
                  variant="dark"
                  text="X"
                  class="align-baseline"
                ></b-avatar>
              </div>
              <h4>
                <b-icon-exclamation-circle></b-icon-exclamation-circle>圖例說明
              </h4>
              <b-container class="bv-example-row">
                <b-row cols="4">
                  <b-col class="m-125" v-show="isFoodItemSelected">
                    <div
                      class="unit planting-ratio-info red"
                      id="colorcard_disaster"
                    >
                      <p class="info">農作物氣象預警<br />種植面積<br />公頃</p>
                      <div id="colorcard_disaster_1">
                        {{ Math.round(this.cityHeight * 10) / 10
                        }}<span class="color Level-1"></span>
                      </div>
                      <div id="colorcard_disaster_2">
                        {{ Math.round((this.cityHeight / 5) * 4 * 10) / 10
                        }}<span class="color Level-2"></span>
                      </div>
                      <div id="colorcard_disaster_3">
                        {{ Math.round((this.cityHeight / 5) * 3 * 10) / 10
                        }}<span class="color Level-3"></span>
                      </div>
                      <div id="colorcard_disaster_4">
                        {{ Math.round((this.cityHeight / 5) * 2 * 10) / 10
                        }}<span class="color Level-4"></span>
                      </div>
                      <div id="colorcard_disaster_5">
                        {{ Math.round((this.cityHeight / 5) * 10) / 10
                        }}<span class="color Level-5"></span>
                      </div>
                    </div>
                  </b-col>
                  <b-col class="m-125" v-show="cropInfoShow">
                    <div
                      class="unit planting-ratio-info green"
                      id="colorcard_area"
                    >
                      <p class="info">農情作物<br />種植面積<br />公頃</p>
                      <div id="colorcard_area_1">
                        {{ Math.round(this.cropArea.HEIGHT_AREA * 10) / 10 || 0
                        }}<span class="color Level-1"></span>
                      </div>
                      <div id="colorcard_area_2">
                        {{
                          Math.round((this.cropArea.HEIGHT_AREA / 5) * 4 * 10) /
                            10 || 0
                        }}<span class="color Level-2"></span>
                      </div>
                      <div id="colorcard_area_3">
                        {{
                          Math.round((this.cropArea.HEIGHT_AREA / 5) * 3 * 10) /
                            10 || 0
                        }}<span class="color Level-3"></span>
                      </div>
                      <div id="colorcard_area_4">
                        {{
                          Math.round((this.cropArea.HEIGHT_AREA / 5) * 2 * 10) /
                            10 || 0
                        }}<span class="color Level-4"></span>
                      </div>
                      <div id="colorcard_area_5">
                        {{
                          Math.round((this.cropArea.HEIGHT_AREA / 5) * 1 * 10) /
                            10 || 0
                        }}<span class="color Level-5"></span>
                      </div>
                    </div>
                  </b-col>                
                  <b-col class="m-125" v-show="tradeWarningShow">
                    <div
                      class="unit planting-ratio-info yellow"
                      id="colorcard_disaster"
                    >
                      <p class="info">種植面積<br />公頃</p>
                      <div id="colorcard_disaster_1">
                        {{
                          Math.round(this.tradeWarningArea.HEIGHT_AREA * 10) /
                            10
                        }}<span class="color Level-1"></span>
                      </div>
                      <div id="colorcard_disaster_2">
                        {{
                          Math.round(
                            (this.tradeWarningArea.HEIGHT_AREA / 5) * 4 * 10
                          ) / 10
                        }}<span class="color Level-2"></span>
                      </div>
                      <div id="colorcard_disaster_3">
                        {{
                          Math.round(
                            (this.tradeWarningArea.HEIGHT_AREA / 5) * 3 * 10
                          ) / 10
                        }}<span class="color Level-3"></span>
                      </div>
                      <div id="colorcard_disaster_4">
                        {{
                          Math.round(
                            (this.tradeWarningArea.HEIGHT_AREA / 5) * 2 * 10
                          ) / 10
                        }}<span class="color Level-4"></span>
                      </div>
                      <div id="colorcard_disaster_5">
                        {{
                          Math.round(
                            (this.tradeWarningArea.HEIGHT_AREA / 5) * 10
                          ) / 10
                        }}<span class="color Level-5"></span>
                      </div>
                    </div>
                  </b-col>
                  <b-col class="m-125" v-show="raingaugeCheck || rainCheck">
                    <div class="unit gis-rainfall" id="raining_color">
                      <p class="info">累計雨量<br />毫米 mm</p>
                      <div><span class="color Level-17"></span></div>
                      <div>300<span class="color Level-16"></span></div>
                      <div>200<span class="color Level-15"></span></div>
                      <div>150<span class="color Level-14"></span></div>
                      <div>130<span class="color Level-13"></span></div>
                      <div>110<span class="color Level-12"></span></div>
                      <div>90<span class="color Level-11"></span></div>
                      <div>70<span class="color Level-10"></span></div>
                      <div>50<span class="color Level-9"></span></div>
                      <div>40<span class="color Level-8"></span></div>
                      <div>30<span class="color Level-7"></span></div>
                      <div>20<span class="color Level-6"></span></div>
                      <div>15<span class="color Level-5"></span></div>
                      <div>10<span class="color Level-4"></span></div>
                      <div>6<span class="color Level-3"></span></div>
                      <div>2<span class="color Level-2"></span></div>
                      <div>1<span class="color Level-1"></span></div>
                    </div>
                  </b-col>
                  <b-col class="m-125" v-show="radarCheck">
                    <div class="unit gis-echo" id="radar_color">
                      <p class="info">回波圖<br />dBZ</p>
                      <div><span class="color echo-75"></span></div>
                      <div>70<span class="color echo-70"></span></div>
                      <div>65<span class="color echo-65"></span></div>
                      <div>60<span class="color echo-60"></span></div>
                      <div>55<span class="color echo-55"></span></div>
                      <div>50<span class="color echo-50"></span></div>
                      <div>45<span class="color echo-45"></span></div>
                      <div>40<span class="color echo-40"></span></div>
                      <div>35<span class="color echo-35"></span></div>
                      <div>30<span class="color echo-30"></span></div>
                      <div>25<span class="color echo-25"></span></div>
                      <div>20<span class="color echo-20"></span></div>
                      <div>15<span class="color echo-15"></span></div>
                      <div>10<span class="color echo-10"></span></div>
                      <div>5<span class="color echo-5"></span></div>
                      <div>0<span class="color echo-0"></span></div>
                      <div>-5<span class="color echo--5"></span></div>
                    </div>
                  </b-col>
                </b-row>
                <div v-show="pestsAndDiseases2.ifPDWindowShow"
                  class="ear-125"
                  >
                  <p class="ear-info">葉稻熱病各罹病度標準警示燈號說明：</p>
                  <span>以目視法取該田區之平均值即為該區之葉病斑面積率。葉病斑面積率=(病斑面積/總葉面積) ×100%</span><br />
                  <br />
                  <ul class="list-unstyled">
                    <li><b-icon icon="circle" class="mr-1"></b-icon>0級：葉病斑面積率為0%</li>
                    <li><b-icon icon="circle-fill" variant="success" class="mr-1"></b-icon>1級：葉病斑面積率&lt;5%</li>
                    <li><b-icon icon="circle-fill" class="mr-1 second-degree"></b-icon>2級：5% ≦葉病斑面積率&lt;11%</li>
                    <li><b-icon icon="circle-fill" variant="warning" class="mr-1"></b-icon>3級：11% ≦葉病斑面積率&lt;55%</li>
                    <li><b-icon icon="circle-fill" variant="danger" class="mr-1"></b-icon>4級：葉病斑面積率 ≧55%</li>
                  </ul>
                </div>
                <div v-show="pestsAndDiseases2.ifPDWindowShow_ear"
                  class="ear-125"
                  >
                  <p class="ear-info">穗稻熱病各罹病度標準警示燈號說明：</p>
                  <span>以目視法調查罹病穗數，以叢為單位，1穗中有3枝梗以上，或約1/5以上梗罹病者視為罹病穗，取該區田區之平均值即為該區之罹病穗率。罹病穗率=(罹病穗數/調查總穗數) ×100%</span><br />
                  <br />
                  <ul class="list-unstyled">
                    <li><b-icon icon="circle" class="mr-1"></b-icon>0級：罹病穗率為0%</li>
                    <li><b-icon icon="circle-fill" variant="success" class="mr-1"></b-icon>1級：罹病穗率&lt;5%</li>
                    <li><b-icon icon="circle-fill" class="mr-1 second-degree"></b-icon>2級：5% ≦罹病穗率&lt;20%</li>
                    <li><b-icon icon="circle-fill" variant="danger" class="mr-1"></b-icon>3級：罹病穗率 ≧20%</li>
                  </ul>
                </div>
              </b-container>
            </div>
            <div class="gis-control">
              <b-button-group>
                <b-button
                  v-b-tooltip.hover.top
                  title="放大"
                  @click="customZoom('plus')"
                >
                  <b-icon-zoom-in></b-icon-zoom-in>
                </b-button>
                <b-button
                  v-b-tooltip.hover.top
                  title="縮小"
                  @click="customZoom('minus')"
                >
                  <b-icon-zoom-out></b-icon-zoom-out>
                </b-button>
                <b-button
                  v-b-tooltip.hover.top
                  title="定位嘉義"
                  @click="toPosition"
                >
                  <b-icon-geo-alt></b-icon-geo-alt>
                </b-button>
                <b-button
                  v-b-tooltip.hover.top
                  title="圖例"
                  @click="legendShow = !legendShow"
                >
                  <b-icon-exclamation-circle></b-icon-exclamation-circle>
                </b-button>
                <b-button
                  id="popover-map-option"
                  v-b-tooltip.hover.top
                  title="底圖"
                >
                  <b-icon-map></b-icon-map>
                </b-button>
                <b-popover
                  target="popover-map-option"
                  triggers="click"
                  placement="top"
                >
                  <template #title></template>
                  <b-form-radio
                    v-model="mapselected"
                    name="some-radios"
                    value="EMAPX99"
                    @change="changeMap"
                    >臺灣通用電子地圖(不含等高線及門牌)</b-form-radio
                  >
                  <b-form-radio
                    v-model="mapselected"
                    name="some-radios"
                    value="PHOTO2"
                    @change="changeMap"
                    >正射影像圖(通用)</b-form-radio
                  >
                  <b-form-radio
                    v-model="mapselected"
                    name="some-radios"
                    value="EMAP9"
                    @change="changeMap"
                    >臺灣通用電子地圖(無鐵公路)</b-form-radio
                  >
                </b-popover>
                <b-button
                  v-b-tooltip.hover.top
                  title="圖台資訊"
                  @click="informationshow = !informationshow"
                >
                  <b-icon-window></b-icon-window>
                </b-button>
                <!-- <b-button
                  @click="
                    show = !show;
                    mapResize();
                  "
                  v-b-tooltip.hover.top
                  title="套疊圖層"
                >
                  <b-icon-layers-half></b-icon-layers-half>
                </b-button> -->
              </b-button-group>
            </div>
            <div v-show="informationshow">
              <CropInformationBox
                :foodselected="foodseleted"
                :isFoodItemSelected="isFoodItemSelected"
                :yearList="yearList"
                :yearPeroidList="yearPeroidList"
                :AREA_P="AREA_P"
                :warningTownName="warningTownName"
                :warningValueList="warningValueList"
                :historyLists="historyLists"
                :infoheight="infoheight"
                :returnChartobj="returnChartobj"
                :gisobject="gisobject"
                :cropArea="cropArea"
                :geoselect="geoselect"
                :cropInfoShow="cropInfoShow"
                :ifPDWindowShow="pestsAndDiseases2.ifPDWindowShow"
                :ifPDWindowShow_ear="pestsAndDiseases2.ifPDWindowShow_ear"
                :PDobject="pestsAndDiseases2.PDobject2"
                :geotabs="geotabs"
                :cropInfo="cropInfo3"
                :SectInfo="SectInfo"
                :SectSubInfo="SectSubInfo"
              />
            </div>
            <b-button
              class="submenuBtn"
              @click="ifshowsidebar = !ifshowsidebar"
              v-b-tooltip.hover.left
              title="套疊圖層"
              ><b-icon-layers-half></b-icon-layers-half
            ></b-button>
            <b-sidebar
              v-model="ifshowsidebar"
              id="sidebar-backdrop"
              backdrop
              right
              shadow
            >
              <div>
                <div class="submenu" v-show="show">
                  <b-tabs v-model="tabselected" pills card class="gis-menu">
                    <b-tab title="農作物氣象預警"
                      v-model="tabselected"
                      @click="mapResize()"
                      active
                      >
                      <template #title>
                        <span class="icon icon-caution-sign" />
                      </template>

                      <template
                        ><h2 class="subtitle">農作物氣象預警</h2></template
                      >
                      <b-tabs
                        pills
                        content-class="mt-3"
                        align="center"
                        justified
                      >
                        <b-tab title="嘉義預警" active
                          ><p></p>
                          <div
                            style="text-align: center"
                            v-show="ifwarningdataloading"
                          >
                            <b-col
                              ><b-spinner
                                variant="success"
                                label="Spinning"
                              ></b-spinner
                            ></b-col>
                          </div>
                          <div v-show="!ifwarningdataloading">
                            <b-card-text v-show="isTyphoonShow" id="anchor_4">
                              <b-list-group class="warninglist">
                                <b-list-group-item variant="danger">
                                  <b-icon
                                    icon="exclamation-circle-fill"
                                    animation="throb"
                                    font-scale="2"
                                    variant="danger"
                                  ></b-icon>
                                  <span class="warninglabel">颱風警戒</span>
                                </b-list-group-item>
                              </b-list-group>
                              <div class="warningReminderClass">
                                ※該縣市發布陸上颱風警報
                              </div>
                              <b-form-radio-group
                                v-model="selected"
                                :options="typhoonWarnOptions"
                                @change="radioSelectedChange"
                                stacked
                              >
                              </b-form-radio-group>
                              <hr />
                            </b-card-text>
                            <b-card-text v-show="isFoehnShow" id="anchor_2">
                              <b-list-group class="warninglist">
                                <b-list-group-item variant="danger">
                                  <b-icon
                                    icon="exclamation-circle-fill"
                                    animation="throb"
                                    font-scale="2"
                                    variant="danger"
                                  ></b-icon>
                                  <span class="warninglabel">焚風警戒</span>
                                </b-list-group-item>
                              </b-list-group>
                              <div class="warningReminderClass">
                                ※該作物分布鄉鎮測站相對濕度比前一小時減少10%以上，溫度增加一度以上，且溫度>34℃，相對濕度&lt;54%
                              </div>
                              <b-form-radio-group
                                v-model="selected"
                                :options="foehnWarnOptions"
                                @change="radioSelectedChange"
                                stacked
                              >
                              </b-form-radio-group>
                              <hr />
                            </b-card-text>
                            <b-card-text v-show="isPrecipitation" id="anchor_3">
                              <b-list-group class="warninglist">
                                <b-list-group-item variant="danger">
                                  <b-icon
                                    icon="exclamation-circle-fill"
                                    animation="throb"
                                    font-scale="2"
                                    variant="danger"
                                  ></b-icon>
                                  <span class="warninglabel">{{ checkMomth(1) }}</span>
                                </b-list-group-item>
                              </b-list-group>
                              <div class="warningReminderClass">
                                ※以自動氣象站及自動雨量站分析，分別計算該作物分布鄉鎮各測站律定時間累積雨量，判斷是否達到門檻值
                              </div>
                              <b-form-radio-group
                                v-model="selected"
                                :options="precipitationWarnOptions"
                                @change="radioSelectedChange"
                                stacked
                              >
                              </b-form-radio-group>
                              <hr />
                            </b-card-text>
                            <b-card-text v-show="isHightempture" id="anchor_1">
                              <b-list-group class="warninglist">
                                <b-list-group-item variant="danger">
                                  <b-icon
                                    icon="exclamation-circle-fill"
                                    animation="throb"
                                    font-scale="2"
                                    variant="danger"
                                  ></b-icon>
                                  <span class="warninglabel">高溫警戒</span>
                                </b-list-group-item>
                              </b-list-group>
                              <div class="warningReminderClass">
                                ※以自動氣象站分析，分別計算該作物分布鄉鎮之各測站律定時間均溫，判斷是否達到門檻值
                              </div>
                              <b-form-radio-group
                                v-model="selected"
                                :options="hightemptureWarnOptions"
                                @change="radioSelectedChange"
                                stacked
                              >
                              </b-form-radio-group>
                              <hr />
                            </b-card-text>
                            <b-card-text v-show="isColdinjury" id="anchor_11">
                              <b-list-group class="warninglist">
                                <b-list-group-item variant="danger">
                                  <b-icon
                                    icon="exclamation-circle-fill"
                                    animation="throb"
                                    font-scale="2"
                                    variant="danger"
                                  ></b-icon>
                                  <span class="warninglabel">寒害警戒</span>
                                </b-list-group-item>
                              </b-list-group>
                              <div class="warningReminderClass">
                                ※該作物分布鄉鎮有任一均溫(日/夜)預報達到門檻
                              </div>
                              <b-form-radio-group
                                v-model="selected"
                                :options="coldinjuryWarnOptions"
                                @change="radioSelectedChange"
                                stacked
                              >
                              </b-form-radio-group>
                              <hr />
                            </b-card-text>
                            <b-card-text v-show="isExcessiverain" id="anchor_0">
                              <b-list-group class="warninglist">
                                <b-list-group-item variant="warning">
                                  <b-icon
                                    icon="exclamation-triangle"
                                    font-scale="2"
                                    variant="warning"
                                  ></b-icon>
                                  <span class="warninglabel">{{
                                    checkMomth(0)
                                  }}</span>
                                </b-list-group-item>
                              </b-list-group>
                              <div class="warningReminderClass">
                                ※該作物分布鄉鎮有水災告警條件，且連續3個時段有降雨可能即觸發
                              </div>
                              <b-form-radio-group
                                v-model="selected"
                                :options="excessiverainNoticeOptions"
                                @change="radioSelectedChange"
                                stacked
                              >
                              </b-form-radio-group>
                              <hr />
                            </b-card-text>
                            <b-card-text v-show="isHightemptureNotice" id="anchor_9">
                              <b-list-group class="warninglist">
                                <b-list-group-item variant="warning">
                                  <b-icon
                                    icon="exclamation-triangle"
                                    font-scale="2"
                                    variant="warning"
                                  ></b-icon>
                                  <span class="warninglabel">注意高溫</span>
                                </b-list-group-item>
                              </b-list-group>
                              <div class="warningReminderClass">
                                ※該作物分布鄉鎮有任一均溫(日/夜)預報達到門檻
                              </div>
                              <b-form-radio-group
                                v-model="selected"
                                :options="hightemptureNoticeOptions"
                                @change="radioSelectedChange"
                                stacked
                              >
                              </b-form-radio-group>
                              <hr />
                            </b-card-text>
                            <b-card-text v-show="isColdinjuryNotice" id="anchor_10">
                              <b-list-group class="warninglist">
                                <b-list-group-item variant="warning">
                                  <b-icon
                                    icon="exclamation-triangle"
                                    font-scale="2"
                                    variant="warning"
                                  ></b-icon>
                                  <span class="warninglabel">注意寒害</span>
                                </b-list-group-item>
                              </b-list-group>
                              <div class="warningReminderClass">
                                ※該作物分布鄉鎮有任一均溫(日/夜)預報達到門檻
                              </div>
                              <b-form-radio-group
                                v-model="selected"
                                :options="coldinjuryNoticeOptions"
                                @change="radioSelectedChange"
                                stacked
                              >
                              </b-form-radio-group>
                              <hr />
                            </b-card-text>
                            <b-card-text v-show="isWarmupNotice" id="anchor_5">
                              <b-list-group class="warninglist">
                                <b-list-group-item variant="warning">
                                  <b-icon
                                    icon="exclamation-triangle"
                                    font-scale="2"
                                    variant="warning"
                                  ></b-icon>
                                  <span class="warninglabel">注意回溫</span>
                                </b-list-group-item>
                              </b-list-group>
                              <div class="warningReminderClass">
                                ※該作物分布鄉鎮白天均溫預報高/低於前一天
                              </div>
                              <b-form-radio-group
                                v-model="selected"
                                :options="warmupNoticeOptions"
                                @change="radioSelectedChange"
                                stacked
                              >
                              </b-form-radio-group>
                              <hr />
                            </b-card-text>
                            <b-card-text v-show="isCooldownNotice" id="anchor_6">
                              <b-list-group class="warninglist">
                                <b-list-group-item variant="warning">
                                  <b-icon
                                    icon="exclamation-triangle"
                                    font-scale="2"
                                    variant="warning"
                                  ></b-icon>
                                  <span class="warninglabel">注意降溫</span>
                                </b-list-group-item>
                              </b-list-group>
                              <div class="warningReminderClass">
                                ※該作物分布鄉鎮白天均溫預報高/低於前一天
                              </div>
                              <b-form-radio-group
                                v-model="selected"
                                :options="cooldownNoticeOptions"
                                @change="radioSelectedChange"
                                stacked
                              >
                              </b-form-radio-group>
                              <hr />
                            </b-card-text>
                            <b-card-text style="color: red">
                              <div>
                                ※注意告警為【黃】，係以氣象局鄉鎮7天預報每0/6/12/18時分析
                              </div>
                              <div>※警戒告警為【紅】，係以每小時分析</div>
                              <div>※倘該鄉鎮無測站則以鄰近鄉鎮替代測站代表</div>
                            </b-card-text>
                          </div>
                        </b-tab>
                        <b-tab title="全國預警"
                          ><p></p>
                          <div
                            style="text-align: center"
                            v-if="ifwarningdataloadingAll"
                          >
                            <b-col
                              ><b-spinner
                                variant="success"
                                label="Spinning"
                              ></b-spinner
                            ></b-col>
                          </div>
                          <div v-else>
                            <b-card-text v-show="isTyphoonShowAll">
                              <b-list-group class="warninglist">
                                <b-list-group-item variant="danger">
                                  <b-icon
                                    icon="exclamation-circle-fill"
                                    animation="throb"
                                    font-scale="2"
                                    variant="danger"
                                  ></b-icon>
                                  <span class="warninglabel">颱風警戒</span>
                                </b-list-group-item>
                              </b-list-group>
                              <div class="warningReminderClass">
                                ※該縣市發布陸上颱風警報
                              </div>
                              <b-form-radio-group
                                v-model="selected"
                                :options="typhoonWarnOptionsAll"
                                @change="radioSelectedAllChange"
                                stacked
                              >
                              </b-form-radio-group>
                              <hr />
                            </b-card-text>
                            <b-card-text v-show="isPrecipitationAll">
                              <b-list-group class="warninglist">
                                <b-list-group-item variant="danger">
                                  <b-icon
                                    icon="exclamation-circle-fill"
                                    animation="throb"
                                    font-scale="2"
                                    variant="danger"
                                  ></b-icon>
                                  <span class="warninglabel">{{checkMomth(1)}}</span>
                                </b-list-group-item>
                              </b-list-group>
                              <div class="warningReminderClass">
                                ※以自動氣象站及自動雨量站分析，分別計算該作物分布鄉鎮各測站律定時間累積雨量，判斷是否達到門檻值
                              </div>
                              <b-form-radio-group
                                v-model="selected"
                                :options="precipitationWarnOptionsAll"
                                @change="radioSelectedAllChange"
                                stacked
                              >
                              </b-form-radio-group>
                              <hr />
                            </b-card-text>
                            <b-card-text v-show="isHightemptureAll">
                              <b-list-group class="warninglist">
                                <b-list-group-item variant="danger">
                                  <b-icon
                                    icon="exclamation-circle-fill"
                                    animation="throb"
                                    font-scale="2"
                                    variant="danger"
                                  ></b-icon>
                                  <span class="warninglabel">高溫警戒</span>
                                </b-list-group-item>
                              </b-list-group>
                              <div class="warningReminderClass">
                                ※以自動氣象站分析，分別計算該作物分布鄉鎮之各測站律定時間均溫，判斷是否達到門檻值
                              </div>
                              <b-form-radio-group
                                v-model="selected"
                                :options="hightemptureNoticeOptionsAll"
                                @change="radioSelectedAllChange"
                                stacked
                              >
                              </b-form-radio-group>
                              <hr />
                            </b-card-text>
                            <b-card-text v-show="isColdinjuryAll">
                              <b-list-group class="warninglist">
                                <b-list-group-item variant="danger">
                                  <b-icon
                                    icon="exclamation-circle-fill"
                                    animation="throb"
                                    font-scale="2"
                                    variant="danger"
                                  ></b-icon>
                                  <span class="warninglabel">寒害警戒</span>
                                </b-list-group-item>
                              </b-list-group>
                              <div class="warningReminderClass">
                                ※該作物分布鄉鎮有任一均溫(日/夜)預報達到門檻
                              </div>
                              <b-form-radio-group
                                v-model="selected"
                                :options="coldinjuryWarnOptionsAll"
                                @change="radioSelectedAllChange"
                                stacked
                              >
                              </b-form-radio-group>
                              <hr />
                            </b-card-text>
                            <b-card-text v-show="isExcessiverainAll" >
                              <b-list-group class="warninglist">
                                <b-list-group-item variant="warning">
                                  <b-icon
                                    icon="exclamation-triangle"
                                    font-scale="2"
                                    variant="warning"
                                  ></b-icon>
                                  <span class="warninglabel">{{
                                    checkMomth(0)
                                  }}</span>
                                </b-list-group-item>
                              </b-list-group>
                              <div class="warningReminderClass">
                                ※該作物分布鄉鎮有水災告警條件，且連續3個時段有降雨可能即觸發
                              </div>
                              <b-form-radio-group
                                v-model="selected"
                                :options="excessiverainNoticeOptionsAll"
                                @change="radioSelectedAllChange"
                                stacked
                              >
                              </b-form-radio-group>
                              <hr />
                            </b-card-text>
                            <b-card-text v-show="isHightemptureNoticeAll">
                              <b-list-group class="warninglist">
                                <b-list-group-item variant="warning">
                                  <b-icon
                                    icon="exclamation-triangle"
                                    font-scale="2"
                                    variant="warning"
                                  ></b-icon>
                                  <span class="warninglabel">注意高溫</span>
                                </b-list-group-item>
                              </b-list-group>
                              <div class="warningReminderClass">
                                ※該作物分布鄉鎮有任一均溫(日/夜)預報達到門檻
                              </div>
                              <b-form-radio-group
                                v-model="selected"
                                :options="hightemptureNoticeOptionsAll"
                                @change="radioSelectedAllChange"
                                stacked
                              >
                              </b-form-radio-group>
                              <hr />
                            </b-card-text>
                            <b-card-text v-show="isColdinjuryNoticeAll">
                              <b-list-group class="warninglist">
                                <b-list-group-item variant="warning">
                                  <b-icon
                                    icon="exclamation-triangle"
                                    font-scale="2"
                                    variant="warning"
                                  ></b-icon>
                                  <span class="warninglabel">注意寒害</span>
                                </b-list-group-item>
                              </b-list-group>
                              <div class="warningReminderClass">
                                ※該作物分布鄉鎮有任一均溫(日/夜)預報達到門檻
                              </div>
                              <b-form-radio-group
                                v-model="selected"
                                :options="coldinjuryNoticeOptionsAll"
                                @change="radioSelectedAllChange"
                                stacked
                              >
                              </b-form-radio-group>
                              <hr />
                            </b-card-text>
                            <b-card-text v-show="isWarmupNoticeAll">
                              <b-list-group class="warninglist">
                                <b-list-group-item variant="warning">
                                  <b-icon
                                    icon="exclamation-triangle"
                                    font-scale="2"
                                    variant="warning"
                                  ></b-icon>
                                  <span class="warninglabel" >注意回溫</span>
                                </b-list-group-item>
                              </b-list-group>
                              <div class="warningReminderClass">
                                ※該作物分布鄉鎮白天均溫預報高/低於前一天
                              </div>
                              <b-form-radio-group
                                v-model="selected"
                                :options="warmupNoticeOptionsAll"
                                @change="radioSelectedAllChange"
                                stacked
                              >
                              </b-form-radio-group>
                              <hr />
                            </b-card-text>
                            <b-card-text v-show="isCooldownNoticeAll">
                              <b-list-group class="warninglist">
                                <b-list-group-item variant="warning">
                                  <b-icon
                                    icon="exclamation-triangle"
                                    font-scale="2"
                                    variant="warning"
                                  ></b-icon>
                                  <span class="warninglabel">注意降溫</span>
                                </b-list-group-item>
                              </b-list-group>
                              <div class="warningReminderClass">
                                ※該作物分布鄉鎮白天均溫預報高/低於前一天
                              </div>
                              <b-form-radio-group
                                v-model="selected"
                                :options="cooldownNoticeOptionsAll"
                                @change="radioSelectedAllChange"
                                stacked
                              >
                              </b-form-radio-group>
                              <hr />
                            </b-card-text>
                            <b-card-text style="color: red">
                              <div>
                                ※注意告警為【黃】，係以氣象局鄉鎮7天預報每0/6/12/18時分析
                              </div>
                              <div>※警戒告警為【紅】，係以每小時分析</div>
                              <div>※倘該鄉鎮無測站則以鄰近鄉鎮替代測站代表</div>
                            </b-card-text>
                          </div>
                        </b-tab>
                      </b-tabs>
                    </b-tab>
                    
                    <b-tab title="農情作物查詢" @click="mapResize()">
                      <template #title>
                        <span class="icon icon-crop_search" />
                      </template>

                      <template
                        ><h2 class="subtitle">農情作物查詢</h2></template
                      >
                      <b-tabs
                        v-model="geotabs"
                        pills
                        content-class="mt-3"
                        align="center"
                        justified
                        >
                        <b-tab title="嘉義農情" active
                          ><p></p>
                          <div>
                            <b-card-text>
                              <v-select
                                v-model="CYcropSelected"
                                :options="CY_croplist"
                                size="sm"
                                class="mb-2"
                                @input="changeCYCropYear"
                              ></v-select>
                              <b-form-select
                                v-model="CYyearSelected"
                                :options="CYyearList"
                                size="sm"
                                class="mb-2"
                                @change="changeCropPeriod()"
                              ></b-form-select>
                              <b-form-select
                                v-model="CYperiodSelected"
                                :options="CYperiodList"
                                size="sm"
                                class="mb-2"
                              ></b-form-select>
                              <b-button
                                block
                                style="background-color: #4f8321"
                                @click="toGetCYCropArea"
                                :disabled="ifGeoSelection"
                                >加入</b-button
                              >
                              <b-card
                                class="mt-3"
                                v-for="(item, index) in addCYAreaLayer"
                                :key="item.year + item.period + item.crop"
                                >
                                <template #header>
                                  <b-form-radio
                                    v-model="rodisValue"
                                    name="area-radios"
                                    @change="changeCYRadio(item,index)"
                                    :value="
                                      item.year +
                                        '_' +
                                        item.period +
                                        '_' +
                                        item.crop
                                    "
                                  >
                                    {{ item.crop }}
                                  </b-form-radio>
                                </template>
                                <b-card-text
                                  >{{ item.year }}
                                  {{ item.period }}
                                  <b-button
                                    href="#"
                                    variant="danger"
                                    size="sm"
                                    @click="removeCYItem(index)"
                                    >移除項目</b-button
                                  ></b-card-text
                                >
                                <b-container>
                                  <!-- <b-row style="margin-bottom: 15px;">
                                    <b-col>
                                      <b-form-select
                                        v-model="townSelect"
                                        :options="townList2"
                                      ></b-form-select>
                                    </b-col>
                                  </b-row> -->
                                  <b-row v-if="item.show">
                                    <b-col lg="6">
                                      <label class="choose-box box">
                                        <b-checkbox
                                          v-model="ifalltownselect"
                                          value="全選"
                                          class="d-inline"
                                        ></b-checkbox>
                                        全選
                                      </label>
                                    </b-col>
                                    <b-col
                                      lg="6"
                                      v-for="(item, index) in townList"
                                      :key="index"
                                    >
                                      <label class="choose-box box">
                                        <b-checkbox
                                          v-model="townSelect"
                                          :value="item.value"
                                          class="d-inline"
                                        ></b-checkbox>
                                        {{ item.text }}
                                      </label>
                                    </b-col>
                                  </b-row>
                                </b-container> 
                              </b-card>
                              

                              <!-- <b-form-checkbox>圖層名稱</b-form-checkbox>
                        <b-form-checkbox>圖層名稱</b-form-checkbox>
                        <b-form-checkbox>圖層名稱</b-form-checkbox> -->
                            </b-card-text>
                          </div></b-tab
                        >
                        <b-tab title="全國農情"
                          ><p></p>
                          <div>
                            <b-card-text>
                              <b-form-select
                                v-model="yearSelectedAll"
                                :options="yearListAll"
                                size="sm"
                                class="mb-2"
                                @change="toGetCropYear()"
                              ></b-form-select>
                              <b-form-select
                                v-model="periodSelectedAll"
                                :options="periodListAll"
                                size="sm"
                                class="mb-2"
                                @change="changeCropListAll()"
                              ></b-form-select>
                              <v-select
                                v-model="cropSelectedAll"
                                :options="cropListAll"
                                size="sm"
                                class="mb-2"
                              ></v-select>
                              <!-- <b-input-group
                          prepend="面積"
                          append="公頃"
                          class="mb-2"
                          size="sm"
                        >
                          <b-form-input
                            v-model="area"
                            placeholder="面積"
                            type="number"
                            min="0"
                          ></b-form-input>
                        </b-input-group> -->
                              <b-button
                                block
                                style="background-color: #4f8321"
                                @click="toGetCropAreaAll"
                                :disabled="ifGeoSelection"
                                >加入</b-button
                              >
                              <b-card
                                class="mt-3"
                                v-for="(item, index) in addAreaLayerAll"
                                :key="item.year + item.period + item.crop"
                              >
                                <template #header>
                                  <b-form-radio
                                    v-model="rodisValue"
                                    name="area-radios"
                                    @change="changeRadio(item)"
                                    :value="
                                      item.year +
                                        '_' +
                                        item.period +
                                        '_' +
                                        item.crop
                                    "
                                  >
                                    {{ item.crop }}
                                  </b-form-radio>
                                </template>
                                <b-card-text
                                  >{{ item.year }}
                                  {{ item.period }}
                                  <b-button
                                    href="#"
                                    variant="danger"
                                    size="sm"
                                    @click="removeItem(index)"
                                    >移除項目</b-button
                                  >
                                </b-card-text>
                                <b-container>
                                  <b-row style="margin-bottom: 15px;">
                                    <b-col>
                                      <b-form-select
                                        v-model="countrySelect"
                                        :options="countryList"
                                      ></b-form-select>
                                    </b-col>
                                  </b-row>
                                  <b-row v-if="countrySelect.length > 0">
                                    <b-col lg="6">
                                      <label class="choose-box box">
                                        <b-checkbox
                                          v-model="ifallgeoselect"
                                          value="全選"
                                          class="d-inline"
                                        ></b-checkbox>
                                        全選
                                      </label>
                                    </b-col>
                                    <b-col
                                      lg="6"
                                      v-for="(item, index) in geoselectionlist"
                                      :key="index"
                                    >
                                      <label class="choose-box box">
                                        <b-checkbox
                                          v-model="geoselect"
                                          :value="item.value"
                                          class="d-inline"
                                        ></b-checkbox>
                                        {{ item.text }}
                                      </label>
                                    </b-col>
                                  </b-row>
                                </b-container>
                              </b-card>
                              <!-- <b-form-checkbox>圖層名稱</b-form-checkbox>
                        <b-form-checkbox>圖層名稱</b-form-checkbox>
                        <b-form-checkbox>圖層名稱</b-form-checkbox> -->
                            </b-card-text>
                          </div></b-tab
                        >
                      </b-tabs>
                    </b-tab>
                    <!-- <b-tab title="農、林、漁、畜主題圖資" @click="mapResize()">
                      <b-card-text>
                        <b-form-checkbox>圖層名稱</b-form-checkbox>
                        <b-form-checkbox>圖層名稱</b-form-checkbox>
                        <b-form-checkbox>圖層名稱</b-form-checkbox>
                      </b-card-text>
                    </b-tab> -->
                    <!-- <b-tab title="價量預警" @click="mapResize()">
                      <b-card-text>
                        <b-form-radio-group
                          v-model="tradeWarningSelected"
                          :options="tradeWarningOptions"
                          @change="tradeWarningChange"
                          stacked
                        >
                        </b-form-radio-group>
                      </b-card-text>
                    </b-tab> -->
                    <!--  -->
                    <b-tab title="農情圖資" @click="mapResize()">
                      <template #title>
                        <span class="icon icon-profit-analysis"/>
                      </template>
                      <template
                        ><h2 class="subtitle">農情圖資</h2>
                      </template>
                      <b-card-text>
                        <b-form-checkbox
                          v-model="SectCheck"
                          >嘉義縣農情圖資大區坵塊圖</b-form-checkbox
                        >
                        <b-form-checkbox
                          v-model="SectSubCheck"
                          >嘉義縣農情圖資小區坵塊圖</b-form-checkbox
                        >
                        <hr />
                      </b-card-text>
                    </b-tab>

                    <b-tab title="天氣圖資" @click="mapResize()">
                      <template #title>
                        <span class="icon icon-weather_analytics" />
                      </template>

                      <template><h2 class="subtitle">天氣圖資</h2></template>
                      <b-card-text>
                        <b-form-checkbox
                          v-model="radarCheck"
                          @change="showclimate(0)"
                          >即時雷達回波圖</b-form-checkbox
                        >
                        <b-form-checkbox
                          v-model="rainCheck"
                          @change="showclimate(1)"
                          >小間距日累積雨量圖</b-form-checkbox
                        >
                        <b-form-checkbox
                          v-model="raingaugeCheck"
                          @change="showclimate(2)"
                          >即時24小時累積雨量整合雷達回波估計圖</b-form-checkbox
                        >
                        <b-form-checkbox
                          v-model="gdacsCheck"
                          @change="showclimate(3)"
                          >GDACS全球防災告警</b-form-checkbox
                        >
                        <b-form-checkbox
                          v-model="fifowstyphoonCheck"
                          @change="showclimate(4)"
                          >颱風路徑</b-form-checkbox
                        >
                        <hr />
                      </b-card-text>
                      <b-card-text style="color: red">
                        <div>
                          ※即時雷達回波圖：雷達回波與閃電可初步判讀是否可能有發生降雨情形。
                        </div>
                        <div>
                          ※小間距日累積雨量圖：日累積雨量以小時為單位，依據降雨量顏色區間，判讀所在縣市累積雨量為多少。
                        </div>
                        <div>
                          ※即時24小時累積雨量整合雷達回波估計圖：此雨量估計是由氣象局
                          自動雨量站 以及 雷達回波 整合估計技術演算而得。
                        </div>
                        <div>
                          ※GDACS全球防災告警：整合多個國際機構的數據，即時發布自然災害（如地震、海嘯、風暴和洪水）的訊息。
                        </div>
                        <div>
                          ※颱風路徑：顯示颱風的過去移動軌跡和預測的未來路徑。
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab
                      class="gis-tab"
                      title="水稻稻熱病預警"
                      @click="mapResize()"
                    >
                      <template #title>
                        <span class="icon icon-bug_alarm" />
                      </template>

                      <template><h2 class="subtitle">水稻稻熱病預警</h2></template>
                      <!-- 病蟲害(新) -->
                      <div style="text-align: center" v-if="!ifpdget">
                        <b-col
                          ><b-spinner
                            variant="success"
                            label="Spinning"
                          ></b-spinner
                        ></b-col>
                      </div>
                      <div v-else>
                        <b-row style="margin-bottom: 2vh" align-h="around">
                          <b-col cols="6">
                            <b-form-select
                              v-model="pestsAndDiseases2.yearselected"
                              :options="pestsAndDiseases2.yearoptions"
                            ></b-form-select>
                          </b-col>
                          <b-col cols="6">
                            <b-form-select
                              v-model="pestsAndDiseases2.monthselected"
                              :options="pestsAndDiseases2.monthoptions"
                            ></b-form-select>
                          </b-col>
                        </b-row>
                        <template v-if="pestsAndDiseases2.data.length > 0">
                          <b-card-text
                            v-for="(item, key) in pestsAndDiseases2.data"
                            :key="key"
                          >
                            <b-list-group
                              class="warninglist"
                              style="width: fit-content"
                            >
                              <b-list-group-item
                                v-if="item.type == 'danger'"
                                variant="danger"
                              >
                                <b-icon
                                  icon="exclamation-circle-fill"
                                  animation="throb"
                                  font-scale="2"
                                  variant="danger"
                                ></b-icon>
                                <span class="warninglabel">{{
                                  item.date
                                }}</span>
                              </b-list-group-item>
                              <b-list-group-item v-else variant="warning">
                                <b-icon
                                  icon="exclamation-triangle"
                                  font-scale="2"
                                  variant="warning"
                                ></b-icon>
                                <span class="warninglabel">{{
                                  item.date
                                }}</span>
                              </b-list-group-item>
                            </b-list-group>
                            <template v-if="item.type != null">
                              <b-form-radio-group
                                v-model="pestsAndDiseases2.selected"
                                :options="parsepestsAndDiseasesOption(item)"
                                stacked
                              >
                              </b-form-radio-group>
                            </template>
                            <template v-else>
                              <div>無預警資料</div>
                            </template>
                            <hr />
                          </b-card-text>
                        </template>
                        <template v-else>
                          <b-card-text>
                            <h4>查無資料</h4>
                          </b-card-text>
                        </template>
                      </div>
                    </b-tab>
                  </b-tabs>
                </div>
              </div>
            </b-sidebar>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
//import Loading from 'vue-loading-overlay';
import "vue-select/dist/vue-select.css";
// import DragInformationBox from "@/views/DragInformationBox.vue";
// import DragCropInformationBox from "@/views/DragCropInformationBox.vue";
// import DragCropInfoChart from "@/views/DragCropInfoChart.vue";
// import DragPDInformationBox from "@/views/DragPDInformationBox.vue"
import CropInformationBox from "@/views/CropInformationBox.vue";
import "ol/ol.css";
import Map from "ol/Map";
import View from "ol/View";
import {
  Tile as TileLayer,
  Vector as VectorLayer,
  Image as ImageLayer,
} from "ol/layer";
import { XYZ, Vector as VectorSource, ImageStatic as Static } from "ol/source";
import { Select } from "ol/interaction";
import { click } from "ol/events/condition";
import { Fill, Stroke, Style } from "ol/style";
import { fromLonLat, transformExtent } from "ol/proj";
import GeoJSON from "ol/format/GeoJSON";
import KML from "ol/format/KML";
import germlist from "@/data/GERM_LIST.json";
import chiayitownlist from "@/data/CHIAYI_TOWN_LIST.json";
import taiwancountrylist from "@/data/TAIWAN_COUNTRY_LIST.json";
import taiwantownlist from "@/data/TAIWAN_TOWN_LIST.json";
// import { forEach } from 'lodash';

export default {
  name: "Home",
  data() {
    return {
      // <summary>
      //  變數宣告
      // </summary>
      isLoading: false,
      fullPage: true,
      show: true,
      // <summary>
      //  Token變數宣告
      // </summary>
      parmData: [
        {
          TokenID: "string",
          Token: "string",
          Page: "string",
        },
      ],
      accountid: "訪客",
      cyhgagritown:[],
      // <summary>
      //  農作物氣象預警的顯示變數宣告
      // </summary>
      geoselectionlist: [],
      geoselect: [],
      ifgermshow: false,
      ifallgeoselect: [],
      ifallsectselect: [],
      ifselectTrigger: false,
      ifGeoSelection: false,
      geotabs: 0,
      countrySelect: "",
      countryList: [],
      townList:[],
      Selecttownsect:"",
      townSelect:[],
      townsectlist:[],
      nowtownid:"",
      sectList:{},
      sectnameList:[],
      sectSelect:[],
      // geotaiwanselectionlist: [],
      // geoselect: [],
      // ifGeoSelection: false,
      geooriginaltownlist: chiayitownlist,
      gisobject: null,
      tabselected: 0,
      parsetab: this.$route.params.tab,
      isFoodItemSelected: false,
      isTyphoonShow: false,
      isTyphoonShowAll: false,
      isFoehnShow: false,
      isPrecipitation: false,
      isPrecipitationAll: false,
      isHightempture: false,
      isColdinjury: false,
      isExcessiverain: false,
      isExcessiverainAll: false,
      isHightemptureNotice: false,
      isHightemptureNoticeAll: false,
      isColdinjuryNotice: false,
      isColdinjuryNoticeAll: false,
      isWarmupNotice: false,
      isWarmupNoticeAll: false,
      isCooldownNotice: false,
      isCooldownNoticeAll: false,
      ifshowsidebar: false,
      isHightemptureAll: false,
      isColdinjuryAll: false,
      selected: [],
      // <summary>
      //  農作物氣象預警的物件與Radio的選項宣告
      // </summary>
      foodseleted: {},
      foodInjuryAllDate: [],
      foodInjuryAllDateSearch: [],
      foodInjuryTaiwanAllDateSearch: [],
      foodCityList: [],
      foodTaiwanCityList: [],
      foodWarningSearch: [],
      typhoonWarn: [],
      typhoonWarnAll: [],
      typhoonWarnOptions: [],
      typhoonWarnOptionsAll: [],
      foehnWarn: [],
      foehnWarnAll: [],
      foehnWarnOptions: [],
      foehnWarnOptionsAll: [],
      precipitationWarn: [],
      precipitationWarnAll: [],
      precipitationWarnOptions: [],
      precipitationWarnOptionsAll: [],
      hightemptureWarn: [],
      hightemptureWarnAll: [],
      hightemptureWarnOptions: [],
      hightemptureWarnOptionsAll: [],
      coldinjuryWarn: [],
      coldinjuryWarnAll: [],
      coldinjuryWarnOptions: [],
      coldinjuryWarnOptionsAll: [],
      excessiverainNotice: [],
      excessiverainNoticeAll: [],
      excessiverainNoticeOptions: [],
      excessiverainNoticeOptionsAll: [],
      hightemptureNotice: [],
      hightemptureNoticeAll: [],
      hightemptureNoticeOptions: [],
      hightemptureNoticeOptionsAll: [],
      coldinjuryNotice: [],
      coldinjuryNoticeAll: [],
      coldinjuryNoticeOptions: [],
      coldinjuryNoticeOptionsAll: [],
      warmupNotice: [],
      warmupNoticeAll: [],
      warmupNoticeOptions: [],
      warmupNoticeOptionsAll: [],
      cooldownNotice: [],
      cooldownNoticeAll: [],
      cooldownNoticeOptions: [],
      cooldownNoticeOptionsAll: [],
      // <summary>
      //  農情作物查詢物件宣告
      // </summary>
      aa:[],
      yearPeriodList: [],
      yearListAll: [],
      yearSelected: "請選擇年度",
      yearSelectedAll: null,
      periodSelected: "",
      periodSelectedAll: null,
      cropSelected: "請選擇農情作物",
      cropSelectedAll: "請選擇農情作物",
      CYcropSelected:"請選擇農情作物",
      yearList: [],
      periodList: [],
      CY_croplist: ["請選擇農情作物"],
      cropList: ["請選擇農情作物"],
      cropLists: [],
      CYyearSelected: "請選擇年度",
      CYyearList:["請選擇年度"],
      CYperiodSelected: "請選擇期作",
      CYperiodList: ["請選擇期作"],
      cropListsAll: [],
      cropListAll: [],
      ifalltownselect:["全選"],
      ifselectCYTrigger:false,
      area: 0,
      showcheckbox:false,
      map: null,
      cropArea: [],
      CYcropArea: [],
      cropAreaSelected: [],
      warningArea: [],
      areaValue: [],
      cropsectorlist: [],
      nowCrop:"",
      cropInfo: {
        townName: "",
        year: "",
        period: "",
      },
      cropInfo2: {
        ifCropShow: false,
        townName: "",
        sectorName: "",
        cropName: "水稻",
        area_P: "",
        area_I: "",
        area_O: "",
        area_NH: "",
        year: "111",
        period: "一期作",
        yearobj: {
          selected: "",
          lsit: ["111"],
        },
        periodobj: {
          selected: "",
          lsit: ["一期作", "二期作", "裡作"],
        },
      },
      cropInfo3: {
        ifCropShow: false,
        townName: "",
        sectorName: "",
        cropName: "",
        area_situation:"",
        area_P: "",
        area_I: "",
        area_O: "",
        area_NH: "",
        year: "",
        period: "",
      },
      SectInfo:{
        ifSectShow: false,
        townname: "",
        sectname: "",
      },
      SectSubInfo:{
        ifSectSubShow: false,
        townname:"",
        sectname:"",
        sectsubname:"",
      },
      cropInfoShow: false,
      informationshow: true,
      // <summary>
      //  價量預警物件宣告
      // </summary>
      MasecList: [],
      // <summary>
      //  價量預警物件宣告
      // </summary>
      tradeWarningArea: [],
      tradeWarningAreaSelected: [],
      tradeWarningAreaValue: [],
      tradeWarningShow: false,
      tradeWarningSelected: null,
      tradeWarningInfo: {
        townName: "",
        year: "",
        period: "",
      },
      tradeWarningOptions: [],
      tradeWarningList: [],
      //<summary>
      // 病蟲害宣告
      pestsAndDiseases: {
        data: [],
        cropdata: [],
        publishhightestarea: 0,
        unpublishhightestarea: 0,
        year: null,
        month: null,
        alldata: [],
        ifPDWindowShow: false,
        selected: null,
        yearselected: "",
        monthselected: "",
        period: [],
        yearoptions: [],
        monthoptions: [],
        PDobject: {
          subject: null,
          contents: null,
          suggest: null,
          publish: null,
          cropname: null,
          date: null,
          detial: {
            title: null,
            place: null,
            items: [],
          },
        },
      },
      pestsAndDiseases2: {
        data: [],
        cropdata: [],
        publishhightestarea: 0,
        year: null,
        month: null,
        alldata: [],
        ifPDWindowShow: false,
        ifPDWindowShow_ear:false,
        selected: null,
        yearselected: "",
        monthselected: "",
        period: [],
        yearoptions: [],
        monthoptions: [],
        type: null,
        warning_lavel:0,
        fillColor:[0,0,0],
        PDobject: {
          subject: null,
          contents: null,
          suggest: null,
          publish: null,
          cropname: null,
          date: null,
          detial: {
            title: null,
            place: null,
            items: [],
          },
        },
        PDobject2: {
          subject: null,
          contents: null,
          suggest: null,
          publish: null,
          cropname: null,
          date: null,
          detial: {
            title: null,
            place: null,
            items: [],
          },
          weather: [],
        },
      },
      showmanage: {
        accountshow: false,
        iflogin: false,
        dashboard: {
          farmshow: false,
          fishshow: false,
          animalshow: false,
          cropshow: false,
        },
        databuild: {
          farmshow: false,
          fishshow: false,
          animalshow: false,
          cropshow: false,
          pentshow: false,
          farmsearchshow:true
        },
      },
      //</summary>
      // <summary>
      //  底圖物件宣告
      // </summary>
      mapselected: "EMAP9",
      firstClick: true,
      MapLayers: {
        layers: [
          new TileLayer({
            // 臺灣通用電子地圖(不含等高線及門牌)
            visible: false,
            source: new XYZ({
              url:
                "https://wmts.nlsc.gov.tw/wmts/EMAP16/default/EPSG:3857/{z}/{y}/{x}",
            }),
          }),
          new TileLayer({
            // 臺灣通用電子地圖(無鐵公路)
            visible: true,
            source: new XYZ({
              url:
                "https://wmts.nlsc.gov.tw/wmts/EMAP9/default/EPSG:3857/{z}/{y}/{x}",
            }),
          }),
          new TileLayer({
            // 正射影像圖(通用)
            visible: false,
            source: new XYZ({
              url:
                "https://wmts.nlsc.gov.tw/wmts/PHOTO2/default/EPSG:3857/{z}/{y}/{x}",
            }),
          }),
        ],
      },
      //<summary>
      //農情圖資宣告
      //</summary>
      SectSubCheck:false,
      SectCheck:false,
      SelectFillColor:[0, 0, 0, 0],
      selectInteraction:null,
      selectMasecInteraction:null,
      selectgermCYmap:null,
      Selectpercentage:null,
      // <summary>
      //  天氣圖資物件宣告
      // </summary>
      mapForVisible: {
        radar: new ImageLayer({
          // 雷達回波
          visible: false,
          source: new Static({
            url: "WeatherLayers/HDMOS/HDMOS.radar.png",
            imageExtent: transformExtent(
              [115.0, 19.2, 129.22, 27.2],
              "EPSG:4326",
              "EPSG:3857"
            ),
          }),
        }),
        rain: new ImageLayer({
          // 雨量觀測-日累積圖
          visible: false,
          source: new Static({
            url: "WeatherLayers/O-A0040-003/O-A0040-003/0/0/0.png",
            imageExtent: transformExtent(
              [119.188024, 21.523313, 123.578233, 25.918078],
              "EPSG:4326",
              "EPSG:3857"
            ),
          }),
        }),
        raingauge: new VectorLayer({
          // 即時24小時累積雨量整合雷達回波估計圖
          visible: false,
          source: new VectorSource({
            url: "WeatherLayers/raingauge_kridmap/kridmap/base.kml",
            format: new KML(),
          }),
        }),
        gdacs: new VectorLayer({
          // GDACS全球防災告警
          visible: false,
          source: new VectorSource({
            url: "WeatherLayers/gdacs/gdacs.kml",
            format: new KML(),
          }),
        }),
        fifows_typhoon: new VectorLayer({
          // 颱風路徑
          visible: false,
          source: new VectorSource({
            url: "WeatherLayers/W-C0034-002/fifows_typhoon.kml",
            format: new KML(),
          }),
        }),
      },
      MapView: new View({
        center: fromLonLat([120.15, 23.473323877771172]),
        zoom: 10,
        // minZoom: 8,
        // maxZoom: 15,
      }),
      warningMap: new VectorLayer({
        visible: true,
        source: new VectorSource({
          url: "GeoJSON/chayi_3857.geojson",
          format: new GeoJSON(),
        }),
        style: this.styleWarning,
      }),
      germMap: new VectorLayer({
        visible: true,
        source: new VectorSource({
          url: "GeoJSON/123.geojson",
          format: new GeoJSON(),
        }),
        style: this.styleGermFunction,
      }),
      germCYMap: new VectorLayer({
        visible: true,
        source: new VectorSource({
          url: "GeoJSON/AllMasec_3857.geojson",
          format: new GeoJSON(),
        }),
        style: this.styleCYFunction,
      }),
      CYSectMap: new VectorLayer({
        visible: true,
        source: new VectorSource({
          url: "GeoJSON/123.geojson",
          format: new GeoJSON(),
        }),
      }),
      CyhgAgriSectMap: new VectorLayer({
        visible: true,
        source: new VectorSource({
          url: "GeoJSON/123.geojson",
          format: new GeoJSON(),
        }),
      }),
      cropMap: new VectorLayer({
        visible: true,
        source: new VectorSource({
          url: "GeoJSON/chayi_3857.geojson",
          format: new GeoJSON(),
        }),
        style: this.styleFunction,
      }),
      cropMapAll: new VectorLayer({
        visible: true,
        source: new VectorSource({
          url: "GeoJSON/taiwan.geojson",
          format: new GeoJSON(),
        }),
        style: this.styleFunction,
      }),
      tradeWarningMap: new VectorLayer({
        visible: true,
        source: new VectorSource({
          url: "GeoJSON/chayi_3857.geojson",
          format: new GeoJSON(),
        }),
        style: this.styleFunction,
      }),
      pestNoticeWarningMap: new VectorLayer({
        visible: true,
        source: new VectorSource({
          url: "GeoJSON/taiwan.geojson",
          format: new GeoJSON(),
        }),
        style: this.stylePDFunction,
      }),
      pestandDieaseMap: new VectorLayer({
        visible: true,
        source: new VectorSource({
          url: "GeoJSON/chayi_3857.geojson",
          format: new GeoJSON(),
        }),
        style: this.stylePDFunction2,
      }),
      //大區
      SectCheckMap:null,
      //小區
      SectSubCheckMap:null,


      // <summary>
      //  圖資物件宣告
      // </summary>
      ifwarningdataloading: true,
      ifwarningdataloadingAll: true,
      selectClick: null,
      ifpdget: false,
      addAreaLayer: [],
      addCYAreaLayer: [],
      addCYAreaLayerindex:"",
      addAreaLayerAll: [],
      rodisValue: "",
      radioLists: [],
      warningLists: [],
      warningTown: [],
      yearPeroidList: [],
      periodListAll: [],
      AREA_PList: [],
      AREA_P: "",
      AREA_P_ID: "",
      iffirst: true,
      year: null,
      month: null,
      chartobj: null,
      warningTownName: "",
      warningValueList_345: [],
      warningValueList: [],
      radarCheck: false,
      rainCheck: false,
      raingaugeCheck: false,
      gdacsCheck:false,
      fifowstyphoonCheck:false,
      historyLists: [],
      legendShow: false,
      cityHeight: 0,
      infoheight: 600,
      testlist: [
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/25",
            WARNING_RESULT: "無預警資料",
          },
          AGRI_INFO: null,
          WEATHER_INFO: null,
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/15",
            WARNING_RESULT: "無預警資料",
          },
          AGRI_INFO: null,
          WEATHER_INFO: null,
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-葉稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "大林鎮",
            CROP: "水稻",
            AREA_H: 1346.08,
            AREA_P: 1346.08,
            RATE_H: 7575,
            HARVEST: 10197902,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q04",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:00.563",
            SN: 93530,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.6347828,
              H_24R: 0,
              HUMD: 0.683478236,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.2625,
              H_24R: 0,
              HUMD: 0.591666639,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.3142853,
              H_24R: 0,
              HUMD: 0.7157143,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.6125,
              H_24R: 0,
              HUMD: 0.728333354,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.0583324,
              H_24R: 0,
              HUMD: 0.78,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.2125,
              H_24R: 0,
              HUMD: 0.8354167,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.5,
              H_24R: 0,
              HUMD: 0.92,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-穗稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "大林鎮",
            CROP: "水稻",
            AREA_H: 1346.08,
            AREA_P: 1346.08,
            RATE_H: 7575,
            HARVEST: 10197902,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q04",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:00.563",
            SN: 93530,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.6347828,
              H_24R: 0,
              HUMD: 0.683478236,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.2625,
              H_24R: 0,
              HUMD: 0.591666639,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.3142853,
              H_24R: 0,
              HUMD: 0.7157143,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.6125,
              H_24R: 0,
              HUMD: 0.728333354,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.0583324,
              H_24R: 0,
              HUMD: 0.78,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.2125,
              H_24R: 0,
              HUMD: 0.8354167,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.5,
              H_24R: 0,
              HUMD: 0.92,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-葉稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "中埔鄉",
            CROP: "水稻",
            AREA_H: 13.89,
            AREA_P: 13.89,
            RATE_H: 5224,
            HARVEST: 72575,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q14",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:00.787",
            SN: 93531,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.2478256,
              H_24R: 0,
              HUMD: 0.7534783,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 9.6125,
              H_24R: 0,
              HUMD: 0.668333352,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 10.485714,
              H_24R: 0,
              HUMD: 0.7885714,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.2833338,
              H_24R: 0,
              HUMD: 0.733333349,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.2625,
              H_24R: 0,
              HUMD: 0.714166641,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 16.833334,
              H_24R: 0,
              HUMD: 0.80583334,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 15.9,
              H_24R: 0,
              HUMD: 0.93,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-穗稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "中埔鄉",
            CROP: "水稻",
            AREA_H: 13.89,
            AREA_P: 13.89,
            RATE_H: 5224,
            HARVEST: 72575,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q14",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:00.787",
            SN: 93531,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.2478256,
              H_24R: 0,
              HUMD: 0.7534783,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 9.6125,
              H_24R: 0,
              HUMD: 0.668333352,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 10.485714,
              H_24R: 0,
              HUMD: 0.7885714,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.2833338,
              H_24R: 0,
              HUMD: 0.733333349,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.2625,
              H_24R: 0,
              HUMD: 0.714166641,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 16.833334,
              H_24R: 0,
              HUMD: 0.80583334,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 15.9,
              H_24R: 0,
              HUMD: 0.93,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-葉稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "六腳鄉",
            CROP: "水稻",
            AREA_H: 140,
            AREA_P: 140,
            RATE_H: 5538,
            HARVEST: 775320,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q08",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:01.007",
            SN: 93532,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.5826082,
              H_24R: 0,
              HUMD: 0.6730435,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.0583334,
              H_24R: 0,
              HUMD: 0.5875,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.1857147,
              H_24R: 0,
              HUMD: 0.7171429,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.416667,
              H_24R: 0,
              HUMD: 0.7475,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.1416664,
              H_24R: 0,
              HUMD: 0.7995833,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.7583332,
              H_24R: 0,
              HUMD: 0.845,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.4,
              H_24R: 0,
              HUMD: 0.93,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-穗稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "六腳鄉",
            CROP: "水稻",
            AREA_H: 140,
            AREA_P: 140,
            RATE_H: 5538,
            HARVEST: 775320,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q08",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:01.007",
            SN: 93532,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.5826082,
              H_24R: 0,
              HUMD: 0.6730435,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.0583334,
              H_24R: 0,
              HUMD: 0.5875,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.1857147,
              H_24R: 0,
              HUMD: 0.7171429,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.416667,
              H_24R: 0,
              HUMD: 0.7475,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.1416664,
              H_24R: 0,
              HUMD: 0.7995833,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.7583332,
              H_24R: 0,
              HUMD: 0.845,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.4,
              H_24R: 0,
              HUMD: 0.93,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-葉稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "太保市",
            CROP: "水稻",
            AREA_H: 2068.66,
            AREA_P: 2068.66,
            RATE_H: 6528,
            HARVEST: 13505597,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q12",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:01.177",
            SN: 93533,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.96087,
              H_24R: 0,
              HUMD: 0.6808696,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.5130434,
              H_24R: 0,
              HUMD: 0.5856522,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.4071426,
              H_24R: 0,
              HUMD: 0.7214286,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.5375,
              H_24R: 0,
              HUMD: 0.7529167,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.34348,
              H_24R: 0,
              HUMD: 0.8073913,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.75,
              H_24R: 0,
              HUMD: 0.863333344,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.5,
              H_24R: 0,
              HUMD: 0.95,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-穗稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "太保市",
            CROP: "水稻",
            AREA_H: 2068.66,
            AREA_P: 2068.66,
            RATE_H: 6528,
            HARVEST: 13505597,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q12",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:01.177",
            SN: 93533,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.96087,
              H_24R: 0,
              HUMD: 0.6808696,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.5130434,
              H_24R: 0,
              HUMD: 0.5856522,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.4071426,
              H_24R: 0,
              HUMD: 0.7214286,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.5375,
              H_24R: 0,
              HUMD: 0.7529167,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.34348,
              H_24R: 0,
              HUMD: 0.8073913,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.75,
              H_24R: 0,
              HUMD: 0.863333344,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.5,
              H_24R: 0,
              HUMD: 0.95,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-葉稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "水上鄉",
            CROP: "水稻",
            AREA_H: 850,
            AREA_P: 850,
            RATE_H: 6359,
            HARVEST: 5405710,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q13",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:01.33",
            SN: 93534,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.8304348,
              H_24R: 0,
              HUMD: 0.69,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.4083338,
              H_24R: 0,
              HUMD: 0.5779167,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.2071428,
              H_24R: 0,
              HUMD: 0.715,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.4458332,
              H_24R: 0,
              HUMD: 0.745,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.1208324,
              H_24R: 0,
              HUMD: 0.785833359,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.4,
              H_24R: 0,
              HUMD: 0.84625,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.4,
              H_24R: 0,
              HUMD: 0.95,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-穗稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "水上鄉",
            CROP: "水稻",
            AREA_H: 850,
            AREA_P: 850,
            RATE_H: 6359,
            HARVEST: 5405710,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q13",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:01.33",
            SN: 93534,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.8304348,
              H_24R: 0,
              HUMD: 0.69,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.4083338,
              H_24R: 0,
              HUMD: 0.5779167,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.2071428,
              H_24R: 0,
              HUMD: 0.715,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.4458332,
              H_24R: 0,
              HUMD: 0.745,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.1208324,
              H_24R: 0,
              HUMD: 0.785833359,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.4,
              H_24R: 0,
              HUMD: 0.84625,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.4,
              H_24R: 0,
              HUMD: 0.95,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-葉稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "布袋鎮",
            CROP: "水稻",
            AREA_H: 170.08,
            AREA_P: 170.08,
            RATE_H: 5792,
            HARVEST: 985273,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q03",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:01.49",
            SN: 93535,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.8521738,
              H_24R: 0,
              HUMD: 0.679130435,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.3708334,
              H_24R: 0,
              HUMD: 0.564166665,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.6857147,
              H_24R: 0,
              HUMD: 0.687142849,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.8375,
              H_24R: 0,
              HUMD: 0.7216667,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.5375,
              H_24R: 0,
              HUMD: 0.785833359,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.8416672,
              H_24R: 0,
              HUMD: 0.83375,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.6,
              H_24R: 0,
              HUMD: 0.9,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-穗稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "布袋鎮",
            CROP: "水稻",
            AREA_H: 170.08,
            AREA_P: 170.08,
            RATE_H: 5792,
            HARVEST: 985273,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q03",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:01.49",
            SN: 93535,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.8521738,
              H_24R: 0,
              HUMD: 0.679130435,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.3708334,
              H_24R: 0,
              HUMD: 0.564166665,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.6857147,
              H_24R: 0,
              HUMD: 0.687142849,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.8375,
              H_24R: 0,
              HUMD: 0.7216667,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.5375,
              H_24R: 0,
              HUMD: 0.785833359,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.8416672,
              H_24R: 0,
              HUMD: 0.83375,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.6,
              H_24R: 0,
              HUMD: 0.9,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-葉稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "民雄鄉",
            CROP: "水稻",
            AREA_H: 2440,
            AREA_P: 2440,
            RATE_H: 6730,
            HARVEST: 16421200,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q05",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:01.623",
            SN: 93536,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.8304348,
              H_24R: 0,
              HUMD: 0.689565241,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.4625,
              H_24R: 0,
              HUMD: 0.59041667,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.3928576,
              H_24R: 0,
              HUMD: 0.7192857,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.7458334,
              H_24R: 0,
              HUMD: 0.73125,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.225,
              H_24R: 0,
              HUMD: 0.7841667,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.65652,
              H_24R: 0,
              HUMD: 0.8352174,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.6,
              H_24R: 0,
              HUMD: 0.92,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-穗稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "民雄鄉",
            CROP: "水稻",
            AREA_H: 2440,
            AREA_P: 2440,
            RATE_H: 6730,
            HARVEST: 16421200,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q05",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:01.623",
            SN: 93536,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.8304348,
              H_24R: 0,
              HUMD: 0.689565241,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.4625,
              H_24R: 0,
              HUMD: 0.59041667,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.3928576,
              H_24R: 0,
              HUMD: 0.7192857,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.7458334,
              H_24R: 0,
              HUMD: 0.73125,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.225,
              H_24R: 0,
              HUMD: 0.7841667,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.65652,
              H_24R: 0,
              HUMD: 0.8352174,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.6,
              H_24R: 0,
              HUMD: 0.92,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-葉稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "朴子市",
            CROP: "水稻",
            AREA_H: 570,
            AREA_P: 570,
            RATE_H: 6320,
            HARVEST: 3602400,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q02",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:01.767",
            SN: 93537,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.565217,
              H_24R: 0,
              HUMD: 0.69086957,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.166667,
              H_24R: 0,
              HUMD: 0.56375,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.3642855,
              H_24R: 0,
              HUMD: 0.698571444,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.5708332,
              H_24R: 0,
              HUMD: 0.74666667,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.208334,
              H_24R: 0,
              HUMD: 0.83708334,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.775,
              H_24R: 0,
              HUMD: 0.8879167,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.3,
              H_24R: 0,
              HUMD: 0.99,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-穗稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "朴子市",
            CROP: "水稻",
            AREA_H: 570,
            AREA_P: 570,
            RATE_H: 6320,
            HARVEST: 3602400,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q02",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:01.767",
            SN: 93537,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.565217,
              H_24R: 0,
              HUMD: 0.69086957,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.166667,
              H_24R: 0,
              HUMD: 0.56375,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.3642855,
              H_24R: 0,
              HUMD: 0.698571444,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.5708332,
              H_24R: 0,
              HUMD: 0.74666667,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.208334,
              H_24R: 0,
              HUMD: 0.83708334,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.775,
              H_24R: 0,
              HUMD: 0.8879167,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.3,
              H_24R: 0,
              HUMD: 0.99,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-葉稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "東石鄉",
            CROP: "水稻",
            AREA_H: 200,
            AREA_P: 200,
            RATE_H: 5891,
            HARVEST: 1178200,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q09",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:01.937",
            SN: 93538,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.6391306,
              H_24R: 0,
              HUMD: 0.6969565,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.3375,
              H_24R: 0,
              HUMD: 0.567083359,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.6571426,
              H_24R: 0,
              HUMD: 0.681428552,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.8291664,
              H_24R: 0,
              HUMD: 0.73,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.3375,
              H_24R: 0,
              HUMD: 0.8020833,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.625,
              H_24R: 0,
              HUMD: 0.845416665,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.1,
              H_24R: 0,
              HUMD: 0.93,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-穗稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "東石鄉",
            CROP: "水稻",
            AREA_H: 200,
            AREA_P: 200,
            RATE_H: 5891,
            HARVEST: 1178200,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q09",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:01.937",
            SN: 93538,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.6391306,
              H_24R: 0,
              HUMD: 0.6969565,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.3375,
              H_24R: 0,
              HUMD: 0.567083359,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.6571426,
              H_24R: 0,
              HUMD: 0.681428552,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.8291664,
              H_24R: 0,
              HUMD: 0.73,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.3375,
              H_24R: 0,
              HUMD: 0.8020833,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.625,
              H_24R: 0,
              HUMD: 0.845416665,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.1,
              H_24R: 0,
              HUMD: 0.93,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-葉稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "鹿草鄉",
            CROP: "水稻",
            AREA_H: 1700,
            AREA_P: 1700,
            RATE_H: 6576,
            HARVEST: 11179200,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q11",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:02.08",
            SN: 93539,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.8,
              H_24R: 0,
              HUMD: 0.6721739,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.2875,
              H_24R: 0,
              HUMD: 0.58125,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.1785717,
              H_24R: 0,
              HUMD: 0.7185714,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.5583334,
              H_24R: 0,
              HUMD: 0.735,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.1708336,
              H_24R: 0,
              HUMD: 0.78791666,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.825,
              H_24R: 0,
              HUMD: 0.8379167,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.5,
              H_24R: 0,
              HUMD: 0.92,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-穗稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "鹿草鄉",
            CROP: "水稻",
            AREA_H: 1700,
            AREA_P: 1700,
            RATE_H: 6576,
            HARVEST: 11179200,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q11",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:02.08",
            SN: 93539,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.8,
              H_24R: 0,
              HUMD: 0.6721739,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.2875,
              H_24R: 0,
              HUMD: 0.58125,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.1785717,
              H_24R: 0,
              HUMD: 0.7185714,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.5583334,
              H_24R: 0,
              HUMD: 0.735,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.1708336,
              H_24R: 0,
              HUMD: 0.78791666,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.825,
              H_24R: 0,
              HUMD: 0.8379167,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.5,
              H_24R: 0,
              HUMD: 0.92,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-葉稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "新港鄉",
            CROP: "水稻",
            AREA_H: 2440,
            AREA_P: 2440,
            RATE_H: 6520,
            HARVEST: 15910060,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q07",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:02.25",
            SN: 93540,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.5086956,
              H_24R: 0,
              HUMD: 0.6621739,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.0708332,
              H_24R: 0,
              HUMD: 0.575,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.3071432,
              H_24R: 0,
              HUMD: 0.695,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.604167,
              H_24R: 0,
              HUMD: 0.72125,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.175,
              H_24R: 0,
              HUMD: 0.77458334,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.6416664,
              H_24R: 0,
              HUMD: 0.832083344,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.5,
              H_24R: 0,
              HUMD: 0.91,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-穗稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "新港鄉",
            CROP: "水稻",
            AREA_H: 2440,
            AREA_P: 2440,
            RATE_H: 6520,
            HARVEST: 15910060,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q07",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:02.25",
            SN: 93540,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.5086956,
              H_24R: 0,
              HUMD: 0.6621739,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.0708332,
              H_24R: 0,
              HUMD: 0.575,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.3071432,
              H_24R: 0,
              HUMD: 0.695,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.604167,
              H_24R: 0,
              HUMD: 0.72125,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.175,
              H_24R: 0,
              HUMD: 0.77458334,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.6416664,
              H_24R: 0,
              HUMD: 0.832083344,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.5,
              H_24R: 0,
              HUMD: 0.91,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-葉稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "溪口鄉",
            CROP: "水稻",
            AREA_H: 1683,
            AREA_P: 1683,
            RATE_H: 7463,
            HARVEST: 12561270,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q06",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:02.523",
            SN: 93541,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.478261,
              H_24R: 0,
              HUMD: 0.488695651,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.1333332,
              H_24R: 0,
              HUMD: 0.323333323,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.257143,
              H_24R: 0,
              HUMD: 0.4757143,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.4458332,
              H_24R: 0,
              HUMD: 0.550833344,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 15.979167,
              H_24R: 0,
              HUMD: 0.636666656,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.3125,
              H_24R: 0,
              HUMD: 0.733333349,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.6,
              H_24R: 0,
              HUMD: 0.82,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-穗稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "溪口鄉",
            CROP: "水稻",
            AREA_H: 1683,
            AREA_P: 1683,
            RATE_H: 7463,
            HARVEST: 12561270,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q06",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:02.523",
            SN: 93541,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.478261,
              H_24R: 0,
              HUMD: 0.488695651,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.1333332,
              H_24R: 0,
              HUMD: 0.323333323,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.257143,
              H_24R: 0,
              HUMD: 0.4757143,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.4458332,
              H_24R: 0,
              HUMD: 0.550833344,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 15.979167,
              H_24R: 0,
              HUMD: 0.636666656,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.3125,
              H_24R: 0,
              HUMD: 0.733333349,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.6,
              H_24R: 0,
              HUMD: 0.82,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-葉稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "義竹鄉",
            CROP: "水稻",
            AREA_H: 15,
            AREA_P: 15,
            RATE_H: 6390,
            HARVEST: 95850,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q10",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:02.687",
            SN: 93542,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.7130432,
              H_24R: 0,
              HUMD: 0.6752174,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.2375,
              H_24R: 0,
              HUMD: 0.58625,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.2214289,
              H_24R: 0,
              HUMD: 0.7192857,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.3166666,
              H_24R: 0,
              HUMD: 0.74,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.1083336,
              H_24R: 0,
              HUMD: 0.785833359,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.833334,
              H_24R: 0,
              HUMD: 0.825,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.5,
              H_24R: 0,
              HUMD: 0.89,
            },
          ],
        },
        {
          WARNING_INFO: {
            WARNING_DATE: "110/01/05",
            WARNING_RESULT: "水稻-穗稻熱病(警戒)",
          },
          AGRI_INFO: {
            A_YEAR: 109,
            PERIOD: " 二期作",
            CITY: "嘉義縣",
            TOWN: "義竹鄉",
            CROP: "水稻",
            AREA_H: 15,
            AREA_P: 15,
            RATE_H: 6390,
            HARVEST: 95850,
            ANA_C_ID: "Y04",
            ANA_DATE: "2020-01-01T00:00:00",
            ANA_CITY_ID: "Q",
            ANA_TOWN_ID: "Q10",
            ANA_TIME: "2022-03-07T17:24:38.687",
            TIMESTAMP: "2022-03-07T17:24:02.687",
            SN: 93542,
            REMARK: 0,
            SEASON: "S         ",
          },
          WEATHER_INFO: [
            {
              ObsTime: "2020-12-29T00:00:00",
              TEMP: 14.7130432,
              H_24R: 0,
              HUMD: 0.6752174,
            },
            {
              ObsTime: "2020-12-30T00:00:00",
              TEMP: 10.2375,
              H_24R: 0,
              HUMD: 0.58625,
            },
            {
              ObsTime: "2020-12-31T00:00:00",
              TEMP: 11.2214289,
              H_24R: 0,
              HUMD: 0.7192857,
            },
            {
              ObsTime: "2021-01-01T00:00:00",
              TEMP: 14.3166666,
              H_24R: 0,
              HUMD: 0.74,
            },
            {
              ObsTime: "2021-01-02T00:00:00",
              TEMP: 16.1083336,
              H_24R: 0,
              HUMD: 0.785833359,
            },
            {
              ObsTime: "2021-01-03T00:00:00",
              TEMP: 17.833334,
              H_24R: 0,
              HUMD: 0.825,
            },
            {
              ObsTime: "2021-01-04T00:00:00",
              TEMP: 17.5,
              H_24R: 0,
              HUMD: 0.89,
            },
          ],
        },
      ],
      // <summary>
      //  API函式宣告
      // </summary>
      /// <param "data">資料</param>
      apiGetWarninginfo: (data) =>
        this.userRequest.post("API/Default/getScourge", data),
      apiGetScourgeAllinfo: (data) =>
        this.userRequest.post("API/Default/getScourgeAll", data),
      apiGetCropYear: (data) =>
        this.userRequest.post("API/Default/CropYear", data),
      apiGetCropYearAll: (data) =>
        this.userRequest.post("API/Default/CropYearAll", data),
      apiGetCYCropList: (data) =>
        this.userRequest.post("API/Default/CY_CropList", data),
      apiGetCYCropYearList: (data) =>
        this.userRequest.post("API/Default/CY_CropYearList", data),
      apiGetCYCropYearPeriodList: (data) =>
      this.userRequest.post("API/Default/CY_CropYearPeriodList", data),
      apiGetCropList: (data) =>
        this.userRequest.post("API/Default/CropList", data),
      apiGetCropListAll: (data) =>
        this.userRequest.post("API/Default/CropListAll", data),
      apiGetCropArea: (data) =>
        this.userRequest.post("API/Default/CropAreaList", data),
      apiCYCropAreaList: (data) =>
        this.userRequest.post("API/Default/CYCropAreaList",data),
      apiGetCropAreaAll: (data) =>
        this.userRequest.post("API/Default/CropAreaListAll", data),
      apiGetCityArea: (data) =>
        this.userRequest.post("API/Default/CityArea", data),
      apiGetCityAreaTaiwan: (data) =>
        this.userRequest.post("API/Default/CityAreaTaiwan", data),
      apiGetHistoryList: (data) =>
        this.userRequest.post("API/Default/HistoryWarning", data),
      apiGetFeohnValue: (data) =>
        this.userRequest.post("API/Default/FeohnValue", data),
      apiGetDrop: (data) =>
        this.userRequest.post("API/Default/GetSevenDrop", data),
      apiGetTempture: (data) =>
        this.userRequest.post("API/Default/GetSevenTempture", data),
      apiTradeWarning: (data) =>
        this.userRequest.post("API/Default/TradeWarning", data),
      apiCropAreaListWarning: (data) =>
        this.userRequest.post("API/Default/CropAreaListWarning", data),
      apiPestNoticeLast: (data) =>
        this.userRequest.post("API/Default/PestNoticeLast", data),
      apiPestNoticeByDate: (data) =>
        this.userRequest.post("API/Default/PestNoticeByDate", data),
      apiRiceBlastLastWarning: (data) =>
        this.userRequest.post("API/Default/RiceBlastLastWarning", data),
      apiRiceBlastWarningByDate: (data) =>
        this.userRequest.post("/API/Default/RiceBlastWarningByDate", data),
      apiRiceBlastDateList: (data) =>
        this.userRequest.post("/API/Default/RiceBlastDateList", data),
      apiCropAreabyPest: (data) =>
        this.userRequest.post("API/Default/CropAreabyPest", data),
      apiGetSystemManualDownload: (data) =>
        this.userRequest.post("/API/Default/SystemManualDownload", data),
      apiGetCyhgAgriTown: (data) =>
        this.userRequest.post("/API/Default/GetCyhgAgriTown", data),
      apiGetSitsect: () =>
        this.userRequest.get("/API/Default/GetSitsect"),
    };
  },
  /*      <summary>
        元件宣告
        </summary>
        / <param "data">資料</param> */
  components: {
    // DragInformationBox,
    // DragCropInformationBox,
    // DragCropInfoChart,
    // DragPDInformationBox,
    CropInformationBox,
    //Loading,
  },
  created() {
    this.FunctionToken(this.getRiceBlastDateList, {});
    this.FunctionToken(this.togetCyhgAgriTown,{});
    this.GetSitsect();
    
  },
  mounted() {
    if (this.$route.params.tab == 0) {
      this.tabselected = this.$route.params.tab;
      this.ifshowsidebar = true;
    }
    if(this.$route.params.anchor != null ){
      this.isLoading = true;
    }
    this.init();
    //獲取農情作物資料
    //this.FunctionToken(this.getCropYear, {});
    this.FunctionToken(this.getCropYearAll, {});
    this.FunctionToken(this.toGetCropList, {});
    // 生成Map
    this.mapInit();
    //獲取災害相關資料
    this.FunctionToken(this.getWarningData, {});//嘉義氣象預警
    this.FunctionToken(this.getWarningAllData, {});

    // this.FunctionToken(this.getPestNoticeList, {});
    //獲取價量預警
    // this.FunctionToken(this.TradeWarning, {});
    if (this.IsNull(this.$route.params.tab) != "") {
      this.tabselected = this.$route.params.tab;
    }
    this.gisobject = this;
    this.checkLogin();
    this.checkUserName();
    
  },
  watch: {
    SectCheck(val){
      if(this.SectCheckMap == null){
        this.SectCheckMap = new VectorLayer({
          visible: true,
          source: new VectorSource({
            url: "GeoJSON/AllMasec_3857.geojson",
            format: new GeoJSON(),
          }),
          style: new Style({
            stroke: new Stroke({
              color: [0, 0, 0, 1],
              width: 1,
            }),
            fill: new Fill({
              color: [147, 115, 216, 0.9],
            }),
          }),
        });

        
        this.SectCheckMap.set("name", "SectCheckMap");

        this.SectCheckMap.getSource().forEachFeature(function(aFeature){
          aFeature.values_.CLASS_NAME = "SectCheckMap";
        });
      }
      if(val)
      {
        this.map.addLayer(this.SectCheckMap);
        this.SectInfo.ifSectShow = true;
        this.ifgermshow = true;
      }
      else
      {
        this.map.removeLayer(this.SectCheckMap);
        this.SectInfo.ifSectShow = false;
        this.ifgermshow = false;
      }
    },
    SectSubCheck(val){
      if(this.SectSubCheckMap == null){
        this.SectSubCheckMap = new VectorLayer({
          visible: true,
          source: new VectorSource({
            url: "GeoJSON/AIlMIsec_3857_new.geojson", 
            format: new GeoJSON(),
          }),
          style: new Style({
            stroke: new Stroke({
              color: [0, 0, 0, 1],
              width: 1,
            }),
            fill: new Fill({
              color: [29, 151, 108, 0.9],
            }),
          }),
        });
        this.SectSubCheckMap.set("name", "SectSubCheckMap");
        this.SectSubCheckMap.getSource().forEachFeature(function(aFeature){
          aFeature.values_.CLASS_NAME = "SectSubCheckMap";
        });
      }

      if(val)
      {
        this.map.addLayer(this.SectSubCheckMap);
        this.SectSubInfo.ifSectSubShow = true;
        this.ifgermshow = true;
      }
      else
      {
        this.map.removeLayer(this.SectSubCheckMap);
        this.SectSubInfo.ifSectSubShow = false;
        this.ifgermshow = false;
      }
    },
    geotabs(val) {
      //console.log(val);
      if (val == 1) {
        this.removeItem(0);
      }
    },
    tabselected() {
      if (
        this.IsNull(this.parsetab) != "" &&
        this.tabselected != this.parsetab
      ) {
        this.tabselected = this.$route.params.tab;
        this.parsetab = null;
      }
    },
    ifallgeoselect(val) {
      if (this.ifselectTrigger) {
        this.ifselectTrigger = false;
      } else if (val.length != 0) {
        this.geoselect = [];
        this.geoselectionlist.forEach((x) => {
          this.geoselect.push(x.value);
        });
      } else if (this.geoselect.length == this.geoselectionlist.length) {
        this.geoselect = [];
      }
    },
    ifallsectselect(val) {
      if(this.ifselectTrigger){
        this.ifselectTrigger = false;
      }else if (val.length !=0){
        this.sectSelect=[];
        this.sectnameList.forEach((x) => {
          this.sectSelect.push(x.text);
        })
      }else if(this.sectSelect.length == this.sectnameList.length){
        this.sectSelect =[];
      }
    },
    geoselect(val) {
      //console.log([val.length, this.geoselectionlist.length]);
      if (val.length != this.geoselectionlist.length) this.ifallgeoselect = [];
      if (val.length == this.geoselectionlist.length) {
        this.ifselectTrigger = true;
        this.ifallgeoselect = ["全選"];
      }
      if (this.geotabs == 0) {
        this.changeGeoJson();
      } else {
        // this.changeTaiwanGeoJson()
        //this.cropMapAll.getSource().refresh();
      }
    },
    //sectSelect(val){
    //  if(val.length != this.sectnameList.length) this.ifallsectselect=[];
    //  if(val.length == this.sectnameList.length){
    //    this.ifselectTrigger = true;
    //    this.ifallsectselect = ["全選"]
    //  }
    //  if(this.geotabs == 0){
    //    this.changeCYGeoJson();
    //  } else {
    //    this.CYSectMap.getSource().refresh();
    //  }
    //},
    countrySelect(val) {
      if (val.length > 0) {
        let geolist = taiwantownlist[val];
        //console.log([geolist, this.crop]);
        this.geoselectionlist = [];
        this.geoselect = [];
        for (var index in this.cropArea.AGRI_SURVEY_TAIWAN) {
          let item = this.cropArea.AGRI_SURVEY_TAIWAN[index];
          let subindex = geolist.findIndex((x) => x.value == item.ANA_TOWN_ID);
          if (
            subindex != -1 &&
            this.geoselectionlist.findIndex(
              (x) => x.value == item.ANA_TOWN_ID
            ) == -1
          ) {
            this.geoselectionlist.push(geolist[subindex]);
            this.geoselect.push(geolist[subindex].value);
          }
        }
        this.changeTaiwanGeoJson();
        this.cropInfoShow = true;
        this.legendShow = true;
      }
    },
    ifalltownselect(val){
      //console.log("ifalltownselec(val)",val);
      if(this.ifselectCYTrigger){
        this.ifselectCYTrigger = false;
      }else if(val.length != 0){
        this.townSelect =[];
        this.townList.forEach((x) =>{
          this.townSelect.push(x.value);
        })
      }else if(val.length == this.townSelect.length){
        this.ifalltownselec = ["全選"];
      }
    },
    townSelect(val){
      //console.log("val.length and townList2.length",[val.length,this.townList2.length]);
      if(val.length != this.townList.length) this.ifalltownselect =[];
      if(val.length == this.townList.length) {
        this.ifselectCYTrigger = true;
        this.ifalltownselect = ["全選"];
      }
      if(this.geotabs == 0){
        this.changeCYGeoJson();
      }else{
        this.germCYmap.getSource().refresh();
      }
    },
    // "pestsAndDiseases.yearselected"(value) {
    //   if (!this.iffirst) {
    //     this.pestsAndDiseases.monthselected = null;
    //     let subindex = this.pestsAndDiseases.period.findIndex(
    //       (x) => x.year == value
    //     );
    //     this.pestsAndDiseases.monthoptions = this.pestsAndDiseases.period[
    //       subindex
    //     ].monthlist;
    //   } else {
    //     this.iffirst = false;
    //   }
    // },
    // "pestsAndDiseases.monthselected"(value) {
    //   if (value != null) {
    //     this.ifpdget = false;
    //     this.changedata();
    //   }
    // },
    // "pestsAndDiseases.selected"(value) {
    //   if (this.IsNull(value) != "") {
    //     let obj = value.split("&#");
    //     let subindex = this.pestsAndDiseases.data.findIndex(
    //       (y) => y.ISSUED_DATE == obj[0]
    //     );
    //     let subitem = this.pestsAndDiseases.data[subindex];
    //     this.pestsAndDiseases.PDobject = {
    //       subject: subitem.SUBJECT,
    //       contents: subitem.CONTENTS,
    //       suggest: subitem.SUGGEST,
    //       publish: subitem.PUBLISH,
    //       cropname: obj[1],
    //       date: obj[0],
    //       detial: {
    //         title: null,
    //         place: null,
    //         items: [],
    //       },
    //     };

    //     let submitobj = {
    //       C_ID: obj[1].split(",")[1],
    //     };
    //     this.pestsAndDiseases.ifPDWindowShow = true;
    //     this.legendShow = true;
    //     this.FunctionToken(this.getCropAreabyPest, submitobj);
    //   }
    // },
    "pestsAndDiseases2.yearselected"(value) {
      if (!this.iffirst) {
        this.pestsAndDiseases2.monthselected = null;
        let subindex = this.pestsAndDiseases2.period.findIndex(
          (x) => x.year == value
        );
        this.pestsAndDiseases2.monthoptions = this.pestsAndDiseases2.period[
          subindex
        ].monthlist;
      } else {
        this.iffirst = false;
      }
    },
    "pestsAndDiseases2.monthselected"(value) {
      //console.log("pestsAndDiseases2.monthselected is change")
      this.map.removeLayer(this.pestandDieaseMap);
      if(this.pestsAndDiseases2.ifPDWindowShow){
        this.pestsAndDiseases2.ifPDWindowShow=false;
      }
      if(this.pestsAndDiseases2.ifPDWindowShow_ear){
        this.pestsAndDiseases2.ifPDWindowShow_ear = false;
      }
      if (value != null) {
        this.ifpdget = false;
        this.changedata2();
      }
    },
    "pestsAndDiseases2.selected"(value) {
      this.getCropdataandMap(value);
    },
    isFoodItemSelected() {
      this.informationshow = true;
      this.legendcheck();
    },
    cropInfoShow() {
      this.informationshow = true;
      this.legendcheck();
    },
    "pestsAndDiseases2.ifPDWindowShow"() {
      this.informationshow = true;
      this.legendcheck();
    },
    "pestsAndDiseases2.ifPDWindowShow_ear"(){
      this.informationshow = true;
      this.legendcheck();
    },
    "pestsAndDiseases.unpublishhightestarea"() {
      this.legendcheck();
    },
    tradeWarningShow() {
      this.legendcheck();
    },
    gdacsCheck(){
      this.legendcheck();
    },
    fifowstyphoonCheck(){
      this.legendcheck();
    },
    raingaugeCheck() {
      this.legendcheck();
    },
    rainCheck() {
      this.legendcheck();
    },
    radarCheck() {
      this.legendcheck();
    },
  },
  methods: {
    init() {
      let height =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
      let headerelement = document.querySelector(".head");
      let headerheight = headerelement.offsetHeight;
      this.infoheight = parseInt(height) - parseInt(headerheight);
    },
    /**/
    GetSitsect(){
      this.apiGetSitsect()
        .then((res) =>{
          const json = JSON.parse(res.data);
          if (json.Status){
            let jsonData = JSON.parse(json.Data);
            //console.log("GetSitsect jsonData",jsonData);
            this.MasecList = [];
            this.MasecList = jsonData;
            //console.log("MasecList",this.MasecList);
          }
        })
    },
    getDocumentLink(data) {
      this.apiGetSystemManualDownload(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.documentlink = null;
            let jsonData = JSON.parse(json.Data);
            this.documentlink = jsonData;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    checkUserName() {
      if (sessionStorage.getItem("username")) {
        this.accountid = sessionStorage.getItem("username");
        this.showmanage.iflogin = true;
      } else {
        this.accountid = "訪客";
        this.showmanage.iflogin = false;
      }
    },
    checkLogin() {
      let TokenID = sessionStorage.getItem("TokenID");
      if (TokenID) {
        // this.accountshow = true;
        this.FunctionToken(this.getDocumentLink, {});
        this.checkPermission();
      } else {
        this.showmanage.iflogin = false;
        this.showmanage.accountshow = false;
        // this.showmanage.datamanagement.databuild.show = false
      }
    },
    async checkPermission() {
      await this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000001",
        fun: this.checkByPJID,
      });
    },
    permisecondcheck() {
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000002",
        fun: this.checkByPJIDdashboardfarmshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000003",
        fun: this.checkByPJIDdashboardfishshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000004",
        fun: this.checkByPJIDdashboardanimalshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000005",
        fun: this.checkByPJIDdashboardcropshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000006",
        fun: this.checkByPJIDdatabuildfarmshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000007",
        fun: this.checkByPJIDdatabuildfarmshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000008",
        fun: this.checkByPJIDdatabuildfarmshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000009",
        fun: this.checkByPJIDdatabuildfarmshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000010",
        fun: this.checkByPJIDdatabuildfishshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000011",
        fun: this.checkByPJIDdatabuildfishshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000012",
        fun: this.checkByPJIDdatabuildfishshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000013",
        fun: this.checkByPJIDdatabuildfishshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000014",
        fun: this.checkByPJIDdatabuildanimalshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000015",
        fun: this.checkByPJIDdatabuildanimalshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000016",
        fun: this.checkByPJIDdatabuildanimalshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000017",
        fun: this.checkByPJIDdatabuildanimalshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000018",
        fun: this.checkByPJIDdatabuildcropshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000019",
        fun: this.checkByPJIDdatabuildcropshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000020",
        fun: this.checkByPJIDdatabuildcropshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000021",
        fun: this.checkByPJIDdatabuildcropshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000022",
        fun: this.checkByPJIDdatabuildpentshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000023",
        fun: this.checkByPJIDdatabuildpentshow,
      });
      // this.FunctionToken(this.Authority, {
      //   PJ_ID: "PJ000000000024",
      //   fun: this.checkByPJIDdatabuildpentshow,
      // });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000025",
        fun: this.checkByPJIDdatabuildpentshow,
      });
    },
    checkByPJID(value) {
      if (!value) {
        this.showmanage.accountshow = false;
      } else {
        this.showmanage.accountshow = true;
      }
      this.permisecondcheck();
    },
    checkByPJIDdashboardfarmshow(value) {
      if (value) this.showmanage.dashboard.farmshow = true;
    },
    checkByPJIDdashboardfishshow(value) {
      if (value) this.showmanage.dashboard.fishshow = true;
    },
    checkByPJIDdashboardanimalshow(value) {
      if (value) this.showmanage.dashboard.animalshow = true;
    },
    checkByPJIDdashboardcropshow(value) {
      if (value) this.showmanage.dashboard.cropshow = true;
    },
    checkByPJIDdatabuildfarmshow(value) {
      if (value) this.showmanage.databuild.farmshow = true;
    },
    checkByPJIDdatabuildfishshow(value) {
      if (value) this.showmanage.databuild.fishshow = true;
    },
    checkByPJIDdatabuildanimalshow(value) {
      if (value) this.showmanage.databuild.animalshow = true;
    },
    checkByPJIDdatabuildcropshow(value) {
      if (value) this.showmanage.databuild.cropshow = true;
    },
    checkByPJIDdatabuildpentshow(value) {
      if (value) this.showmanage.databuild.pentshow = true;
    },
    userSignOut() {
      sessionStorage.removeItem("TokenID");
      sessionStorage.removeItem("username");
      // this.GROUPMyList = [];
      // this.checkLogin()
      this.$parent.refresh();
      this.$router.push({ path: "/login" });
    },
    legendcheck() {
      if (
        !this.isFoodItemSelected &&
        !this.cropInfoShow &&
        !this.pestsAndDiseases2.ifPDWindowShow &&
        !this.pestsAndDiseases2.ifPDWindowShow_ear &&
        !this.tradeWarningShow &&
        !this.raingaugeCheck &&
        !this.rainCheck &&
        !this.radarCheck &&
        !this.fifowstyphoonCheck &&
        !this.gdacsCheck
      ) {
        this.legendShow = false;
      } else {
        this.legendShow = true;
      }
    },
    parseToOptions(value) {
      let option = [];
      for (let i in value.CROPS) {
        let subitem = value.CROPS[i].split(",");
        if (option.findIndex((y) => y.text == subitem[0]) == -1) {
          let obj = {
            text: subitem[0],
            value: value.ISSUED_DATE + "&#" + value.CROPS[i],
          };
          option.push(obj);
        }
      }
      return option;
    },
    parseToOptions2(value) {
      let option = [];
      for (let i in value.CROPS) {
        let subitem = value.CROPS[i].split(",");
        if (option.findIndex((y) => y.text == subitem[0]) == -1) {
          let obj = {
            text: subitem[0],
            value: value.ISSUED_DATE + "&#" + value.CROPS[i],
          };
          option.push(obj);
        }
      }
      return option;
    },
    //病蟲害(舊)
    getPestNoticeList(data) {
      this.apiPestNoticeList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            for (let i in jsonData) {
              let item = jsonData[i];
              if (this.IsNull(item.CROP) != "") {
                let date1 = item.ISSUED_DATE.split("T")[0];
                let subdate = item.ISSUED_DATE.split("T")[0].split("-");
                if (
                  this.pestsAndDiseases.yearoptions.indexOf(subdate[0]) == -1
                ) {
                  this.pestsAndDiseases.yearoptions.push(subdate[0]);
                }

                let subindex = this.pestsAndDiseases.period.findIndex(
                  (x) => x.year == subdate[0]
                );

                if (subindex == -1) {
                  let dateobject = {
                    year: subdate[0],
                    monthlist: [subdate[1]],
                  };
                  this.pestsAndDiseases.period.push(dateobject);
                } else {
                  if (
                    this.pestsAndDiseases.period[subindex].monthlist.indexOf(
                      subdate[1]
                    ) == -1
                  ) {
                    this.pestsAndDiseases.period[subindex].monthlist.push(
                      subdate[1]
                    );
                    this.pestsAndDiseases.period[subindex].monthlist
                      .sort()
                      .reverse();
                  }
                }
                item.ISSUED_DATE = date1;
                this.pestsAndDiseases.alldata.push(item);
              }
            }
            this.pestsAndDiseases.yearselected = this.pestsAndDiseases.period[0].year;
            this.pestsAndDiseases.monthoptions = this.pestsAndDiseases.period[0].monthlist;
            this.pestsAndDiseases.monthselected = this.pestsAndDiseases.monthoptions[0];
            // this.changedata()
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getPestNoticeByDate(data) {
      this.apiPestNoticeByDate(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.pestsAndDiseases.data = [];
            for (let j in jsonData) {
              let subitem = jsonData[j];
              if (subitem.CROPS.length > 0) {
                let date1 = subitem.ISSUED_DATE.split("T")[0];
                subitem.ISSUED_DATE = date1;
                this.pestsAndDiseases.data.push(subitem);
              }
            }
            this.ifpdget = true;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getPestNoticeLast(data) {
      this.apiPestNoticeLast(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            var d = jsonData.ISSUED_DATE.split("T")[0].split("-");
            // var d = new Date();
            // this.pestsAndDiseases.year = d.getFullYear();
            // this.pestsAndDiseases.month = d.getMonth()+1;

            this.pestsAndDiseases.year = parseInt(d[0]);
            this.pestsAndDiseases.month = parseInt(d[1]);

            for (let i = this.pestsAndDiseases.year; i > 2013; i--) {
              let dateobject = {};
              if (
                this.pestsAndDiseases.year == i &&
                this.pestsAndDiseases.month != 12
              ) {
                let monthlist2 = [];
                for (let j = this.pestsAndDiseases.month; j > 0; j--) {
                  monthlist2.push(j);
                }
                dateobject = {
                  year: i - 1911,
                  monthlist: monthlist2,
                };
              } else {
                dateobject = {
                  year: i - 1911,
                  monthlist: [12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
                };
              }
              this.pestsAndDiseases.yearoptions.push(i - 1911);
              this.pestsAndDiseases.period.push(dateobject);
            }
            this.pestsAndDiseases.yearselected = this.pestsAndDiseases.period[0].year;
            this.pestsAndDiseases.monthoptions = this.pestsAndDiseases.period[0].monthlist;
            this.pestsAndDiseases.monthselected = this.pestsAndDiseases.monthoptions[0];
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    //病蟲害(新)
    // getRiceBlastLastWarning(data) {
    //   this.apiRiceBlastLastWarning(data)
    //     .then((res) => {
    //       const json = JSON.parse(res.data);
    //       if (json.Status) {
    //         let jsonData = JSON.parse(json.Data);
    //         for (let i in jsonData) {
    //           let item = jsonData[i];

    //           // if (this.IsNull(item.CROP) != "") {
    //           //   let date1 = item.ISSUED_DATE.split("T")[0];
    //           //   let subdate = item.ISSUED_DATE.split("T")[0].split("-");
    //           //   if (
    //           //     this.pestsAndDiseases.yearoptions.indexOf(subdate[0]) == -1
    //           //   ) {
    //           //     this.pestsAndDiseases.yearoptions.push(subdate[0]);
    //           //   }

    //           //   let subindex = this.pestsAndDiseases.period.findIndex(
    //           //     (x) => x.year == subdate[0]
    //           //   );

    //           //   if (subindex == -1) {
    //           //     let dateobject = {
    //           //       year: subdate[0],
    //           //       monthlist: [subdate[1]],
    //           //     };
    //           //     this.pestsAndDiseases.period.push(dateobject);
    //           //   } else {
    //           //     if (
    //           //       this.pestsAndDiseases.period[subindex].monthlist.indexOf(
    //           //         subdate[1]
    //           //       ) == -1
    //           //     ) {
    //           //       this.pestsAndDiseases.period[subindex].monthlist.push(
    //           //         subdate[1]
    //           //       );
    //           //       this.pestsAndDiseases.period[subindex].monthlist
    //           //         .sort()
    //           //         .reverse();
    //           //     }
    //           //   }
    //           //   item.ISSUED_DATE = date1;
    //           //   this.pestsAndDiseases.alldata.push(item);
    //           // }
    //         }
    //         // this.pestsAndDiseases.yearselected = this.pestsAndDiseases.period[0].year;
    //         // this.pestsAndDiseases.monthoptions = this.pestsAndDiseases.period[0].monthlist;
    //         // this.pestsAndDiseases.monthselected = this.pestsAndDiseases.monthoptions[0];
    //         // this.changedata()
    //       }
    //     })
    //     .catch((err) => {
    //       console.warn(err);
    //     });
    // },
    getRiceBlastWarningByDate(data) {
      this.apiRiceBlastWarningByDate(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.pestsAndDiseases2.alldata = JSON.parse(
              JSON.stringify(jsonData)
            );
            //console.log("this.pestsAndDiseases2.alldata",this.pestsAndDiseases2.alldata);
            this.getPestsandDiseaseData(this.pestsAndDiseases2.alldata);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getRiceBlastDateList(data) {
      this.apiRiceBlastDateList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            jsonData.forEach((y) => {
              let date1 = y.S_DATE.split("/");
              if (this.pestsAndDiseases2.yearoptions.indexOf(date1[0]) == -1) {
                this.pestsAndDiseases2.yearoptions.push(date1[0]);
              }

              let subindex = this.pestsAndDiseases2.period.findIndex(
                (x) => x.year == date1[0]
              );

              if (subindex == -1) {
                let dateobject = {
                  year: date1[0],
                  monthlist: [date1[1]],
                };
                this.pestsAndDiseases2.period.push(dateobject);
              } else {
                if (
                  this.pestsAndDiseases2.period[subindex].monthlist.indexOf(
                    date1[1]
                  ) == -1
                ) {
                  this.pestsAndDiseases2.period[subindex].monthlist.push(
                    date1[1]
                  );
                  this.pestsAndDiseases2.period[subindex].monthlist
                    .sort()
                    .reverse();
                }
              }
            });

            this.pestsAndDiseases2.yearselected = this.pestsAndDiseases2.period[0].year;
            this.pestsAndDiseases2.monthoptions = this.pestsAndDiseases2.period[0].monthlist;
            this.pestsAndDiseases2.monthselected = this.pestsAndDiseases2.monthoptions[0];
            // this.pestsAndDiseases2.alldata = JSON.parse(
            //   JSON.stringify(this.testlist)
            // );
            // this.getPestsandDiseaseData(this.pestsAndDiseases2.alldata);
            // let obj = {
            //   YEAR: this.pestsAndDiseases2.yearselected,
            //   MONTH: this.pestsAndDiseases2.monthselected,
            // };
            // this.FunctionToken(this.getRiceBlastWarningByDate, obj);
            //this.changedata2();//已做pestsAndDiseases2.monthselected監聽，不用再多做一次changedata2()
            //test/
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getCropAreabyPest(data) {
      this.apiCropAreabyPest(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.pestsAndDiseases.publishhightestarea = 0;
            this.pestsAndDiseases.unpublishhightestarea = 0;
            this.pestsAndDiseases.cropdata = [];
            let jsonData = JSON.parse(json.Data);
            this.pestsAndDiseases.publishhightestarea = this.arrayMax(
              jsonData,
              0
            );
            this.pestsAndDiseases.unpublishhightestarea = this.arrayMax(
              jsonData,
              1
            );
            this.pestsAndDiseases.cropdata = jsonData;
            this.map.removeLayer(this.pestNoticeWarningMap);
            this.pestNoticeWarningMap = {};
            this.pestNoticeWarningMap = new VectorLayer({
              visible: true,
              source: new VectorSource({
                url: "GeoJSON/taiwan.geojson",
                format: new GeoJSON(),
              }),
              style: this.stylePDFunction,
            });
            this.pestNoticeWarningMap.set("name", "pestnoticewarning");
            this.map.addLayer(this.pestNoticeWarningMap);
            this.MapView.animate(
              { zoom: 8 },
              { center: fromLonLat([120.58, 23.58]) }
            );
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    showGermMap() {
      this.germMap = new VectorLayer({
        visible: true,
        source: new VectorSource({
          url: "GeoJSON/123.geojson",
          format: new GeoJSON(),
        }),
        style: this.styleGermFunction,
      });
      //console.log("this.germMap:",this.germMap);
      //console.log("germlist[this.cropInfo2.period]",germlist[this.cropInfo2.period]);
      this.cropsectorlist = germlist[this.cropInfo2.period].data;
      this.germMap.set("name", "germmap");
      this.map.addLayer(this.germMap);
      this.cropInfo2.ifCropShow = true;
      this.ifgermshow = true;
    },
    removeGermMap() {
      this.map.removeLayer(this.germMap);
      this.germMap = {};
      this.cropsectorlist = [];
      this.ifgermshow = false;
      this.cropInfo2.ifCropShow = false;
    },
    arrayMax(arr, index) {
      let len = arr.length,
        max = -Infinity;
      if (index == 0) {
        while (len--) {
          if (
            arr[len].AREA_H > max &&
            this.pestsAndDiseases.PDobject.publish.findIndex(
              (x) => x.split(",")[1] == arr[len].ANA_CITY_ID
            ) != -1
          ) {
            max = arr[len].AREA_H;
          }
        }
      } else {
        while (len--) {
          if (
            arr[len].AREA_H > max &&
            this.pestsAndDiseases.PDobject.publish.findIndex(
              (x) => x.split(",")[1] == arr[len].ANA_CITY_ID
            ) == -1
          ) {
            max = arr[len].AREA_H;
          }
        }
      }
      return max == -Infinity ? 0 : max;
    },
    getPestsandDiseaseData(list) {
      //console.log("list",list)
      try {
        let resultlist = [];
        list.forEach((x) => {
          let checkstyle =
            x.WARNING_INFO.WARNING_RESULT == "水稻-葉稻熱病(預警)" ||
            x.WARNING_INFO.WARNING_RESULT == "水稻-穗稻熱病(預警)"
              ? "warning"
              : x.WARNING_INFO.WARNING_RESULT == "水稻-葉稻熱病(警戒)" ||
                x.WARNING_INFO.WARNING_RESULT == "水稻-穗稻熱病(警戒)"
              ? "danger"
              : null;
          let subindex = resultlist.findIndex(
            (y) => y.date == x.WARNING_INFO.WARNING_DATE && y.type == checkstyle
          );
          let subindex2 =
            subindex == -1
              ? -1
              : resultlist[subindex].result.indexOf(
                  x.WARNING_INFO.WARNING_RESULT
                );
          if (subindex == -1) {
            let obj = {
              date: x.WARNING_INFO.WARNING_DATE,
              type: checkstyle,
              result: [],
              warning_lavel:x.Warning_lavel,
            };
            obj.result.push(x.WARNING_INFO.WARNING_RESULT);
            resultlist.push(obj);
          } else if (subindex2 == -1) {
            resultlist[subindex].result.push(x.WARNING_INFO.WARNING_RESULT);
          } 
        });
        this.pestsAndDiseases2.data = [];
        this.pestsAndDiseases2.data = resultlist;
        //console.log("this.pestsAndDiseases2.data",this.pestsAndDiseases2.data);
        this.ifpdget = true;
      } catch (e) {
        console.warn(e);
      }
    },
    parsepestsAndDiseasesOption(item) {
      let list = [];
      //console.log(item);
      item.result.forEach((y) => {
        let str = item.date + "&%$" + y;
        let obj = {
          text: y,
          value: str,
        };
        list.push(obj);
      });
      //console.log("list",list);
      return list;
    },
    changedata() {
      this.pestsAndDiseases.data = [];
      let obj = {
        YEAR: this.pestsAndDiseases.yearselected + 1911,
        MONTH: this.pestsAndDiseases.monthselected,
      };
      this.FunctionToken(this.getPestNoticeByDate, obj);
    },
    changedata2() {
      //console.log("changedata2 is called")
      this.pestsAndDiseases2.data = [];
      let obj = {
        YEAR: this.pestsAndDiseases2.yearselected,
        MONTH: this.pestsAndDiseases2.monthselected,
      };
      this.FunctionToken(this.getRiceBlastWarningByDate, obj);
    },
    getCropdataandMap(value) {
      //console.log("getCropdataandMap value",value);
      if (value == null) return null;
      if(this.pestsAndDiseases2.ifPDWindowShow && !this.pestsAndDiseases2.ifPDWindowShow_ear){
        this.pestsAndDiseases2.ifPDWindowShow=false;
      }
      if(this.pestsAndDiseases2.ifPDWindowShow_ear && !this.pestsAndDiseases2.ifPDWindowShow){
        this.pestsAndDiseases2.ifPDWindowShow_ear=false;
      }
      let item = value.split("&%$");
      let date = item[0];
      let text = item[1];
      //console.log("pestsAndDiseases2",this.pestsAndDiseases2)
      let typeindex = this.pestsAndDiseases2.data.findIndex(
        (y) => y.date == date && y.result.indexOf(text) != -1
      );
      this.pestsAndDiseases2.warning_lavel = this.pestsAndDiseases2.data[typeindex].warning_lavel;
      //this.pestsAndDiseases2.type = this.pestsAndDiseases2.data[typeindex].type;
      this.pestsAndDiseases2.type = text;
      //console.log("this.pestsAndDiseases2.type",this.pestsAndDiseases2.type);
      this.pestsAndDiseases2.cropdata = [];
      this.pestsAndDiseases2.alldata.forEach((y) => {
        if (y.AGRI_INFO != null) {
          if (
            y.WARNING_INFO.WARNING_DATE == date &&
            y.WARNING_INFO.WARNING_RESULT == text
          ) {
            this.pestsAndDiseases2.cropdata.push(y);
          }
          if (this.pestsAndDiseases2.publishhightestarea < y.AGRI_INFO.AREA_H)
            this.pestsAndDiseases2.publishhightestarea = y.AGRI_INFO.AREA_H;
        }
      });

      this.map.removeLayer(this.pestandDieaseMap);
      this.pestandDieaseMap = {};
      this.pestandDieaseMap = new VectorLayer({
        visible: true,
        source: new VectorSource({
          url: "GeoJSON/chayi_3857.geojson",
          format: new GeoJSON(),
        }),
        style: this.stylePDFunction2,
      });
      this.pestandDieaseMap.set("name", "pestandDieaseMap");
      this.map.addLayer(this.pestandDieaseMap);

      this.pestsAndDiseases2.PDobject2.date = date;
      if(text.includes("葉稻熱病")){
        this.pestsAndDiseases2.ifPDWindowShow = true;
      }
      else{
        this.pestsAndDiseases2.ifPDWindowShow_ear = true;
      }
      this.legendShow = true;
    },
    returnChartobj(Obj) {
      this.chartobj = Obj;
    },
    styleGermFunction(feature) {
      //styleGermFunction() {
      let style;
      let fillColor = [0, 0, 0, 0];
      let strokeColor = [0, 0, 0, 0];
      // alert(1);
      let metadata = feature.values_;
      let hugevolume =
        this.cropInfo2.period == "一期作"
          ? 355.53
          : this.cropInfo2.period == "二期作"
          ? 443.55
          : 26;
      let index = this.cropsectorlist.findIndex(
        (x) => x.SECT_NAME == metadata.SECT_NAME && x.TOWN == metadata.TOWN
      );
      // console.log([metadata, hugevolume]);

      let highest_level = hugevolume / 5;
      let percentage;
      //if (metadata.TOWN == "0008.六腳鄉") console.log(metadata);
      // if (
      //   metadata.A_YEAR == this.cropInfo2.year &&
      //   metadata.PERIOD == this.cropInfo2.period
      // )
      if (index != -1) {
        let area = parseInt(this.cropsectorlist[index].AREA_P);
        if (area == 0) percentage = 0;
        else if (area < highest_level) percentage = 0.2;
        else if (area < highest_level * 2) percentage = 0.4;
        else if (area < highest_level * 3) percentage = 0.6;
        else if (area < highest_level * 4) percentage = 0.7;
        else if (area <= highest_level * 5) percentage = 0.9;
        fillColor = [29, 151, 108, percentage];
        strokeColor = [0, 0, 0, 1];
      }
      //else{
      //  console.log(metadata.TOWN,metadata.SECT_NAME);
      //} 
      style = new Style({
        stroke: new Stroke({
          color: strokeColor,
          width: 1,
        }),
        fill: new Fill({
          color: fillColor,
        }),
      });
      return style;
    },
    styleFunction(feature) {
      let style;
      let fillColor = [0, 0, 0, 0];
      let strokeColor = [0, 0, 0, 0];

      if (this.cropArea.BA_AGRI_SURVEY) {
        let survey = this.cropArea.BA_AGRI_SURVEY;
        if (survey.length > 0) {
          let townID = feature.values_.TOWNID;
          if (
            this.cropAreaSelected.includes(townID) &&
            this.geoselect.includes(townID)
          ) {
            let highest_level = this.cropArea.HEIGHT_AREA / 5;
            let percentage;
            if (this.areaValue[townID].AREA_H < highest_level) percentage = 0.2;
            else if (this.areaValue[townID].AREA_H < highest_level * 2)
              percentage = 0.4;
            else if (this.areaValue[townID].AREA_H < highest_level * 3)
              percentage = 0.6;
            else if (this.areaValue[townID].AREA_H < highest_level * 4)
              percentage = 0.7;
            else if (this.areaValue[townID].AREA_H <= highest_level * 5)
              percentage = 0.9;
            fillColor = [29, 151, 108, percentage];
            strokeColor = [0, 0, 0, 1];
          }
        }
        style = new Style({
          stroke: new Stroke({
            color: strokeColor,
            width: 1,
          }),
          fill: new Fill({
            color: fillColor,
          }),
        });
        return style;
      } else if (this.cropArea.AGRI_SURVEY_TAIWAN) {
        let survey = this.cropArea.AGRI_SURVEY_TAIWAN;
        if (survey.length > 0) {
          let townID = feature.values_.TOWNID;
          if (
            this.cropAreaSelected.includes(townID) &&
            this.geoselect.includes(townID)
          ) {
            let highest_level = this.cropArea.HEIGHT_AREA / 5;
            let percentage;
            if (this.areaValue[townID].AREA_H < highest_level) percentage = 0.2;
            else if (this.areaValue[townID].AREA_H < highest_level * 2)
              percentage = 0.4;
            else if (this.areaValue[townID].AREA_H < highest_level * 3)
              percentage = 0.6;
            else if (this.areaValue[townID].AREA_H < highest_level * 4)
              percentage = 0.7;
            else if (this.areaValue[townID].AREA_H <= highest_level * 5)
              percentage = 0.9;
            fillColor = [29, 151, 108, percentage];
            strokeColor = [0, 0, 0, 1];
          }
        }
        style = new Style({
          stroke: new Stroke({
            color: strokeColor,
            width: 1,
          }),
          fill: new Fill({
            color: fillColor,
          }),
        });
        return style;
      }
    },
    styleCYFunction(feature){
      let style;
      let fillColor = [0, 0, 0, 0];
      let strokeColor = [0, 0, 0, 0];
      let metadata = feature.values_;
      let highest_level = this.cropArea.HEIGHT_AREA / 5;
      let percentage,sectname,sectid,townid,townname;
      //geojson區段名稱整理
      if(metadata.SECT_NAME.includes(".")){
        sectid = metadata.SECT_NAME.split(".")[0]
        sectname = metadata.SECT_NAME.split(".")[1];
      }
      else {
        sectid = "";
        sectname = metadata.SECT_NAME;
      }
      
      //因geojson的區段名稱有些會短少及型態不同，因此以資料表區段為主，此處做比對
      if(metadata.TOWN.includes('.')){
        let masecindex1 = this.MasecList.findIndex(
          (x) => x.TOWN_ID == metadata.TOWN.split(".")[0] 
        )
        if(masecindex1 != -1){
          townid = this.MasecList[masecindex1].TOWN_ID;
          townname = this.MasecList[masecindex1].TOWN;
        }
        else{
          townid = metadata.TOWN.split(".")[0];
          townname = metadata.TOWN.split(".")[1];
        } 
      }
      else{
        let masecindex = this.MasecList.findIndex(
          (x) => x.TOWN == metadata.TOWN 
        )
        if(masecindex != -1){
          townid = this.MasecList[masecindex].TOWN_ID;
          townname = this.MasecList[masecindex].TOWN;
        }
      }
            
      //比對geojson區段名稱是否在cropsectorlist內
      if(sectid != ""){
        let index = this.cropsectorlist.findIndex(
        (x) => x.ANA_SECTI_ID == sectid && x.SECT_NAME.includes(sectname) && x.TOWN.includes(metadata.TOWN)
        );
        if (index != -1){

          let subindex = this.townList.findIndex(
            (x) => x.value == townid
          );
          
          if(subindex == -1){
            this.townList.push({value:townid,text:townname});
          }
          if(this.townSelect.includes(townid))
          {
            //let area = parseInt(this.cropsectorlist[index].AREA_P);
          if (this.cropsectorlist[index].AREA_P == 0) percentage = 0;
          else if (this.cropsectorlist[index].AREA_P < highest_level) percentage = 0.2;
          else if (this.cropsectorlist[index].AREA_P < highest_level * 2) percentage = 0.4;
          else if (this.cropsectorlist[index].AREA_P < highest_level * 3) percentage = 0.6;
          else if (this.cropsectorlist[index].AREA_P < highest_level * 4) percentage = 0.7;
          else if (this.cropsectorlist[index].AREA_P <= highest_level * 5) percentage = 0.9;
          fillColor = [29, 151, 108, percentage];
          strokeColor = [0, 0, 0, 1];
          }
          this.percentage = percentage;
          //console.log("this.SelectFillColor , fillColor",this.SelectFillColor,fillColor);
          style = new Style({
            stroke: new Stroke({
              color: strokeColor,
              width: 1,
            }),
            fill: new Fill({
              color: fillColor,
            }),
          });
          return style;
        }
      }
      else{
        let index = this.cropsectorlist.findIndex(
        (x) => x.SECT_NAME.includes(sectname) && x.TOWN.includes(metadata.TOWN)
        );
        if (index != -1){

          let subindex = this.townList.findIndex(
            (x) => x.value == townid
          );
          
          if(subindex == -1){
            this.townList.push({value:townid,text:townname});
          }
          if(this.townSelect.includes(townid))
          {
            //let area = parseInt(this.cropsectorlist[index].AREA_P);
          if (this.cropsectorlist[index].AREA_P == 0) percentage = 0;
          else if (this.cropsectorlist[index].AREA_P < highest_level) percentage = 0.2;
          else if (this.cropsectorlist[index].AREA_P < highest_level * 2) percentage = 0.4;
          else if (this.cropsectorlist[index].AREA_P < highest_level * 3) percentage = 0.6;
          else if (this.cropsectorlist[index].AREA_P < highest_level * 4) percentage = 0.7;
          else if (this.cropsectorlist[index].AREA_P <= highest_level * 5) percentage = 0.9;
          fillColor = [29, 151, 108, percentage];
          strokeColor = [0, 0, 0, 1];
          }
          this.percentage = percentage;
          //console.log("this.SelectFillColor1 , fillColor1",this.SelectFillColor,fillColor);
          style = new Style({
            stroke: new Stroke({
              color: strokeColor,
              width: 1,
            }),
            fill: new Fill({
              color: fillColor,
            }),
          });
          return style;
        }
      }
    },
    stylePDFunction(feature) {
      let style;
      let fillColor = [0, 0, 0, 0];
      let strokeColor = [0, 0, 0, 0];
      if (this.pestsAndDiseases.cropdata.length > 0) {
        let townID = feature.values_.TOWNID;
        let countryID = feature.values_.COUNTYID;

        let subindex = this.pestsAndDiseases.cropdata.findIndex(
          (x) => x.ANA_TOWN_ID == townID
        );

        if (subindex != -1) {
          let result = this.pestsAndDiseases.PDobject.publish.findIndex(
            (x) => x.split(",")[1] == countryID
          );
          let highest_level;
          if (result != -1) {
            highest_level = this.pestsAndDiseases.publishhightestarea / 5;
          } else {
            highest_level = this.pestsAndDiseases.unpublishhightestarea / 5;
          }

          let percentage;
          if (this.pestsAndDiseases.cropdata[subindex].AREA_H < highest_level)
            percentage = 0.2;
          else if (
            this.pestsAndDiseases.cropdata[subindex].AREA_H <
            highest_level * 2
          )
            percentage = 0.4;
          else if (
            this.pestsAndDiseases.cropdata[subindex].AREA_H <
            highest_level * 3
          )
            percentage = 0.6;
          else if (
            this.pestsAndDiseases.cropdata[subindex].AREA_H <
            highest_level * 4
          )
            percentage = 0.7;
          else if (
            this.pestsAndDiseases.cropdata[subindex].AREA_H <=
            highest_level * 5
          )
            percentage = 0.9;
          if (result != -1) {
            fillColor = [63, 81, 181, percentage];
          } else {
            fillColor = [255, 152, 0, percentage];
          }
          strokeColor = [0, 0, 0, 1];
        }
      }
      style = new Style({
        stroke: new Stroke({
          color: strokeColor,
          width: 1,
        }),
        fill: new Fill({
          color: fillColor,
        }),
      });
      return style;
    },
    stylePDFunction2(feature) {
      let style;
      let fillColor = [0, 0, 0, 0];
      let strokeColor = [0, 0, 0, 0];
      if (this.pestsAndDiseases2.cropdata.length > 0) {
        let townID = feature.values_.TOWNID;
        //let countryID = feature.values_.COUNTYID;

        let subindex = this.pestsAndDiseases2.cropdata.findIndex(
          (x) => x.AGRI_INFO.ANA_TOWN_ID == townID
        );

        if (subindex != -1) {
          //let highest_level;

          //highest_level = this.pestsAndDiseases2.publishhightestarea / 5;

          //let percentage;
          //if (
            //  this.pestsAndDiseases2.cropdata[subindex].AGRI_INFO.AREA_H <
            //  highest_level
            //)
          //  percentage = 0.2;
            //else if (
            //  this.pestsAndDiseases2.cropdata[subindex].AGRI_INFO.AREA_H <
            //  highest_level * 2
            //)
          //  percentage = 0.4;
            //else if (
            //  this.pestsAndDiseases2.cropdata[subindex].AGRI_INFO.AREA_H <
            //  highest_level * 3
            //)
          //  percentage = 0.6;
            //else if (
            //  this.pestsAndDiseases2.cropdata[subindex].AGRI_INFO.AREA_H <
            //  highest_level * 4
            //)
          //  percentage = 0.7;
            //else if (
            //  this.pestsAndDiseases2.cropdata[subindex].AGRI_INFO.AREA_H <=
            //  highest_level * 5
            //)
          //  percentage = 0.9;

          //if (this.pestsAndDiseases2.type == "danger")
          //fillColor = [63, 81, 181, percentage];
            //else fillColor = [255, 152, 0, percentage];
          //     fillColor = [255, 152, 0, percentage];
          if(this.pestsAndDiseases2.type.includes("葉稻熱病")){
            if(this.pestsAndDiseases2.warning_lavel == 4){
              fillColor = [220, 56, 72,0.6];
              this.pestsAndDiseases2.fillColor =[220, 56, 72,0.6];
            }
            else if(this.pestsAndDiseases2.warning_lavel == 3){
              fillColor= [255, 193, 5,0.6];
              this.pestsAndDiseases2.fillColor =[255, 193, 5,0.6];
            }
            else if(this.pestsAndDiseases2.warning_lavel == 2){
              fillColor = [0, 123, 255,0.6];
              this.pestsAndDiseases2.fillColor =[0, 123, 255,0.6];
            }
            else {
              fillColor = [41, 168, 71,0.6];
              this.pestsAndDiseases2.fillColor =[41, 168, 71,0.6];
            }
          }
          else{
            if(this.pestsAndDiseases2.warning_lavel == 3){
              fillColor = [220, 56, 72,0.6];
              this.pestsAndDiseases2.fillColor =[220, 56, 72,0.6];
            }
            else if(this.pestsAndDiseases2.warning_lavel == 2){
              fillColor = [0, 123, 255,0.6];
              this.pestsAndDiseases2.fillColor =[0, 123, 255,0.6];
            }
            else {
              fillColor = [41, 168, 71,0.6];
              this.pestsAndDiseases2.fillColor =[41, 168, 71,0.6];
            }
          }
          
          strokeColor = [0, 0, 0, 1];
        }
      }
      //fillColor = [63, 81, 181, 1];

      style = new Style({
        stroke: new Stroke({
          color: strokeColor,
          width: 1,
        }),
        fill: new Fill({
          color: fillColor,
        }),
      });
      return style;
    },
    tabChangeEvent(tabindex) {
      switch (tabindex) {
        // case 0:
        //   this.cropInfoShow = true;
        //   this.isFoodItemSelected = false;
        //   break;
        case 0:
          // this.cropInfoShow = false;
          // if(this.firstClick){
          //   this.firstClick = false;
          //   this.warningMap.setVisible(true);
          //   this.isFoodItemSelected = true;
          // }
          break;
        default:
          break;
      }
    },
    /*      <summary>
         地圖初始化
        </summary>*/
    mapInit: function() {
      for (var item in this.mapForVisible) {
        this.MapLayers.layers.push(this.mapForVisible[item]);
      }
      setTimeout(() => {
        // var Height =
        //   window.innerHeight -
        //   document.getElementsByClassName("head")[0].offsetHeight;
        var Height = window.innerHeight - 74;
        // 右側menu高度
        document.getElementsByClassName("gis-menu")[0].style.height =
          Height + "px";
        // 需要固定高度
        document.getElementById("map").style.height = Height + "px";
        // 需要固定高度
        this.mapCreate();
        // 生成選擇層
        this.selectCreate();
      }, 100);
    },
    /*      <summary>
        建置地圖
        </summary>*/
    mapCreate: function() {
      this.map = new Map({
        target: "map",
        controls: [],
        layers: this.MapLayers.layers,
        view: this.MapView,
      });
    },
    /*      <summary>
        重整地圖大小
        </summary>*/
    mapResize() {
      setTimeout(() => {
        this.map.updateSize();
      }, 100);
    },
    // toggleMap: function() {
    //   this.mapToggleShow = !this.mapToggleShow;
    //   this.MapLayers.layers[0].setVisible(!this.mapToggleShow);
    //   this.MapLayers.layers[1].featuresetVisible(this.mapToggleShow);
    // },
    /*      <summary>
        切換底圖
        </summary>*/
    changeMap() {
      if (this.mapselected == "EMAPX99") {
        //切換至臺灣通用電子地圖
        this.MapLayers.layers[0].setVisible(true);
        this.MapLayers.layers[1].setVisible(false);
        this.MapLayers.layers[2].setVisible(false);
      } else if (this.mapselected == "EMAP9") {
        //臺灣通用電子地圖(無鐵公路)
        this.MapLayers.layers[0].setVisible(false);
        this.MapLayers.layers[1].setVisible(true);
        this.MapLayers.layers[2].setVisible(false);
      } else if (this.mapselected == "PHOTO2") {
        //正射影像圖(通用)
        this.MapLayers.layers[0].setVisible(false);
        this.MapLayers.layers[1].setVisible(false);
        this.MapLayers.layers[2].setVisible(true);
      }
    },
    /*      <summary>
    地圖放大與縮小功能
    </summary>
    <param "count">點擊次數</param>*/
    customZoom(count) {
      var num = count == "plus" ? 1 : -1;
      this.map.getView().animate({
        zoom: this.map.getView().getZoom() + num,
        duration: 250,
      });
    },
    /*      <summary>
      導引至地圖上特定位置
      </summary>*/
    toPosition: function() {
      this.map.getView().animate({
        center: fromLonLat([120.15, 23.473323877771172]),
        zoom: 10,
        duration: 450,
      });
    },
    /*      <summary>
        生成圖層
        </summary>*/
    selectCreate: function() {
      //console.log("selectCreate is called");
      this.selectClick = new Select({
        condition: click,
      });
      this.map.addInteraction(this.selectClick); //要使用原預設值時啟用
      this.selectClick.on("select", this.selectClickfunction);
      // var me = this;
      // this.selectClick.on('select', function(e) {
      //   e.target.getFeatures().forEach(function(feature) {
      //     var layer = me.selectClick.getLayer(feature);
      //     let name = layer.get('name');
      //   });
      // });
      this.map.on("pointermove", function(evt) {
        var hit = this.forEachFeatureAtPixel(evt.pixel, function() {
          return true;
        });
        if (hit) {
          //改變滑鼠型態為pointer
          this.getTargetElement().style.cursor = "pointer";
        } else {
          this.getTargetElement().style.cursor = "";
        }
      });
    },
    changeStleByChart(item) {
      for (let i in this.cropMap.values_.source.uidIndex_) {
        let id = this.cropMap.values_.source.uidIndex_[i].values_.TOWNID;
        if (this.geoselect.includes(id)) {
          //console.log([item, id]);
          if (item.ANA_TOWN_ID == id) {
            let colorfill = this.getcolorfill(
              this.cropMap.values_.source.uidIndex_[i]
            );
            let newstyle = new Style({
              stroke: new Stroke({
                color: "#007bff",
                width: 3,
              }),
              fill: new Fill({
                color: colorfill,
              }),
            });
            this.cropMap.values_.source.uidIndex_[i].setStyle(newstyle);
          } else {
            let colorfill = this.getcolorfill(
              this.cropMap.values_.source.uidIndex_[i]
            );
            let newstyle = new Style({
              stroke: new Stroke({
                color: [0, 0, 0, 1],
                width: 1,
              }),
              fill: new Fill({
                color: colorfill,
              }),
            });
            this.cropMap.values_.source.uidIndex_[i].setStyle(newstyle);
          }
        }
      }
    },
    changeTaiwanStleByChart(item) {
      for (let i in this.cropMapAll.values_.source.uidIndex_) {
        let id = this.cropMapAll.values_.source.uidIndex_[i].values_.TOWNID;
        if (this.geoselect.includes(id)) {
          //console.log([item, id]);
          if (item.ANA_TOWN_ID == id) {
            let colorfill = this.getcolorfill(
              this.cropMapAll.values_.source.uidIndex_[i]
            );
            let newstyle = new Style({
              stroke: new Stroke({
                color: "#007bff",
                width: 3,
              }),
              fill: new Fill({
                color: colorfill,
              }),
            });
            this.cropMapAll.values_.source.uidIndex_[i].setStyle(newstyle);
          } else {
            let colorfill = this.getcolorfill(
              this.cropMapAll.values_.source.uidIndex_[i]
            );
            let newstyle = new Style({
              stroke: new Stroke({
                color: [0, 0, 0, 1],
                width: 1,
              }),
              fill: new Fill({
                color: colorfill,
              }),
            });
            this.cropMapAll.values_.source.uidIndex_[i].setStyle(newstyle);
          }
        }
      }
    },
    getvolume(data) {
      return Math.floor((data / 1000) * 100) / 100 || "0";
    },
    selectClickfunction: function(e) {
      if (e.target.getFeatures().getArray()[0] !== undefined) {
        if (e.target.getFeatures().getArray()[0].values_ !== undefined) {
          var name;
          //console.log(e.target.getFeatures().getArray()[0].values_);
          e.target.getFeatures().forEach((feature) => {
            var layer = this.selectClick.getLayer(feature);//原select顏色style為預設值
            //var layer = this.selectInteraction.getLayer(feature); //新-區塊選擇自訂style
            //console.log(layer);
            name = layer.get("name");
          });
          //設定warning
          if (name == "warning") {
            let tID = e.target.getFeatures().getArray()[0].values_.TOWNID;
            //console.log("tID",tID);
            let tName = e.target.getFeatures().getArray()[0].values_.TOWNNAME;
            this.AREA_P = this.AREA_PList[tID];
            this.AREA_P_ID = tID;
            this.warningTownName = tName;
            this.warningValueList = [];
            if (this.foodseleted.Note == "2") {
              if (
                this.warningAllLists[this.selected].ANA_TOWN_ID.includes(tID)
              ) {
                this.FunctionToken(this.getFeohnValue, { town: tID });
              }
            } else if (
              this.foodseleted.Note == "3" ||
              this.foodseleted.Note == "4" ||
              this.foodseleted.Note == "5"
            ) {
              if (this.warningValueList_345[tID]) {
                this.warningValueList = this.warningValueList_345[tID];
                this.FunctionToken(this.getHistoryList, {
                  note: this.foodseleted.Note,
                  town: tID,
                  crop: this.foodseleted.C_NAME,
                });
              }
            } else if (this.foodseleted.Note == "6") {
              if (
                this.warningAllLists[this.selected].ANA_TOWN_ID.includes(tID)
              ) {
                this.FunctionToken(this.getDrop, { town: tID });
              }
            } else if (
              this.foodseleted.Note == "7" ||
              this.foodseleted.Note == "8" ||
              this.foodseleted.Note == "9" ||
              this.foodseleted.Note == "10"
            ) {
              if (
                this.warningAllLists[this.selected].ANA_TOWN_ID.includes(tID)
              ) {
                this.FunctionToken(this.getTempture, {
                  note: this.selected.substring(0, this.selected.indexOf("_")),
                  town: tID,
                });
              }
            }

            let percentage,fillColor;
            if (this.warningTown.includes(tID) && this.AREA_PList[tID]) {
              let highest_level = this.cityHeight / 5;
              if (this.AREA_PList[tID] == 0 || !this.AREA_PList[tID])
                percentage = 0;
              else if (this.AREA_PList[tID] < highest_level) percentage = 0.2;
              else if (this.AREA_PList[tID] < highest_level * 2)
                percentage = 0.4;
              else if (this.AREA_PList[tID] < highest_level * 3)
                percentage = 0.6;
              else if (this.AREA_PList[tID] < highest_level * 4)
                percentage = 0.7;
              else if (this.AREA_PList[tID] <= highest_level * 5)
                percentage = 0.9;
              fillColor = [234, 56, 77, percentage];
            }
            e.selected[0].setStyle(new Style({
              stroke: new Stroke({
                color: [0, 153, 255, 1],
                width: 3,
              }),
              fill: new Fill({
                  color: fillColor,
              }),
              zIndex: 10000,
            }));
          } 
          //
          else if (name == "tradeWarning") {
            let tID = e.target.getFeatures().getArray()[0].values_.TOWNID;
            let tName = e.target.getFeatures().getArray()[0].values_.TOWNNAME;
            this.tradeWarningInfo.townName = tName;
            if (this.tradeWarningAreaValue[tID]) {
              this.tradeWarningInfo.AREA_H = this.tradeWarningAreaValue[
                tID
              ].AREA_H;
              this.tradeWarningInfo.AREA_P = this.tradeWarningAreaValue[
                tID
              ].AREA_P;
              this.tradeWarningInfo.RATE_H = this.tradeWarningAreaValue[
                tID
              ].RATE_H;
              this.tradeWarningInfo.HARVEST = this.tradeWarningAreaValue[
                tID
              ].HARVEST;
            } else {
              this.tradeWarningInfo.AREA_H = 0;
              this.tradeWarningInfo.AREA_P = 0;
              this.tradeWarningInfo.RATE_H = 0;
              this.tradeWarningInfo.HARVEST = 0;
            }
          } 
          else if (name == "pestnoticewarning") {
            let tID = e.target.getFeatures().getArray()[0].values_.TOWNID;
            // let tName = e.target.getFeatures().getArray()[0].values_.TOWNNAME;
            let cropID = this.pestsAndDiseases.PDobject.cropname.split(",")[1];
            let subindex = this.pestsAndDiseases.cropdata.findIndex(
              (x) => x.ANA_C_ID == cropID && x.ANA_TOWN_ID == tID
            );
            if (subindex != -1) {
              let subitem = this.pestsAndDiseases.cropdata[subindex];
              this.pestsAndDiseases.PDobject.detial = {
                title: subitem.A_YEAR + "．" + subitem.PERIOD,
                place: subitem.TOWN,
                items: [
                  {
                    收穫面積: subitem.AREA_H + " 公頃",
                    種植面積: subitem.AREA_P + " 公頃",
                    每公頃收穫量: subitem.RATE_H + " 公斤",
                    收量: this.getvolume(subitem.HARVEST) + " 公噸",
                  },
                ],
              };
            }
          } 
          else if (name == "pestandDieaseMap") {
            let tID = e.target.getFeatures().getArray()[0].values_.TOWNID;
            //let tName = e.target.getFeatures().getArray()[0].values_.TOWNNAME;
            // let item = this.pestsAndDiseases2.selected.split("&%$");
            let subindex = this.pestsAndDiseases2.cropdata.findIndex(
              (x) => x.AGRI_INFO.ANA_TOWN_ID == tID
            );
            if (subindex != -1) {
              let subitem = this.pestsAndDiseases2.cropdata[subindex].AGRI_INFO;
              this.pestsAndDiseases2.PDobject2.detial = {
                title: subitem.A_YEAR + "．" + subitem.PERIOD,
                place: subitem.TOWN,
                items: [
                  {
                    收穫面積: subitem.AREA_H + " 公頃",
                    種植面積: subitem.AREA_P + " 公頃",
                    每公頃收穫量: subitem.RATE_H + " 公斤",
                    收量: this.getvolume(subitem.HARVEST) + " 公噸",
                  },
                ],
              };
              this.pestsAndDiseases2.PDobject2.weather = this.pestsAndDiseases2.cropdata[
                subindex
              ].WEATHER_INFO;
              //let isBule = [0, 123, 255,0.6];
              //console.log("this.pestsAndDiseases2.fillColor",this.pestsAndDiseases2.fillColor,this.pestsAndDiseases2.fillColor[0] == 0 && this.pestsAndDiseases2.fillColor[1] ==123 && this.pestsAndDiseases2.fillColor[2]==255);
              if(this.pestsAndDiseases2.fillColor[0] == 0 && this.pestsAndDiseases2.fillColor[1] ==123 && this.pestsAndDiseases2.fillColor[2]==255){
                e.selected[0].setStyle(new Style({
                  stroke: new Stroke({
                    color: [0, 255, 255, 1],
                    width: 3,
                  }),
                  fill: new Fill({
                      color: this.pestsAndDiseases2.fillColor,
                  }),
                  zIndex: 10000,
                }));
              }
              else{
                e.selected[0].setStyle(new Style({
                  stroke: new Stroke({
                    color: [0, 153, 255, 1],
                    width: 3,
                  }),
                  fill: new Fill({
                      color: this.pestsAndDiseases2.fillColor,
                  }),
                  zIndex: 10000,
                }));
              }
              
              // this.pestsAndDiseases2.PDobject2.date = this.pestsAndDiseases2.cropdata[
              //   subindex
              // ].AGRI_INFO.ANA_DATE.split("T")[0];
            }
          }//設定選取後的stoke及fill color
          else if (name == "cropMapAll"){
            let data = e.target.getFeatures().getArray()[0].values_;
            //console.log("cropMapAll data",data.TOWNID);
            let townID = data.TOWNID,percentage,fillColor;
            if (
              this.cropAreaSelected.includes(townID) &&
              this.geoselect.includes(townID)
            ) {
              let highest_level = this.cropArea.HEIGHT_AREA / 5;
              if (this.areaValue[townID].AREA_H < highest_level) percentage = 0.2;
              else if (this.areaValue[townID].AREA_H < highest_level * 2)
                percentage = 0.4;
              else if (this.areaValue[townID].AREA_H < highest_level * 3)
                percentage = 0.6;
              else if (this.areaValue[townID].AREA_H < highest_level * 4)
                percentage = 0.7;
              else if (this.areaValue[townID].AREA_H <= highest_level * 5)
                percentage = 0.9;
              fillColor = [29, 151, 108, percentage];
            }
            e.selected[0].setStyle(new Style({
              stroke: new Stroke({
                color: [0, 153, 255, 1],
                width: 3,
              }),
              fill: new Fill({
                  color: fillColor,
              }),
              zIndex: 10000,
            }));
          }
          else if (name == "germmap") {
            //console.log("germmap",e.target.getFeatures().getArray()[0].values_);
            let data = e.target.getFeatures().getArray()[0].values_;
            let index = this.cropsectorlist.findIndex(
              (x) => x.SECT_NAME == data.SECT_NAME && x.TOWN == data.TOWN
            );
            if (index != -1) {
              let crop = this.cropsectorlist[index];
              this.cropInfo2.townName = crop.TOWN.split(".")[1];
              this.cropInfo2.sectorName = crop.SECT_NAME.split(".")[1];
              this.cropInfo2.area_P = crop.AREA_P;
              this.cropInfo2.area_I = crop.AREA_I;
              this.cropInfo2.area_O = crop.AREA_O;
              this.cropInfo2.area_NH = crop.AREA_NH;
            }
          }//設定germCYmap
          else if (name == "germCYmap") {
            //console.log("germCYmap:e.target.getFeatures().getArray()[0].values_",e.target.getFeatures().getArray()[0].values_);
            let data = e.target.getFeatures().getArray()[0].values_;
            let index = this.cropsectorlist.findIndex(
              (x) => x.SECT_NAME.includes(data.SECT_NAME) && x.TOWN.includes(data.TOWN)
            );
            this.cropInfo3.year = "";
            this.cropInfo3.cropName = "";
            this.cropInfo3.period = "";
            this.cropInfo3.townName = "";
            this.cropInfo3.sectorName = "";
            this.cropInfo3.area_situation= "";
            this.cropInfo3.area_P = "";
            this.cropInfo3.area_I = "";
            this.cropInfo3.area_O = "";
            this.cropInfo3.area_NH = "";

            if (index != -1) {
              let crop = this.cropsectorlist[index];
              this.cropInfo3.cropName = crop.CROP;
              this.cropInfo3.year= this.CYyearSelected;
              this.cropInfo3.period =this.CYperiodSelected;
              this.cropInfo3.townName = crop.TOWN.split(".")[1];
              this.cropInfo3.sectorName = crop.SECT_NAME.split(".")[1];
              this.cropInfo3.area_situation = crop.AREA_SITUATION;
              this.cropInfo3.area_P = crop.AREA_P;
              this.cropInfo3.area_I = crop.AREA_I;
              this.cropInfo3.area_O = crop.AREA_O;
              this.cropInfo3.area_NH = crop.AREA_NH;
            }
            e.selected[0].setStyle(new Style({
              stroke: new Stroke({
                color: [0, 153, 255, 1],
                width: 3,
              }),
              fill: new Fill({
                  color: this.getColor(this.cropInfo3.area_P),
              }),
              zIndex: 10000,
            }));

          }//設定SectCheckMap
          else if(name == "SectCheckMap"){
            let data = e.target.getFeatures().getArray()[0].values_;
            this.Selecttownsect = data.SECT_NAME;
            if(data.TOWN.includes('.')){
              let TOWNNAME = data.TOWN.split('.')[1];
              this.SectInfo.townname = TOWNNAME;
              if(data.SECT_NAME.includes('.')){
                let secnameid = data.SECT_NAME.split('.')[0];
                //console.log("secnameid",secnameid);
                let index = this.MasecList.findIndex(
                  (x) => x.TOWN == TOWNNAME && x.MASEC_ID == secnameid);
                if(index !=-1){
                  this.SectInfo.sectname = this.MasecList[index].MASEC_NAME;
                }
                else{
                  let indexsec = this.MasecList.findIndex(
                  (x) => x.TOWN == TOWNNAME && x.MASEC_ID.includes(data.SECT_NAME.split('.')[0]));
                  if(indexsec != -1 ){
                    this.SectInfo.sectname = this.MasecList[indexsec].MASEC_NAME;
                  }
                  else{
                    this.SectInfo.sectname = data.SECT_NAME;
                  }
                }
              }
              else{
                let secname = data.SECT_NAME;
                //console.log("secname",secname);
                let index = this.MasecList.findIndex(
                  (x) => x.TOWN == TOWNNAME && x.MASEC_NAME.includes(secname));
                if(index !=-1){
                  this.SectInfo.sectname = this.MasecList[index].MASEC_NAME;
                  this.SectInfo.townname = TOWNNAME;
                }
              }
              
            }
            else{
              let TOWNNAME = data.TOWN;
              this.SectInfo.townname = TOWNNAME;
              //console.log("TOWNNAME",TOWNNAME);
              if(data.SECT_NAME.includes('.')){
                let secnameid = data.SECT_NAME.split('.')[0];
                //console.log("secnameid",secnameid);
                let index = this.MasecList.findIndex(
                  (x) => x.TOWN == TOWNNAME && x.MASEC_ID == secnameid);
                if(index !=-1){
                  this.SectInfo.sectname = this.MasecList[index].MASEC_NAME;
                }
                else{
                  let indexsec = this.MasecList.findIndex(
                  (x) => x.TOWN == TOWNNAME && x.MASEC_ID.includes(data.SECT_NAME.split('.')[0]));
                  if(indexsec != -1 ){
                    this.SectInfo.sectname = this.MasecList[indexsec].MASEC_NAME;
                  }
                  else{
                    this.SectInfo.sectname = data.SECT_NAME;
                  }
                }
              }
              else{
                let secname = data.SECT_NAME;
                //console.log("secname",secname);
                let index = this.MasecList.findIndex(
                  (x) => x.TOWN == TOWNNAME && x.MASEC_NAME.includes(secname));
                if(index !=-1){
                  this.SectInfo.sectname = this.MasecList[index].MASEC_NAME;
                  this.SectInfo.townname = TOWNNAME;
                }
              }
            }
            e.selected[0].setStyle(new Style({
              stroke: new Stroke({
                color: [0, 153, 255, 1],
                width: 3,
              }),
              fill: new Fill({
                  color: [147, 115, 216, 0.9],
              }),
              zIndex: 10000,
            }));
          }//設定SectSubCheckMap
          else if(name == "SectSubCheckMap"){
            let data = e.target.getFeatures().getArray()[0].values_;
            //console.log("data:",data)
            let TOWNNAME = data.TOWNNAME;
            this.SectSubInfo.townname = TOWNNAME;
            if(data.MASEC.includes('.')){
              let indexsec = this.MasecList.findIndex(
                (x) => x.TOWN == TOWNNAME && x.MASEC_NAME.includes(data.MASEC.split('.')[1])
              );
              if(indexsec != -1){
                this.SectSubInfo.sectname = this.MasecList[indexsec].MASEC_NAME;
              }
              else this.SectSubInfo.sectname = data.MASEC.split('.')[1];
            }
            else{
              let indexsec = this.MasecList.findIndex(
                (x) => x.TOWN == TOWNNAME && x.MASEC_NAME.includes(data.MASEC)
              );
              if(indexsec != -1){
                this.SectSubInfo.sectname = this.MasecList[indexsec].MASEC_NAME;
              }
              else this.SectSubInfo.sectname = data.MASEC;
            }
            this.SectSubInfo.sectsubname = data.MISEC_NAME;
            e.selected[0].setStyle(new Style({
              stroke: new Stroke({
                color: [0, 153, 255, 1],
                width: 3,
              }),
              fill: new Fill({
                  color: [29, 151, 108, 0.9],
              }),
              zIndex: 10000,
            }));
          }
          else {
            let tID = e.target.getFeatures().getArray()[0].values_.TOWNID;
            let tName = e.target.getFeatures().getArray()[0].values_.TOWNNAME;
            this.cropInfo.townName = tName;
            let survey = this.cropArea.BA_AGRI_SURVEY
              ? this.cropArea.BA_AGRI_SURVEY
              : this.cropArea.AGRI_SURVEY_TAIWAN;
            let index = survey.findIndex(
              (item) => item.TOWN == this.cropInfo.townName
            );
            let obj = { ANA_TOWN_ID: tID };
            this.changeStleByChart(obj);
            this.$nextTick(() => {
              let id = survey[index].ANA_TOWN_ID;
              let cropindex = this.geoselect.findIndex((x) => x == id);
              this.chartobj.changeBarSelection(cropindex);
            });
            if (this.areaValue[tID]) {
              this.cropInfo.AREA_H = this.areaValue[tID].AREA_H;
              this.cropInfo.AREA_P = this.areaValue[tID].AREA_P;
              this.cropInfo.RATE_H = this.areaValue[tID].RATE_H;
              this.cropInfo.HARVEST = this.areaValue[tID].HARVEST;
            } else {
              this.cropInfo.AREA_H = 0;
              this.cropInfo.AREA_P = 0;
              this.cropInfo.RATE_H = 0;
              this.cropInfo.HARVEST = 0;
            }
          }
        }
      }
    },
    getDrop(data) {
      this.apiGetDrop(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.warningValueList = jsonData;
            this.warningValueList["List"] = jsonData;
            this.warningValueList["ANA_TOWN_ID"] = this.AREA_P_ID;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getTempture(data) {
      this.apiGetTempture(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.warningValueList = jsonData;
            this.warningValueList["List"] = jsonData;
            this.warningValueList["ANA_TOWN_ID"] = this.AREA_P_ID;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    /*      <summary>
        取得焚風的影響數值
        //  </summary>
        <param "data">城鎮的代碼"tID"</param>
         */
    getFeohnValue(data) {
      this.apiGetFeohnValue(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.warningValueList = jsonData[0];
            this.warningValueList["ANA_TOWN_ID"] = this.AREA_P_ID;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    /*  <summary>
        取得歷史紀錄清單
        </summary>
        <param "data">Object with three property:Note, tID, C_NAME</param>
        <property "Note">災害代碼</property>
        <property "tID">程式代碼</property>
        <property "C_NAME">農場名稱</property>
         */
    getHistoryList(data) {
      this.apiGetHistoryList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.historyLists = jsonData;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    /*
      <summary>
      取得嘉義農情調查有紀錄的作物列表--Zanna 
      </summary>
      <param "data"></param>
    */
    toGetCropList(data){
      this.apiGetCYCropList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.CY_croplist = ["請選擇農情作物"];
            this.CYcropSelected = "請選擇農情作物";
            for(let i = 0; i < jsonData.length ; i++){
                this.CY_croplist.push(jsonData[i].CROP);
            }
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    /*     <summary>
        取得有紀載農務年份的資料
        </summary>
        <param "data"></param>
         */
    toGetCropYear() {
      this.FunctionToken(this.getCropYearChange, {});
    },
    /*原嘉義農情搜尋
    getCropYear(data) {
      this.apiGetCropYear(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.yearPeriodList = jsonData;
            let tempYear = [];
            let list = [];
            for (let i = 0; i < jsonData.length; i++) {
              tempYear.push(jsonData[i].A_YEAR);
              let period = jsonData[i].PERIOD.split(",");
              list[jsonData[i].A_YEAR] = period;
              if (i == 0) {
                this.yearSelected = jsonData[i].A_YEAR;
                this.periodList = [];
                let array = jsonData[i].PERIOD.split(",");
                let first = true;
                let rawList = ["全年", "一期作", "二期作", "裡作"];
                for (let j = 0; j < array.length; j++) {
                  if (rawList.includes(array[j])) {
                    this.periodList.push(array[j]);
                    if (first) {
                      this.periodSelected = array[j];
                      first = false;
                    }
                  }
                }
              }
            }
            this.yearPeroidList = list;
            this.yearList = tempYear;
            this.changeCropList();
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },*/
    getCropYearChange(data) {
      this.apiGetCropYearAll(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.yearPeriodListAll = jsonData;
            let tempYear = [];
            let list = [];
            for (let i = 0; i < jsonData.length; i++) {
              tempYear.push(jsonData[i].A_YEAR);
              let period = jsonData[i].PERIOD.split(",");
              list[jsonData[i].A_YEAR] = period;
              if (i == 0) {
                this.yearSelectedAll = jsonData[i].A_YEAR;
                this.periodListAll = [];
                let array = jsonData[i].PERIOD.split(",");
                let first = true;
                let rawList = ["全年", "一期作", "二期作", "裡作"];
                for (let j = 0; j < array.length; j++) {
                  if (rawList.includes(array[j])) {
                    this.periodListAll.push(array[j]);
                    if (first) {
                      this.periodSelectedAll = array[j];
                      first = false;
                    }
                  }
                }
              }
            }
            this.yearPeroidListAll = list;
            this.yearListAll = tempYear;
            this.changeCropListAll();
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getCropYearAll(data) {
      this.apiGetCropYearAll(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.yearPeriodListAll = jsonData;
            let tempYear = [];
            let list = [];
            for (let i = 0; i < jsonData.length; i++) {
              tempYear.push(jsonData[i].A_YEAR);
              let period = jsonData[i].PERIOD.split(",");
              list[jsonData[i].A_YEAR] = period;
              if (i == 0) {
                this.yearSelectedAll = jsonData[i].A_YEAR;
                this.periodListAll = [];
                let array = jsonData[i].PERIOD.split(",");
                let first = true;
                let rawList = ["全年", "一期作", "二期作", "裡作"];
                for (let j = 0; j < array.length; j++) {
                  if (rawList.includes(array[j])) {
                    this.periodListAll.push(array[j]);
                    if (first) {
                      this.periodSelectedAll = array[j];
                      first = false;
                    }
                  }
                }
              }
            }
            this.yearPeroidListAll = list;
            this.yearListAll = tempYear;
            this.changeCropListAll();
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    /*     <summary>
        取得年度期作作物列表
        </summary>
        <param "data">Object with two property:year, period</param>
        <property "year">年份</property>
        <property "period">期</property>
         */
    getCropList(data) {
      this.apiGetCropList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.cropList = ["請選擇農情作物"];
            this.cropSelected = "請選擇農情作物";
            for (var i = 0; i < jsonData.length; i++) {
              this.cropList.push(jsonData[i].CROP);
            }
            this.cropLists[
              this.yearSelected + "_" + this.periodSelected
            ] = this.cropList;
            this.$forceUpdate();
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getCropListAll(data) {
      this.apiGetCropListAll(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.cropListAll = ["請選擇農情作物"];
            this.cropSelectedAll = "請選擇農情作物";
            for (var i = 0; i < jsonData.length; i++) {
              this.cropListAll.push(jsonData[i].CROP);
            }
            this.cropListsAll[
              this.yearSelectedAll + "_" + this.periodSelectedAll
            ] = this.cropListAll;
            this.$forceUpdate();
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    /*
      <summary>
        選擇作物後-更新年度列表
      </summary>
    */
    changeCYCropYear() {
      //console.log("changeCYCropYear method called with CYcropSelected:",this.CYcropSelected);
      if(this.CYcropSelected != null){
        this.CYperiodList=[];
        this.FunctionToken(this.getCYCropYear,{crop: this.CYcropSelected,});
      }
      else{
        alert("請選擇農情作物");
        this.CYcropSelected = "請選擇農情作物";
        this.CYyearSelected = "請選擇年度";
        this.CYperiodSelected = "請選擇期作";
      } 
    },
    //農情作物查詢取年度
    getCYCropYear(data){
      this.apiGetCYCropYearList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          //console.log("API response:", json);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            //this.aa=jsonData;
            
            this.CYyearList = ["請選擇年度"];
            this.CYyearSelected = jsonData[0].A_YEAR;
            this.CYperiodList=["請選擇期作"];
            this.CYperiodSelected="請選擇期作";
            for(var i= 0; i < jsonData.length; i++){
              this.CYyearList.push(jsonData[i].A_YEAR);
            }
          }
          this.changeCropPeriod();
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    /*
      <summary>
        選擇作物及年度後更改期作列表
      </summary>
    */
    changeCropPeriod(){
      //console.log("changeCropPeriod method called with yearSelected:",this.CYyearSelected);
      this.FunctionToken(this.getCropYearPeriodList,{
        A_YEAR : this.CYyearSelected,
        CROP : this.CYcropSelected,
      })
      this.mapResize();
    },
    getCropYearPeriodList(data){
      this.apiGetCYCropYearPeriodList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          this.CYperiodList=["請選擇期作"];
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            //this.aa=jsonData;
            this.CYperiodSelected=jsonData[0].PERIOD;
            for( var i =0; i < jsonData.length ; i++){
              this.CYperiodList.push(jsonData[i].PERIOD);
            }
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    /*     <summary>
        更改年度期作作物列表
        </summary>
         */
    changeCropList() {
      this.mapResize();
      if (!this.cropLists[this.yearSelected + "_" + this.periodSelected]) {
        this.FunctionToken(this.getCropList, {
          year: this.yearSelected,
          period: this.periodSelected,
        });
      } else {
        this.cropList = this.cropLists[
          this.yearSelected + "_" + this.periodSelected
        ];
        this.cropSelected = "請選擇農情作物";
      }
    },
    changeCropListAll() {
      this.mapResize();
      if (
        !this.cropListsAll[this.yearSelectedAll + "_" + this.periodSelectedAll]
      ) {
        this.FunctionToken(this.getCropListAll, {
          year: this.yearSelectedAll,
          period: this.periodSelectedAll,
        });
      } else {
        this.cropListAll = this.cropListsAll[
          this.yearSelectedAll + "_" + this.periodSelectedAll
        ];
        this.cropSelectedAll = "請選擇農情作物";
      }
    },
    /*     <summary>
        呼叫getCropArea function，並有防呆機制
        </summary>
         */
    toGetCropArea() {
      if (!this.yearSelected || this.yearSelected == "") {
        alert("請選擇年度");
        return false;
      } else if (!this.periodSelected || this.periodSelected == "") {
        alert("請選擇農情作物");
        return false;
      } else if (
        this.cropSelected == "請選擇農情作物" ||
        !this.cropSelected ||
        this.cropSelected == ""
      ) {
        alert("請選擇農情作物");
        return false;
      } else if (this.addAreaLayer.length >= 3) {
        alert("圖層上限為三項");
        return false;
      } else if (
        this.radioLists.includes(
          this.yearSelected +
            "_" +
            this.periodSelected +
            "_" +
            this.cropSelected
        )
      ) {
        alert("此圖層已加入");
        return false;
      }
      let obj = {
        year: this.yearSelected,
        period: this.periodSelected,
        crop: this.cropSelected,
        area: this.area,
      };
      this.FunctionToken(this.getCropArea, obj);
    },
    /*<summary>
      呼叫getCYCropArea function，並有防呆機制
      </summary>
     */
  toGetCYCropArea() {
    if (!this.CYyearSelected || this.CYyearSelected == "") {
      alert("請選擇年度");
      return false;
    } else if (!this.CYperiodSelected || this.CYperiodSelected == "") {
      alert("請選擇期作");
      return false;
    } else if (
      this.CYcropSelected == "請選擇農情作物" ||
      !this.CYcropSelected ||
      this.CYcropSelected == ""
    ) {
      alert("請選擇農情作物");
      return false;
    } else if (this.addCYAreaLayer.length >= 3) {
      alert("圖層上限為三項");
      return false;
    } else if (
      this.radioLists.includes(
        this.CYyearSelected +
          "_" +
          this.CYperiodSelected +
          "_" +
          this.CYcropSelected
      )
    ) {
      alert("此圖層已加入");
      return false;
    }
    let obj = {
      A_YEAR: this.CYyearSelected,
      period: this.CYperiodSelected,
      crop: this.CYcropSelected,
      area: this.area,
    };
    this.FunctionToken(this.getCYCropArea, obj);
  },
    toGetCropAreaAll() {
      if (!this.yearSelectedAll || this.yearSelectedAll == "") {
        alert("請選擇年度");
        return false;
      } else if (!this.periodSelectedAll || this.periodSelectedAll == "") {
        alert("請選擇農情作物");
        return false;
      } else if (
        this.cropSelectedAll == "請選擇農情作物" ||
        !this.cropSelectedAll ||
        this.cropSelectedAll == ""
      ) {
        alert("請選擇農情作物");
        return false;
      } else if (this.addAreaLayer.length >= 3) {
        alert("圖層上限為三項");
        return false;
      } else if (
        this.radioLists.includes(
          this.yearSelectedAll +
            "_" +
            this.periodSelectedAll +
            "_" +
            this.cropSelectedAll
        )
      ) {
        alert("此圖層已加入");
        return false;
      }
      let obj = {
        year: this.yearSelectedAll,
        period: this.periodSelectedAll,
        crop: this.cropSelectedAll,
        area: this.area,
      };
      this.FunctionToken(this.getCropAreaAll, obj);
    },
    /*     <summary>
        取得農作物種植範圍
        </summary>
         */
    getCropArea(data) {
      this.apiGetCropArea(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.cropArea = jsonData;
            //console.log(this.cropArea);
            this.geoselectionlist = [];
            this.geoselect = [];
            this.cropAreaSelected = [];
            this.areaValue = [];
            for (var index in jsonData.BA_AGRI_SURVEY) {
              let item = jsonData.BA_AGRI_SURVEY[index];
              this.cropAreaSelected.push(item.ANA_TOWN_ID);
              this.areaValue[item.ANA_TOWN_ID] = item;
              let subindex = this.geooriginaltownlist.findIndex(
                (x) => x.value == item.ANA_TOWN_ID
              );
              if (subindex != -1) {
                this.geoselectionlist.push(this.geooriginaltownlist[subindex]);
                this.geoselect.push(this.geooriginaltownlist[subindex].value);
              }
            }
            this.ifallgeoselect = ["全選"];
            this.ifGeoSelection = true;
            //console.log(this.geoselect);
            this.map.removeLayer(this.cropMap);
            this.cropMap = {};
            this.cropMap = new VectorLayer({
              visible: true,
              source: new VectorSource({
                url: "GeoJSON/chayi_3857.geojson",
                format: new GeoJSON(),
              }),
              style: this.styleFunction,
            });
            this.map.addLayer(this.cropMap);
            this.cropInfo = {
              townName: "",
              year: "",
              period: "",
            };

            this.cropInfo.townName = "嘉義縣";
            this.cropInfo.AREA_H = jsonData.CITY_AREA.AREA_H;
            this.cropInfo.AREA_P = jsonData.CITY_AREA.AREA_P;
            this.cropInfo.RATE_H = jsonData.CITY_AREA.RATE_H;
            this.cropInfo.HARVEST = jsonData.CITY_AREA.HARVEST;

            this.cropInfo.year = this.yearSelected;
            this.cropInfo.period = this.periodSelected;
            this.cropInfo.crop = this.cropSelected;
            this.cropInfoShow = true;
            if (this.addAreaLayer.length == 0) {
              this.addAreaLayer[0] = {
                year: this.yearSelected,
                period: this.periodSelected,
                crop: this.cropSelected,
              };
            } else {
              this.addAreaLayer.push({
                year: this.yearSelected,
                period: this.periodSelected,
                crop: this.cropSelected,
              });
            }
            this.legendShow = true;
            this.rodisValue =
              this.yearSelected +
              "_" +
              this.periodSelected +
              "_" +
              this.cropSelected;
            this.radioLists.push(
              this.yearSelected +
                "_" +
                this.periodSelected +
                "_" +
                this.cropSelected
            );
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    /*     <summary>
      嘉義農情-取得農作物種植範圍_new 
      </summary>
     */
    getCYCropArea(data){
      this.apiCYCropAreaList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status){
            let jsonData = JSON.parse(json.Data);
            this.cropArea = jsonData;
            this.areaValue = [];
            this.townList=[];
            this.townSelect=[];
            this.cropAreaSelected=[];
            this.CYcropArea = jsonData.BA_AGRI_SURVEY_PERIOD;
            
            for(var index in jsonData.BA_AGRI_SURVEY_PERIOD){
              let item = jsonData.BA_AGRI_SURVEY_PERIOD[index];
              this.areaValue[item.ANA_TOWN_ID] = item;
              let subindex = this.townList.findIndex(
                (x) => x.value == item.TOWN.split('.')[0]
              );
              let townid = item.TOWN.split('.')[0];
              let townname = item.TOWN.split('.')[1];
              if(subindex == -1)
              {
                this.townList.push({value:townid,text:townname});
                this.cropAreaSelected.push(townid);
                this.townSelect.push(townid);
              }
            }
            this.ifalltownselect = ["全選"];
            this.townsectlist=[];

            this.map.removeLayer(this.germCYmap);
            this.germCYmap = {}; 
            this.germCYmap = new VectorLayer({
              visible: true,
              source: new VectorSource({
              url:"GeoJSON/AllMasec_3857.geojson",
              format: new GeoJSON(),
              }),
              style: this.styleCYFunction,
            });

            this.cropInfoShow = true;
            this.cropsectorlist = this.CYcropArea;
            //console.log(this.cropsectorlist);
            if(this.addCYAreaLayer.length == 0 ){
              this.addCYAreaLayer[0] ={
                year: this.CYyearSelected,
                period: this.CYperiodSelected,
                crop: this.CYcropSelected,
                show:false,
              };
            }
            else{
              this.addCYAreaLayer.push({
                year: this.CYyearSelected,
                period: this.CYperiodSelected,
                crop: this.CYcropSelected,
                show:false,
              });
            }
            for(var i in this.addCYAreaLayer){
              if(i < this.addCYAreaLayer.length-1) this.addCYAreaLayer[i].show = false;
              else{
                this.addCYAreaLayer[i].show = true;
                this.addCYAreaLayerindex = i;
              } 
            }
            
            this.rodisValue =
              this.CYyearSelected +
              "_" +
              this.CYperiodSelected +
              "_" +
              this.CYcropSelected;
            this.radioLists.push(
                this.CYyearSelected +
                  "_" +
                  this.CYperiodSelected +
                  "_" +
                  this.CYcropSelected
              );
            this.germCYmap.set("name","germCYmap");
            this.map.addLayer(this.germCYmap);
            this.cropInfo3= {
              ifCropShow: true,
              townName: "",
              sectorName: "",
              cropName: data.crop,
              area_situation:"",
              area_P: "",
              area_I: "",
              area_O: "",
              area_NH: "",
              year: data.A_YEAR,
              period: data.period,
            },
            this.cropInfo3.ifCropShow = true;
            this.ifgermshow = true;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getCYCropAreaList(data){
      this.apiCYCropAreaList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status){
            let jsonData = JSON.parse(json.Data);
            this.CYcropArea = jsonData.BA_AGRI_SURVEY_PERIOD;
            this.HEIGHT_AREA  = jsonData.HEIGHT_AREA;
            this.cropArea= jsonData;
            this.map.removeLayer(this.germCYmap);
            this.germCYmap = {};
            this.cropsectorlist = [];
            this.townList = [];
            
            for(var index in jsonData.BA_AGRI_SURVEY_PERIOD){
              let item = jsonData.BA_AGRI_SURVEY_PERIOD[index];
              this.areaValue[item.ANA_TOWN_ID] = item;
              let subindex = this.townList.findIndex(
              (x) => x.value == item.TOWN.split('.')[0]
              );
              if(subindex == -1)
              {
                this.townList.push({value:item.TOWN.split('.')[0],text:item.TOWN.split('.')[1]});
                this.cropAreaSelected.push(item.TOWN.split('.')[0]);
                this.townSelect.push(item.TOWN.split('.')[0]);
                //console.log("townList:",this.townList);
              }
            }
            this.ifalltownselect = ["全選"];
            this.germCYmap = new VectorLayer({
              visible: true,
              source: new VectorSource({
                url:"GeoJSON/AllMasec_3857.geojson",
                format: new GeoJSON(),
              }),
              style: this.styleCYFunction,
            });
            
            this.cropInfo3= {
              ifCropShow: false,
              townName: "",
              sectorName: "",
              cropName: data.crop,
              area_situation: "",
              area_P: "",
              area_I: "",
              area_O: "",
              area_NH: "",
              year: data.A_YEAR,
              period: data.period,
            },
            
            this.cropsectorlist = this.CYcropArea;
            this.germCYmap.set("name","germCYmap");
            this.map.addLayer(this.germCYmap);
            this.cropInfo3.ifCropShow = true;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getCropAreaAll(data) {
      this.apiGetCropAreaAll(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            // console.log(jsonData)
            this.cropArea = jsonData;
            this.cropAreaSelected = [];
            this.areaValue = [];
            this.countrySelect = "請選擇縣市";
            this.countryList = ["請選擇縣市"];
            for (var index in jsonData.AGRI_SURVEY_TAIWAN) {
              let item = jsonData.AGRI_SURVEY_TAIWAN[index];
              this.cropAreaSelected.push(item.ANA_TOWN_ID);
              this.areaValue[item.ANA_TOWN_ID] = item;
              let subindex = taiwancountrylist.findIndex(
                (x) => x.value == item.ANA_CITY_ID
              );
              if (
                subindex != -1 &&
                this.countryList.findIndex(
                  (y) => y.value == item.ANA_CITY_ID
                ) == -1
              ) {
                this.countryList.push(taiwancountrylist[subindex]);
              }
            }

            this.countryList.sort((a, b) => {
              const index_a = taiwancountrylist.findIndex(
                (x) => x.value == a.value
              );
              const index_b = taiwancountrylist.findIndex(
                (x) => x.value == b.value
              );
              return index_a - index_b;
            });

            this.cropInfo = {
              townName: "",
              year: "",
              period: "",
            };
            this.ifGeoSelection = true;
            this.cropInfo.townName = "嘉義縣";
            this.cropInfo.AREA_H = jsonData.CITY_AREA.AREA_H;
            this.cropInfo.AREA_P = jsonData.CITY_AREA.AREA_P;
            this.cropInfo.RATE_H = jsonData.CITY_AREA.RATE_H;
            this.cropInfo.HARVEST = jsonData.CITY_AREA.HARVEST;

            this.cropInfo.year = this.yearSelectedAll;
            this.cropInfo.period = this.periodSelectedAll;
            this.cropInfo.crop = this.cropSelectedAll;
            
            this.cropInfoShow = true;
            if (this.addAreaLayerAll.length == 0) {
              this.addAreaLayerAll[0] = {
                year: this.yearSelectedAll,
                period: this.periodSelectedAll,
                crop: this.cropSelectedAll,
              };
            } else {
              this.addAreaLayerAll.push({
                year: this.yearSelectedAll,
                period: this.periodSelectedAll,
                crop: this.cropSelectedAll,
              });
            }
            // this.cropInfoShow = true;
            // this.legendShow = true;

            this.rodisValue =
              this.yearSelectedAll +
              "_" +
              this.periodSelectedAll +
              "_" +
              this.cropSelectedAll;
            this.radioLists.push(
              this.yearSelectedAll +
                "_" +
                this.periodSelectedAll +
                "_" +
                this.cropSelectedAll
            );
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    /*     <summary>
        取得農作物種植範圍的清單
        </summary>
         */
    getCropAreaList(data) {
      this.apiGetCropAreaAll(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.cropArea = jsonData;
            this.cropAreaSelected = [];
            this.areaValue = [];
            for (var index in jsonData.BA_AGRI_SURVEY) {
              let item = jsonData.BA_AGRI_SURVEY[index];
              this.cropAreaSelected.push(item.ANA_TOWN_ID);
              this.areaValue[item.ANA_TOWN_ID] = item;
            }
            this.map.removeLayer(this.cropMap);
            this.cropMap = {};
            this.cropMap = new VectorLayer({
              visible: true,
              source: new VectorSource({
                url: "GeoJSON/chayi_3857.geojson",
                format: new GeoJSON(),
              }),
              style: this.styleFunction,
            });
            this.map.addLayer(this.cropMap);
            this.cropInfo = {
              townName: "",
              year: "",
              period: "",
            };

            this.cropInfo.townName = "嘉義縣";
            this.cropInfo.AREA_H = jsonData.CITY_AREA.AREA_H;
            this.cropInfo.AREA_P = jsonData.CITY_AREA.AREA_P;
            this.cropInfo.RATE_H = jsonData.CITY_AREA.RATE_H;
            this.cropInfo.HARVEST = jsonData.CITY_AREA.HARVEST;

            this.cropInfo.year = data.year;
            this.cropInfo.period = data.period;
            this.cropInfo.crop = data.crop;
            this.cropInfoShow = true;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getcolorfill(feature) {
      let townID = "";
      let fillColor = [29, 151, 108, 0];
      let survey = this.cropArea.BA_AGRI_SURVEY
        ? this.cropArea.BA_AGRI_SURVEY
        : this.cropArea.AGRI_SURVEY_TAIWAN;
      if (survey.length > 0) {
        townID = feature.values_.TOWNID;
        if (this.cropAreaSelected.includes(townID)) {
          let highest_level = this.cropArea.HEIGHT_AREA / 5;
          let percentage;
          if (this.areaValue[townID].AREA_H < highest_level) percentage = 0.2;
          else if (this.areaValue[townID].AREA_H < highest_level * 2)
            percentage = 0.4;
          else if (this.areaValue[townID].AREA_H < highest_level * 3)
            percentage = 0.6;
          else if (this.areaValue[townID].AREA_H < highest_level * 4)
            percentage = 0.7;
          else if (this.areaValue[townID].AREA_H <= highest_level * 5)
            percentage = 0.9;
          fillColor = [29, 151, 108, percentage];
        }
      }
      return fillColor;
    },
    styleWarning(feature) {
      let style;
      let fillColor = [0, 0, 0, 0];
      let strokeColor = [0, 0, 0, 0];
      if (this.warningTown.length > 0) {
        let townID = feature.values_.TOWNID;
        if (this.warningTown.includes(townID) && this.AREA_PList[townID]) {
          let highest_level = this.cityHeight / 5;
          let percentage;
          if (this.AREA_PList[townID] == 0 || !this.AREA_PList[townID])
            percentage = 0;
          else if (this.AREA_PList[townID] < highest_level) percentage = 0.2;
          else if (this.AREA_PList[townID] < highest_level * 2)
            percentage = 0.4;
          else if (this.AREA_PList[townID] < highest_level * 3)
            percentage = 0.6;
          else if (this.AREA_PList[townID] < highest_level * 4)
            percentage = 0.7;
          else if (this.AREA_PList[townID] <= highest_level * 5)
            percentage = 0.9;
          fillColor = [234, 56, 77, percentage];
          strokeColor = [0, 0, 0, 1];
        }
      }
      style = new Style({
        stroke: new Stroke({
          color: strokeColor,
          width: 1,
        }),
        fill: new Fill({
          color: fillColor,
        }),
      });
      return style;
    },
    changeGeoJson() {
      this.map.removeLayer(this.cropMap);
      this.cropMap = {};
      this.cropMap = new VectorLayer({
        visible: true,
        source: new VectorSource({
          url: "GeoJSON/chayi_3857.geojson",
          format: new GeoJSON(),
        }),
        style: this.styleFunction,
      });
      this.map.addLayer(this.cropMap);
    },
    selectStyle(feature) {
      const color = feature.get('COLOR') || '#eeeeee';
      this.selectgermCYmap.getFill().setColor(color);
      //console.log("this.selectgermCYmap.color",color);
      return this.selectgermCYmap;
    },
    //取得顏色
    getColor(val){
      if(val == 0) this.percentage =0;
      else if(val < (this.cropArea.HEIGHT_AREA / 5))this.percentage =0.2;
      else if(val < (this.cropArea.HEIGHT_AREA / 5)*2)this.percentage =0.4;
      else if(val < (this.cropArea.HEIGHT_AREA / 5)*3)this.percentage =0.6;
      else if(val < (this.cropArea.HEIGHT_AREA / 5)*4)this.percentage =0.7;
      else if(val < (this.cropArea.HEIGHT_AREA / 5)*5)this.percentage =0.9;
      else this.percentage = 1;
      //console.log("getcolor",val,this.percentage);
      return [29, 151, 108,this.percentage];
    },
    changeCYGeoJson(){
      this.map.removeLayer(this.germCYmap);
      this.germCYmap = {};
      this.germCYmap = new VectorLayer({
        visible: true,
        source: new VectorSource({
          url: "GeoJSON/AllMasec_3857.geojson",
          format: new GeoJSON(),
        }),
        style: this.styleCYFunction,
      });
      
      this.germCYmap.set("name","germCYmap");
      this.map.addLayer(this.germCYmap);
      this.cropInfo3.ifCropShow = true;
      this.ifgermshow = true;
    },
    changeTaiwanGeoJson() {
      this.map.removeLayer(this.cropMapAll);
      this.cropMapAll = {};
      this.cropMapAll = new VectorLayer({
        visible: true,
        source: new VectorSource({
          url: "GeoJSON/taiwan.geojson",
          format: new GeoJSON(),
        }),
        style: this.styleFunction,
      });
      this.cropMapAll.set("name","cropMapAll");
      this.map.addLayer(this.cropMapAll);
    },
    styleTradingWarning(feature) {
      let style;
      let fillColor = [0, 0, 0, 0];
      let strokeColor = [0, 0, 0, 0];
      if (this.tradeWarningArea.BA_AGRI_SURVEY.length > 0) {
        let townID = feature.values_.TOWNID;
        if (this.tradeWarningAreaSelected.includes(townID)) {
          let highest_level = this.tradeWarningArea.HEIGHT_AREA / 5;
          let percentage;
          if (this.tradeWarningAreaValue[townID].AREA_H < highest_level)
            percentage = 0.2;
          else if (
            this.tradeWarningAreaValue[townID].AREA_H <
            highest_level * 2
          )
            percentage = 0.4;
          else if (
            this.tradeWarningAreaValue[townID].AREA_H <
            highest_level * 3
          )
            percentage = 0.6;
          else if (
            this.tradeWarningAreaValue[townID].AREA_H <
            highest_level * 4
          )
            percentage = 0.7;
          else if (
            this.tradeWarningAreaValue[townID].AREA_H <=
            highest_level * 5
          )
            percentage = 0.9;
          fillColor = [255, 153, 0, percentage];
          strokeColor = [0, 0, 0, 1];
        }
      }
      style = new Style({
        stroke: new Stroke({
          color: strokeColor,
          width: 1,
        }),
        fill: new Fill({
          color: fillColor,
        }),
      });
      return style;
    },
    /*     <summary>

    /*     <summary>
        關閉農作物歷年資料視窗
        </summary>
         */
    closeCropInfo(item) {
      if (this.addAreaLayer.length) this.addAreaLayer.splice(item, 1);
      else this.addAreaLayerAll.splice(item, 1);
      this.radioLists.splice(item, 1);
      // this.closeCropInfo();
    },
    closeCYCropInfo(item) {
      if (this.addCYAreaLayer.length) this.addCYAreaLayer.splice(item, 1);
      else this.addAreaLayerAll.splice(item, 1);
      this.radioLists.splice(item, 1);
      // this.closeCropInfo();
    },
    /*     <summary>
        關閉價量預警資料視窗
        </summary>
         */
    closeTradeWarning() {
      this.tradeWarningShow = false;
      this.map.removeLayer(this.tradeWarningMap);
      this.tradeWarningSelected = "";
    },
    showclimate(num) {
      switch (num) {
        case 0:
          this.mapForVisible["radar"].setVisible(this.radarCheck);
          break;
        case 1:
          this.mapForVisible["rain"].setVisible(this.rainCheck);
          break;
        case 2:
          this.mapForVisible["raingauge"].setVisible(this.raingaugeCheck);
          break; 
        case 3: 
          this.mapForVisible["gdacs"].setVisible(this.gdacsCheck);
          break;
        case 4: 
          this.mapForVisible["fifows_typhoon"].setVisible(this.fifowstyphoonCheck);
          break;
        default:
          break;
      }
    },
    /*   <summary>
        關閉病蟲預警視窗
        </summary>
    */
    closePDWindow() {
      // this.map.removeLayer(this.pestNoticeWarningMap);
      this.map.removeLayer(this.pestandDieaseMap);

      // this.pestsAndDiseases.ifPDWindowShow = false;
      this.pestsAndDiseases2.ifPDWindowShow = false;
      this.pestsAndDiseases2.ifPDWindowShow_ear = false;
      // this.pestsAndDiseases.PDobject = {
      //   subject: null,
      //   contents: null,
      //   suggest: null,
      //   publish: null,
      //   cropname: null,
      //   date: null,
      //   detial: {
      //     title: null,
      //     place: null,
      //     items: [],
      //   },
      // };
      this.pestsAndDiseases2.selected = null;
      // this.MapView.animate(
      //   { zoom: 10 },
      //   { center: fromLonLat([120.15, 23.473323877771172]) }
      // );
    },
    
    /*     <summary>
        移除農作物的佇列表
        </summary>
         */
    removeItem(item) {
      this.cropInfoShow = false;
      if (this.addAreaLayer.length) this.map.removeLayer(this.cropMap);
      else this.map.removeLayer(this.cropMapAll);
      this.geoselectionlist = [];
      this.geoselect = [];
      this.ifGeoSelection = false;
      this.rodisValue = "";
      this.closeCropInfo(item);
    },
    removeCYItem(item) {
      this.cropInfoShow = false;
      if (this.addCYAreaLayer.length) this.map.removeLayer(this.germCYmap);
      else this.map.removeLayer(this.cropMapAll);
      this.germCYMap = {};
      this.cropsectorlist = [];
      this.townsectlist=[];
      this.ifgermshow = false;
      this.cropInfo3.ifCropShow = false;
      this.rodisValue = "";
      this.ifGeoSelection = false;
      this.closeCYCropInfo(item);
    },
    /*    <summary>
        更新取得農作物的列表
      </summary>
         */
    changeRadio(item) {
      this.FunctionToken(this.getCropAreaList, {
        year: item.year,
        period: item.period,
        crop: item.crop,
      });
    },
    changeCYRadio(item,index) {
      this.townSelect=[];
      this.townList=[];
      this.cropArea=[];
      this.addCYAreaLayer[this.addCYAreaLayerindex].show = false;
      this.addCYAreaLayer[index].show = true;
      this.addCYAreaLayerindex = index;
      this.FunctionToken(this.getCYCropAreaList, {
        A_YEAR: item.year,
        period: item.period,
        crop: item.crop,
        index:index
      });
    },
    /*    <summary>
    取得農作物氣象預警
    </summary>
    <param "data">農作物氣象預警資料</param>
    */
    //取得嘉義氣象預警
    getWarningData(data) {
      this.apiGetWarninginfo(data).then((res) => {
        const json = JSON.parse(res.data);
        this.foodInjuryAllDate = JSON.parse(json.Data);
        var text = JSON.parse(json.Data);
        // for(let i in text)
        // {
        //   let item = text[i]
        // }
        //將Json format的資料分類並寫入agriwarningList
        text
          .filter((it) => it.Note == 7 && it.DISASTER == "注意寒害")
          .map((el) => {
            el.Note = 8;
            return el;
          }); ///現階段資料庫高低溫但同代碼解法

        var agriwarningList = Object.values(
          text.reduce(
            (
              acc,
              {
                Note,
                C_NAME,
                ANA_TOWN_ID,
                PERIOD,
                EFFECT,
                PREVENTION,
                RECOVERY,
                DURATION,
                A_YEAR,
                A_PERIOD,
                REAL_VALUE,
                Unit,
                CREATETIME,
                TIMESTAMP,
                THRESHOLD,
                ANA_C_ID,
                DISASTER,
              }
            ) => {
              const key = Note + "_" + C_NAME + "_" + DISASTER;
              acc[key] = acc[key] || {
                Note,
                C_NAME,
                ANA_TOWN_ID: [],
                PERIOD,
                EFFECT,
                PREVENTION,
                RECOVERY,
                DURATION,
                A_YEAR,
                A_PERIOD,
                THRESHOLD,
                Unit,
                REAL_VALUE: [],
                TIMESTAMP,
                ANA_C_ID,
                DISASTER,
                CREATETIME,
              };
              acc[key].ANA_TOWN_ID.push(ANA_TOWN_ID.replace(/\s*/g, ""));
              const real_value_json = new Object();
              real_value_json.ANA_TOWN_ID = ANA_TOWN_ID.replace(/\s*/g, "");
              real_value_json.REAL_VALUE = REAL_VALUE;
              real_value_json.CREATETIME = CREATETIME;
              acc[key].REAL_VALUE.push(real_value_json);
              return acc;
            },
            {}
          )
        );

        var Temp = [];
        for (var index in agriwarningList) {
          let item = agriwarningList[index];
          Temp[item.Note + "_" + item.ANA_C_ID] = item;
        }
        this.warningLists = Temp;
        //等warningLists有資料後才跑判斷是否url有傳入變數
        let url = window.location.href;
        
        let githubURL = new URL(url.replace("#/",""));
        let params = new URLSearchParams(githubURL.search)
        let crop_id= params.get("id");
        console.log("crop_id",crop_id)
        if(!this.IsNullEmpty(crop_id)){
          this.selected=crop_id;
        this.radioSelectedChange();
        }
        
        for (var i = 0; i < text.length; i++) {
          let warning = text[i].Note;
          let foodname = text[i].C_NAME;
          let cityname = text[i].ANA_TOWN_NAME;
          let data1 = {
            DISASTER: warning,
            C_NAME: foodname,
            ANA_TOWN_NAME: cityname,
            Data: text[i],
          };
          this.foodInjuryAllDateSearch.push(data1);

          if (foodname in this.foodCityList) {
            this.foodCityList[foodname].push(cityname.trim());
          } else {
            this.foodCityList[foodname] = [cityname.trim()];
          }

          if (warning == "1") {
            //將資料寫入"颱風警戒"的物件與選項列表
            this.parseDataToWarn(
              this.typhoonWarn,
              this.typhoonWarnOptions,
              text[i]
            );
          } else if (warning == "2") {
            //將資料寫入"焚風警戒"的物件與選項列表
            this.parseDataToWarn(
              this.foehnWarn,
              this.foehnWarnOptions,
              text[i]
            );
          } else if (warning == "3") {
            //將資料寫入"降水警戒"的物件與選項列表
            this.parseDataToWarn(
              this.precipitationWarn,
              this.precipitationWarnOptions,
              text[i]
            );
          } else if (warning == "4") {
            //將資料寫入"高溫警戒"的物件與選項列表
            this.parseDataToWarn(
              this.hightemptureWarn,
              this.hightemptureWarnOptions,
              text[i]
            );
          } else if (warning == "5") {
            //將資料寫入"寒害警戒"的物件與選項列表
            this.parseDataToWarn(
              this.coldinjuryWarn,
              this.coldinjuryWarnOptions,
              text[i]
            );
          } else if (warning == "6") {
            //將資料寫入"注意降水"的物件與選項列表
            this.parseDataToWarn(
              this.excessiverainNotice,
              this.excessiverainNoticeOptions,
              text[i]
            );
          } else if (warning == "7") {
            //將資料寫入"注意高溫"的物件與選項列表
            this.parseDataToWarn(
              this.hightemptureNotice,
              this.hightemptureNoticeOptions,
              text[i]
            );
          } else if (warning == "8") {
            //將資料寫入"注意寒害"的物件與選項列表
            this.parseDataToWarn(
              this.coldinjuryNotice,
              this.coldinjuryNoticeOptions,
              text[i]
            );
          } else if (warning == "9") {
            //將資料寫入"注意回溫"的物件與選項列表
            this.parseDataToWarn(
              this.warmupNotice,
              this.warmupNoticeOptions,
              text[i]
            );
          } else if (warning == "10") {
            //將資料寫入"注意降溫"的物件與選項列表
            this.parseDataToWarn(
              this.cooldownNotice,
              this.cooldownNoticeOptions,
              text[i]
            );
          }
        }
        
        this.ifwarningdataloading = false;

      });
    },
    getWarningAllData(data) {
      this.apiGetScourgeAllinfo(data).then((res) => {
        const json = JSON.parse(res.data);
        this.foodInjuryTaiwanAllDate = JSON.parse(json.Data);
        var text = JSON.parse(json.Data);
        text
          .filter((it) => it.Note == 7 && it.DISASTER == "注意寒害")
          .map((el) => {
            el.Note = 8;
            return el;
          }); ///現階段資料庫高低溫但同代碼解法

        var agriwarningList = Object.values(
          text.reduce(
            (
              acc,
              {
                Note,
                C_NAME,
                ANA_TOWN_ID,
                PERIOD,
                EFFECT,
                PREVENTION,
                RECOVERY,
                DURATION,
                A_YEAR,
                A_PERIOD,
                REAL_VALUE,
                Unit,
                CREATETIME,
                TIMESTAMP,
                THRESHOLD,
                ANA_C_ID,
                DISASTER,
              }
            ) => {
              const key = Note + "_" + C_NAME + "_" + DISASTER;
              acc[key] = acc[key] || {
                Note,
                C_NAME,
                ANA_TOWN_ID: [],
                PERIOD,
                EFFECT,
                PREVENTION,
                RECOVERY,
                DURATION,
                A_YEAR,
                A_PERIOD,
                THRESHOLD,
                Unit,
                REAL_VALUE: [],
                TIMESTAMP,
                ANA_C_ID,
                DISASTER,
                CREATETIME,
              };
              acc[key].ANA_TOWN_ID.push(ANA_TOWN_ID.replace(/\s*/g, ""));
              const real_value_json = new Object();
              real_value_json.ANA_TOWN_ID = ANA_TOWN_ID.replace(/\s*/g, "");
              real_value_json.REAL_VALUE = REAL_VALUE;
              real_value_json.CREATETIME = CREATETIME;
              acc[key].REAL_VALUE.push(real_value_json);
              return acc;
            },
            {}
          )
        );
        //console.log("agriwarningList",agriwarningList)
        var Temp = [];
        for (var index in agriwarningList) {
          let item = agriwarningList[index];
          Temp[item.Note + "_" + item.ANA_C_ID] = item;
        }
        this.warningAllLists = Temp;
        //console.log("warningAllLists",this.warningAllLists)
        for (var i = 0; i < text.length; i++) {
          let warning = text[i].Note;
          let foodname = text[i].C_NAME;
          let cityname = text[i].ANA_TOWN_NAME;

          let data1 = {
            DISASTER: warning,
            C_NAME: foodname,
            ANA_TOWN_NAME: cityname,
            Data: text[i],
          };
          this.foodInjuryTaiwanAllDateSearch.push(data1);

          
          if (foodname in this.foodTaiwanCityList) {
            this.foodTaiwanCityList[foodname].push(cityname.trim());
          } else {
            this.foodTaiwanCityList[foodname] = [cityname.trim()];
          }

          if (warning == "1") {
            //將資料寫入"颱風警戒"的物件與選項列表
            this.parseDataToWarnTaiwan(
              this.typhoonWarnAll,
              this.typhoonWarnOptionsAll,
              text[i]
            );
          } else if (warning == "2") {
            //將資料寫入"焚風警戒"的物件與選項列表
            this.parseDataToWarnTaiwan(
              this.foehnWarnAll,
              this.foehnWarnOptionsAll,
              text[i]
            );
          } else if (warning == "3") {
            //將資料寫入"降水警戒"的物件與選項列表
            this.parseDataToWarnTaiwan(
              this.precipitationWarnAll,
              this.precipitationWarnOptionsAll,
              text[i]
            );
          } else if (warning == "4") {
            //將資料寫入"高溫警戒"的物件與選項列表
            this.parseDataToWarnTaiwan(
              this.hightemptureWarnAll,
              this.hightemptureWarnOptionsAll,
              text[i]
            );
          } else if (warning == "5") {
            //將資料寫入"寒害警戒"的物件與選項列表
            this.parseDataToWarnTaiwan(
              this.coldinjuryWarnAll,
              this.coldinjuryWarnOptionsAll,
              text[i]
            );
          } else if (warning == "6") {
            //將資料寫入"注意降水"的物件與選項列表
            this.parseDataToWarnTaiwan(
              this.excessiverainNoticeAll,
              this.excessiverainNoticeOptionsAll,
              text[i]
            );
          } else if (warning == "7") {
            //將資料寫入"注意高溫"的物件與選項列表
            this.parseDataToWarnTaiwan(
              this.hightemptureNoticeAll,
              this.hightemptureNoticeOptionsAll,
              text[i]
            );
          } else if (warning == "8") {
            //將資料寫入"注意寒害"的物件與選項列表
            this.parseDataToWarnTaiwan(
              this.coldinjuryNoticeAll,
              this.coldinjuryNoticeOptionsAll,
              text[i]
            );
          } else if (warning == "9") {
            //將資料寫入"注意回溫"的物件與選項列表
            this.parseDataToWarnTaiwan(
              this.warmupNoticeAll,
              this.warmupNoticeOptionsAll,
              text[i]
            );
          } else if (warning == "10") {
            //將資料寫入"注意降溫"的物件與選項列表
            this.parseDataToWarnTaiwan(
              this.cooldownNoticeAll,
              this.cooldownNoticeOptionsAll,
              text[i]
            );
          }
          
        }
        
        console.log("this.$route.params.anchor",this.$route.params.anchor)
        if(this.$route.params.anchor != null ){
          console.log("anchor",this.$route.params.anchor)
          let anchorElementId = "anchor_"+this.$route.params.anchor;
          console.log("anchorElement",document.getElementById(anchorElementId))
          document.querySelector('#'+anchorElementId).scrollIntoView(true);
          if(document.getElementById(anchorElementId) != null){
            document.getElementById(anchorElementId).scrollIntoView(true);
          }
        }
        this.isLoading = false;
        this.ifwarningdataloadingAll = false;
      });
    },
    /*    <summary>
        將資料寫入特定的物件與選項列表
        </summary>
        <param "data">農作物氣象預警資料</param>
         */
    parseDataToWarn(Obj, option, data) {
      var result = true;
      for (var i = 0; i < Obj.length; i++) {
        if (Obj[i].C_NAME == data.C_NAME) {
          result = false;
          break;
        }
      }
      if (result) {
        let data1 = {
          C_NAME: data.C_NAME,
          ANA_TOWN_NAME: data.ANA_TOWN_NAME,
          Data: data,
        };
        this.changeWarnInfomation(data.Note);
        let mergedata = data.Note + "_" + data.ANA_C_ID;
        let data3 = {
          text: data.C_NAME,
          value: mergedata,
        };
        Obj.push(data1);
        option.push(data3);
      }
    },

    parseDataToWarnTaiwan(Obj, option, data) {
      var result = true;
      for (var i = 0; i < Obj.length; i++) {
        if (Obj[i].C_NAME == data.C_NAME) {
          result = false;
          break;
        }
      }
      if (result) {
        let data1 = {
          C_NAME: data.C_NAME,
          ANA_TOWN_NAME: data.ANA_TOWN_NAME,
          Data: data,
        };
        this.changeWarnInfomationTaiwan(data.Note);
        let mergedata = data.Note + "_" + data.ANA_C_ID;

        let data3 = {
          text: data.C_NAME,
          value: mergedata,
        };
        Obj.push(data1);
        option.push(data3);
      }
    },
    /*    <summary>
        決定顯示的災害資訊
        </summary>
        <param "disaster">災害的代碼</param>
         */
    changeWarnInfomation(disaster) {
      switch (disaster) {
        case 1:
          //"颱風警戒"
          this.isTyphoonShow = true;
          break;
        case 2:
          //"焚風警戒"
          this.isFoehnShow = true;
          break;
        case 3:
          //"降水警戒"
          this.isPrecipitation = true;
          break;
        case 4:
          //"高溫警戒"
          this.isHightempture = true;
          break;
        case 5:
          //"寒害警戒"
          this.isColdinjury = true;
          break;
        case 6:
          //"注意降水"
          this.isExcessiverain = true;
          break;
        case 7:
          //"注意高溫"
          this.isHightemptureNotice = true;
          break;
        case 8:
          //"注意寒害"
          this.isColdinjuryNotice = true;
          break;
        case 9:
          //"注意回溫"
          this.isWarmupNotice = true;
          break;
        case 10:
          //"注意降溫"
          this.isCooldownNotice = true;
          break;
      }
    },

    changeWarnInfomationTaiwan(disaster) {
      switch (disaster) {
        case 1:
          //"颱風警戒"
          this.isTyphoonShowAll = true;
          break;
        case 2:
          //"焚風警戒"
          this.isFoehnShowAll = true;
          break;
        case 3:
          //"降水警戒"
          this.isPrecipitationAll = true;
          break;
        case 4:
          //"高溫警戒"
          this.isHightemptureAll = true;
          break;
        case 5:
          //"寒害警戒"
          this.isColdinjuryAll = true;
          break;
        case 6:
          //"注意降水"
          this.isExcessiverainAll = true;
          break;
        case 7:
          //"注意高溫"
          this.isHightemptureNoticeAll = true;
          break;
        case 8:
          //"注意寒害"
          this.isColdinjuryNoticeAll = true;
          break;
        case 9:
          //"注意回溫"
          this.isWarmupNoticeAll = true;
          break;
        case 10:
          //"注意降溫"
          this.isCooldownNoticeAll = true;
          break;
      }
    },
    /*    <summary>
        更動作物預警視窗中的資訊
        </summary>
         */
    radioSelectedChange() {
      if (Object.keys(this.warningLists).length > 0) {
        this.AREA_P_ID = "";
        this.warningTownName = "";
        this.warningValueList = "";
        console.log("this.selected",this.selected)
        let data = this.warningLists[this.selected];
        var result = data.ANA_TOWN_ID.reduce((obj, item) => {
          obj[item] = 1;
          return obj;
        }, {});

        data.ANA_TOWN_ID = Object.keys(result);

        this.warningTown = data.ANA_TOWN_ID;
        this.foodseleted = data;

        var temp_array = Object.values(
          data.REAL_VALUE.reduce(
            (acc, { ANA_TOWN_ID, CREATETIME, REAL_VALUE }) => {
              const key = ANA_TOWN_ID;
              acc[key] = acc[key] || {
                ANA_TOWN_ID,
                CREATETIME: [],
                REAL_VALUE: [],
              };
              acc[key].CREATETIME.push(CREATETIME);
              acc[key].REAL_VALUE.push(REAL_VALUE);
              return acc;
            },
            {}
          )
        );

        if (data.Note == "3" || data.Note == "4" || data.Note == "5") {
          let temp = [];
          for (var index in temp_array) {
            let item = temp_array[index];
            temp[item.ANA_TOWN_ID] = item;
          }
          this.warningValueList_345 = temp;
        }

        // for(var i=0;i<this.foodInjuryAllDateSearch.length;i++)
        // {
        //   let disaster = this.foodInjuryAllDateSearch[i].DISASTER;
        //   let foodname = this.foodInjuryAllDateSearch[i].C_NAME;

        //   if(disaster==data[0] && foodname==data[1])
        //   {
        //     this.foodseleted = this.foodInjuryAllDateSearch[i].Data;
        //     break;
        //   }
        // }
        //if(this.tabselected==1)
        //{
        this.legendShow = true;
        this.isFoodItemSelected = !this.firstClick;

        this.FunctionToken(this.getCityArea, {
          town: data.ANA_TOWN_ID,
          crop: data.C_NAME,
          period: data.A_PERIOD,
        });
        //}
      }
    },
    radioSelectedAllChange() {
      if (Object.keys(this.warningAllLists).length > 0) {
        this.AREA_P_ID = "";
        this.warningTownName = "";
        this.warningValueList = "";

        let data = this.warningAllLists[this.selected];
        
        var result = data.ANA_TOWN_ID.reduce((obj, item) => {
          obj[item] = 1;
          return obj;
        }, {});

        data.ANA_TOWN_ID = Object.keys(result);

        this.warningTown = data.ANA_TOWN_ID;

        this.foodseleted = data;

        var temp_array = Object.values(
          data.REAL_VALUE.reduce(
            (acc, { ANA_TOWN_ID, CREATETIME, REAL_VALUE }) => {
              const key = ANA_TOWN_ID;
              acc[key] = acc[key] || {
                ANA_TOWN_ID,
                CREATETIME: [],
                REAL_VALUE: [],
              };
              acc[key].CREATETIME.push(CREATETIME);
              acc[key].REAL_VALUE.push(REAL_VALUE);
              return acc;
            },
            {}
          )
        );

        if (data.Note == "3" || data.Note == "4" || data.Note == "5") {
          let temp = [];
          for (var index in temp_array) {
            let item = temp_array[index];
            temp[item.ANA_TOWN_ID] = item;
          }
          this.warningValueList_345 = temp;
        }

        this.legendShow = true;
        this.isFoodItemSelected = !this.firstClick;

        this.FunctionToken(this.getAllCityArea, {
          town: data.ANA_TOWN_ID,
          crop: data.C_NAME,
          year: data.A_YEAR,
          period: data.A_PERIOD,
        });
      }
    },
    /*
    <summary>
    取得城市在地圖上顯示的範圍
    </summary>
    */
    getCityArea(data) {
      this.apiGetCityArea(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.cityHeight = jsonData.HEIGHT_AREA;
            let lists = jsonData.SCOURGE_AREA_LIST.filter(
              (item) => item.AREA_P > 0.1
            );
            //console.log(["getCityArea",lists])
            let temp = [];
            for (var index in lists) {
              let item = lists[index];
              temp[item.ANA_TOWN_ID] = item.AREA_P;
            }
            this.AREA_PList = temp;
            this.AREA_P = this.AREA_PList[this.AREA_P_ID];
            //console.log(["getCityArea",this.AREA_PList,this.AREA_P])
            this.map.removeLayer(this.warningMap);
            this.warningMap = {};
            this.warningMap = new VectorLayer({
              // 雲林行政區
              id: "warning",
              visible: !this.firstClick,
              source: new VectorSource({
                url: "GeoJSON/chayi_3857.geojson",
                format: new GeoJSON(),
              }),
              style: this.styleWarning,
            });
            this.warningMap.set("name", "warning");
            this.map.addLayer(this.warningMap);
            this.firstClick = false;
            this.warningMap.setVisible(true);
            this.isFoodItemSelected = true;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getAllCityArea(data) {
      this.apiGetCityAreaTaiwan(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.cityHeight = jsonData.HEIGHT_AREA;
            let lists = jsonData.SCOURGE_AREA_LIST.filter(
              (item) => item.AREA_P > 0.1
            );
            let temp = [];
            for (var index in lists) {
              let item = lists[index];
              temp[item.ANA_TOWN_ID] = item.AREA_P;
            }
            this.AREA_PList = temp;
            this.AREA_P = this.AREA_PList[this.AREA_P_ID];
            this.map.removeLayer(this.warningMap);
            this.warningMap = {};
            this.warningMap = new VectorLayer({
              // 全台
              id: "warning",
              visible: !this.firstClick,
              source: new VectorSource({
                url: "GeoJSON/taiwan.geojson",
                format: new GeoJSON(),
              }),
              style: this.styleWarning,
            });
            this.warningMap.set("name", "warning");
            this.map.addLayer(this.warningMap);
            this.firstClick = false;
            this.warningMap.setVisible(true);
            this.isFoodItemSelected = true;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    regetCityArea(yearSelected, periodSelected) {
      this.FunctionToken(this.getCityArea, {
        town: this.foodseleted.ANA_TOWN_ID,
        crop: this.foodseleted.C_NAME,
        year: yearSelected,
        period: periodSelected,
      });
    },
    /*    <summary>
        關閉預警視窗
        </summary>
         */
    closeWindow() {
      this.isFoodItemSelected = false;
      this.map.removeLayer(this.warningMap);
      this.selected = "";
      this.AREA_P_ID = "";
      this.warningTownName = "";
      this.warningValueList = "";
      this.cityHeight = "";
    },
    closeChartWindow() {
      let item = this.cropArea.CITY_AREA;
      let index = this.addAreaLayer.findIndex(
        (x) =>
          x.crop == item.CROP &&
          x.period == item.PERIOD &&
          x.year == item.A_YEAR
      );
      if (index != -1) {
        this.cropInfoShow = false;
        this.removeItem(index);
      }
      this.addAreaLaye=[];
      this.addAreaLayerAll=[];
      this.radioLists=[];
      this.cropInfoShow = false;
      this.map.removeLayer(this.cropMapAll);
      this.geoselectionlist = [];
      this.geoselect = [];
      this.ifGeoSelection = false;
      this.rodisValue = "";
    },
    //關閉農情作物
    closeCropWindow() {
      this.cropInfo3.ifCropShow = false;
      this.cropInfo.townName = "";
      this.cropInfo.sectorName = "";
      this.cropInfo.area_P = "";
      this.cropInfo.area_I = "";
      this.cropInfo.area_O = "";
      this.cropInfo.area_NH = "";
      this.map.removeLayer(this.germCYmap);
      this.germCYMap = {};
      this.cropsectorlist = [];
      this.townsectlist=[];
      this.ifgermshow = false;
      this.rodisValue = "";
      this.ifGeoSelection = false;
      this.cropMapAll=[];
      this.radioLists=[];
      this.addAreaLayerAll=[];
      this.addCYAreaLayer=[];
      this.cropInfoShow = false;
    },
    //關閉大區坵塊視窗
    closeSectWindow(){
      this.SectInfo.ifSectShow =false;
      this.map.removeLayer(this.SectCheckMap);
      this.ifgermshow = false;
      this.SectCheck = false;
    },
    //關閉小區坵塊視窗
    closeSectSubWindow(){
      this.map.removeLayer(this.SectSubCheckMap);
      this.SectSubInfo.ifSectSubShow = false;
      this.ifgermshow = false;
      this.SectSubCheck = false;
    },
    checkMomth(val) {
      let name = "霪雨";
      var d = new Date();
      var nowMonth = d.getMonth() + 1;
      if (nowMonth == 5 || nowMonth == 6) {
        name = "梅雨";
      }
      if(val == 0) name = "注意"+name;
      else if(val == 1) name += "警戒";
      return name;
    },
    /*    <summary>
    價量預警列表
    </summary>
      */
    TradeWarning(data) {
      this.apiTradeWarning(data).then((res) => {
        const json = JSON.parse(res.data);
        if (json.Status) {
          const jsonData = JSON.parse(json.Data);
          this.tradeWarningList = jsonData;
          let temp = [];
          for (var i = 0; i < jsonData.length; i++) {
            temp.push({
              text: jsonData[i][0]["TW_NAME"],
              value: jsonData[i][0]["TW_NAME"],
            });
          }
          this.tradeWarningOptions = temp;
        }
      });
    },
    /*     <summary>
    呼叫getCropArea function
    </summary>
      */
    tradeWarningChange() {
      this.FunctionToken(this.getCropAreaListWarning, {
        crop: this.tradeWarningSelected,
      });
    },
    /*     <summary>
        取得農作物種植範圍
        </summary>
         */
    getCropAreaListWarning(data) {
      this.apiCropAreaListWarning(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.tradeWarningArea = jsonData;
            this.tradeWarningAreaSelected = [];
            this.tradeWarningAreaValue = [];
            for (var index in jsonData.BA_AGRI_SURVEY) {
              let item = jsonData.BA_AGRI_SURVEY[index];
              this.tradeWarningAreaSelected.push(item.ANA_TOWN_ID);
              this.tradeWarningAreaValue[item.ANA_TOWN_ID] = item;
            }
            this.map.removeLayer(this.tradeWarningMap);
            this.tradeWarningMap = {};
            this.tradeWarningMap = new VectorLayer({
              // 雲林行政區
              visible: true,
              source: new VectorSource({
                url: "GeoJSON/chayi_3857.geojson",
                format: new GeoJSON(),
              }),
              //style: this.styleTradingWarning,
            });
            this.tradeWarningMap.set("name", "tradeWarning");
            this.map.addLayer(this.tradeWarningMap);
            this.tradeWarningInfo = {
              townName: "",
              year: "",
              period: "",
            };

            this.tradeWarningInfo.townName = "嘉義縣";
            this.tradeWarningInfo.AREA_H = jsonData.CITY_AREA.AREA_H;
            this.tradeWarningInfo.AREA_P = jsonData.CITY_AREA.AREA_P;
            this.tradeWarningInfo.RATE_H = jsonData.CITY_AREA.RATE_H;
            this.tradeWarningInfo.HARVEST = jsonData.CITY_AREA.HARVEST;

            this.tradeWarningInfo.year = this.yearSelected;
            this.tradeWarningInfo.period = this.periodSelected;
            this.tradeWarningInfo.crop = this.tradeWarningSelected;
            this.tradeWarningShow = true;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    countryNameParse(list) {
      let countrylist = [];
      for (let i in list) {
        let subitem = list[i];
        countrylist.push(subitem.split(",")[0]);
      }
      return countrylist.join(",");
    },
    togetCyhgAgriTown(data){
      this.apiGetCyhgAgriTown(data)
        .then((res) =>{
          const json = JSON.parse(res.data);
          //console.log("CyhgAgriTown:",json);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            //console.log("CyhgAgriTown:",jsonData);
            for(var index in jsonData){
              this.cyhgagritown[jsonData[index].TOWN_ID] = jsonData[index].TOWN_NAME;
            }
          }
        })
    }
  },
};
</script>
<style scoped>
#map {
  height: 100vh;
}

.submenu {
  height: 100%;
}

.submenu h2.subtitle {
  margin: -1.2rem -1.2rem 1rem -1.2rem;
  padding: 0.5rem 0;
  font-size: 1.5rem;
  color: #fff;
  font-weight: bolder;
  text-align: center;
  background-color: #4f8321;
  box-shadow: 0px 2px 6px 3px #cccccc;
}

@media (max-width: 1024px) {
}
/* 
@media (min-width: 1025px){
  .gis-tab {
    width: 30vh;
  }
} */

.submenuBtn {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  position: absolute;
  opacity: 0.8;
  right: 1rem;
  top: 1rem;
  z-index: 1004;
}

.legend {
  position: absolute;
  right: 1rem;
  bottom: 1rem;
  z-index: 1002;
  -webkit-box-align: baseline;
  -webkit-align-items: baseline;
  -ms-flex-align: baseline;
  align-items: baseline;
  background-color: rgba(2552, 255, 255, 0.8);
  padding-bottom: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border-radius: 4px;
  -webkit-box-shadow: 0 12px 12px rgba(10, 10, 10, 0.15);
  box-shadow: 0 12px 12px rgba(10, 10, 10, 0.15);
}

@media screen and (max-width: 974px) {
  .legend {
    bottom: 4rem;
  }
}

.legend .unit {
  border-right: 1px dotted #8a8a8a;
  padding: 1rem;
  height: 38vh;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  -ms-flex-align: end;
  align-items: flex-end;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  /* width: 120px; */
}
.legend .unit div {
  text-align: right;
  font-size: 80%;
  line-height: 1;
}
.legend .unit div span.color {
  display: inline-block;
  width: 20px;
  vertical-align: bottom;
  position: relative;
  margin-left: 5px;
}
.legend .unit .info {
  width: max-content !important;
  font-size: 80%;
  border-bottom: 1px solid #ccc;
  text-align: right;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  line-height: 1rem;
}
.legend .cell:last-child .unit {
  border-right: none;
}

.legend h4,
.h4 {
  text-align: center;
  font-weight: bolder;
  font-size: 1.1rem;
}

.planting-ratio-info.green span {
  height: 20px;
}
.planting-ratio-info.green span.Level-1 {
  background-color: rgba(29, 151, 108, 0.9);
}
.planting-ratio-info.green span.Level-2 {
  background-color: rgba(29, 151, 108, 0.7);
}
.planting-ratio-info.green span.Level-3 {
  background-color: rgba(29, 151, 108, 0.6);
}
.planting-ratio-info.green span.Level-4 {
  background-color: rgba(29, 151, 108, 0.4);
}
.planting-ratio-info.green span.Level-5 {
  background-color: rgba(29, 151, 108, 0.2);
}

.planting-ratio-info.red span {
  height: 20px;
}
.planting-ratio-info.red span.Level-1 {
  background-color: rgba(234, 56, 77, 0.9);
}
.planting-ratio-info.red span.Level-2 {
  background-color: rgba(234, 56, 77, 0.7);
}
.planting-ratio-info.red span.Level-3 {
  background-color: rgba(234, 56, 77, 0.6);
}
.planting-ratio-info.red span.Level-4 {
  background-color: rgba(234, 56, 77, 0.4);
}
.planting-ratio-info.red span.Level-5 {
  background-color: rgba(234, 56, 77, 0.2);
}

.planting-ratio-info.yellow span {
  height: 20px;
}
.planting-ratio-info.yellow span.Level-1 {
  background-color: rgba(255, 153, 0, 0.9);
}
.planting-ratio-info.yellow span.Level-2 {
  background-color: rgba(255, 153, 0, 0.7);
}
.planting-ratio-info.yellow span.Level-3 {
  background-color: rgba(255, 153, 0, 0.6);
}
.planting-ratio-info.yellow span.Level-4 {
  background-color: rgba(255, 153, 0, 0.4);
}
.planting-ratio-info.yellow span.Level-5 {
  background-color: rgba(255, 153, 0, 0.2);
}

.planting-ratio-info.blue span {
  height: 20px;
}
.planting-ratio-info.blue span.Level-1 {
  background-color: rgba(63, 140, 181, 0.9);
}
.planting-ratio-info.blue span.Level-2 {
  background-color: rgba(63, 140, 181, 0.7);
}
.planting-ratio-info.blue span.Level-3 {
  background-color: rgba(63, 140, 181, 0.6);
}
.planting-ratio-info.blue span.Level-4 {
  background-color: rgba(63, 140, 181, 0.4);
}
.planting-ratio-info.blue span.Level-5 {
  background-color: rgba(63, 140, 181, 0.2);
}

.planting-ratio-info.orange span {
  height: 20px;
}
.planting-ratio-info.orange span.Level-1 {
  background-color: rgba(255, 152, 0, 0.9);
}
.planting-ratio-info.orange span.Level-2 {
  background-color: rgba(255, 152, 0, 0.7);
}
.planting-ratio-info.orange span.Level-3 {
  background-color: rgba(255, 152, 0, 0.6);
}
.planting-ratio-info.orange span.Level-4 {
  background-color: rgba(255, 152, 0, 0.4);
}
.planting-ratio-info.orange span.Level-5 {
  background-color: rgba(255, 152, 0, 0.2);
}

.gis-rainfall div {
  height: 5%;
}

.gis-rainfall span {
  height: 100%;
}
.gis-rainfall span.Level-1 {
  background-color: #cacaca;
}
.gis-rainfall span.Level-2 {
  background-color: #9efdff;
}
.gis-rainfall span.Level-3 {
  background-color: #01d2fd;
}
.gis-rainfall span.Level-4 {
  background-color: #00a5fe;
}
.gis-rainfall span.Level-5 {
  background-color: #0177fd;
}
.gis-rainfall span.Level-6 {
  background-color: #27a41c;
}
.gis-rainfall span.Level-7 {
  background-color: #01f92f;
}
.gis-rainfall span.Level-8 {
  background-color: #ffff33;
}
.gis-rainfall span.Level-9 {
  background-color: #fed428;
}
.gis-rainfall span.Level-10 {
  background-color: #ffa71f;
}
.gis-rainfall span.Level-11 {
  background-color: #ff2a08;
}
.gis-rainfall span.Level-12 {
  background-color: #da2303;
}
.gis-rainfall span.Level-13 {
  background-color: #aa1801;
}
.gis-rainfall span.Level-14 {
  background-color: #ac20a3;
}
.gis-rainfall span.Level-15 {
  background-color: #db2cd1;
}
.gis-rainfall span.Level-16 {
  background-color: #fd38fa;
}
.gis-rainfall span.Level-17 {
  background-color: #ffd4fd;
}

.gis-echo div {
  height: 5%;
}

.gis-echo span {
  height: 100%;
}
.gis-echo span.echo--5 {
  background-color: #a564d8;
}
.gis-echo span.echo-0 {
  background-color: #bc9ad7;
}
.gis-echo span.echo-5 {
  background-color: #9a9a9a;
}
.gis-echo span.echo-10 {
  background-color: #757575;
}
.gis-echo span.echo-15 {
  background-color: #eaa8a9;
}
.gis-echo span.echo-20 {
  background-color: #d68a8c;
}
.gis-echo span.echo-25 {
  background-color: #b46e6e;
}
.gis-echo span.echo-30 {
  background-color: #8ffb95;
}
.gis-echo span.echo-35 {
  background-color: #68ba2a;
}
.gis-echo span.echo-40 {
  background-color: #fefe78;
}
.gis-echo span.echo-45 {
  background-color: #ced06b;
}
.gis-echo span.echo-50 {
  background-color: #df6057;
}
.gis-echo span.echo-55 {
  background-color: #b90000;
}
.gis-echo span.echo-60 {
  background-color: #940000;
}
.gis-echo span.echo-65 {
  background-color: #0000f9;
}
.gis-echo span.echo-70 {
  background-color: #ffffff;
}
.gis-echo span.echo-75 {
  background-color: #c700f9;
}
.m-125 {
  min-width: 125px;
}

.warninglabel {
  font-weight: bold;
  font-size: 25px;
}

.warninglist {
  /* border-style: outset; */
  border-radius: 5.5rem;
  margin-bottom: 1rem;
}

.warningReminderClass {
  margin-bottom: 0.5rem;
  color: blue;
}

.ear-125 {
  max-width: 250px;
}
.ear-125 span {
  line-height: 0;
}
.ear-info {
  margin-top:0.5rem;
  font-size: 1.3rem;
  font-weight: 800;
}

.second-degree{
  color: #007bff;
}

.loading{
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: gray;
  z-index: 1045;
  opacity: 0.5;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
}
</style>
